export interface Store {
  id: number
  name: string
  lat: number
  lng: number
  score: number
  status: string
  type: string
  address: string
}

export const stores: Store[] = [
  {
    id: 1,
    name: "Lidl Express Hamburg-Hafencity",
    lat: 53.5511,
    lng: 9.9937,
    score: 4.4,
    status: "success",
    type: "Lidl Express",
    address: "Hamburg, Hafencity",
  },
  {
    id: 2,
    name: "Lidl Hamburg-Altona",
    lat: 53.5511,
    lng: 9.9937,
    score: 4.8,
    status: "success",
    type: "Lidl",
    address: "Hamburg, Altona",
  },
  {
    id: 3,
    name: "Lidl Hamburg-Wandsbek",
    lat: 53.5511,
    lng: 9.9937,
    score: 3.1,
    status: "danger",
    type: "Lidl",
    address: "Hamburg, Wandsbek",
  },
  {
    id: 4,
    name: "Lidl Hamburg-Bergedorf",
    lat: 53.5511,
    lng: 9.9937,
    score: 4.5,
    status: "success",
    type: "Lidl",
    address: "Hamburg, Bergedorf",
  },
  {
    id: 5,
    name: "Lidl Hamburg-Harburg",
    lat: 53.5511,
    lng: 9.9937,
    score: 4.1,
    status: "warning",
    type: "Lidl",
    address: "Hamburg, Harburg",
  },
  {
    id: 6,
    name: "Lidl Express Hamburg-Eimsbüttel",
    lat: 53.5511,
    lng: 9.9937,
    score: 2.7,
    status: "danger",
    type: "Lidl Express",
    address: "Hamburg, Eimsbüttel",
  },
  {
    id: 7,
    name: "Lidl Express Hamburg-Barmbek",
    lat: 53.5511,
    lng: 9.9937,
    score: 4.7,
    status: "success",
    type: "Lidl Express",
    address: "Hamburg, Barmbek",
  },
  {
    id: 8,
    name: "Lidl Express Hamburg-Billstedt",
    lat: 53.5511,
    lng: 9.9937,
    score: 4.1,
    status: "warning",
    type: "Lidl Express",
    address: "Hamburg, Billstedt",
  },
  {
    id: 9,
    name: "Lidl Express Hamburg-Bramfeld",
    lat: 53.5511,
    lng: 9.9937,
    score: 4.3,
    status: "success",
    type: "Lidl Express",
    address: "Hamburg, Bramfeld",
  },
  {
    id: 10,
    name: "Lidl Hamburg-St. Pauli",
    lat: 53.5511,
    lng: 9.9937,
    score: 3.1,
    status: "danger",
    type: "Lidl",
    address: "Hamburg, St. Pauli",
  },
  {
    id: 11,
    name: "Lidl XL Hamburg-Ottensen",
    lat: 53.5511,
    lng: 9.9937,
    score: 4.9,
    status: "success",
    type: "Lidl XL",
    address: "Hamburg, Ottensen",
  },
  {
    id: 12,
    name: "Lidl Express Hamburg-Winterhude",
    lat: 53.5511,
    lng: 9.9937,
    score: 3.8,
    status: "warning",
    type: "Lidl Express",
    address: "Hamburg, Winterhude",
  },
  {
    id: 13,
    name: "Lidl Express Hamburg-Lokstedt",
    lat: 53.5511,
    lng: 9.9937,
    score: 4.8,
    status: "success",
    type: "Lidl Express",
    address: "Hamburg, Lokstedt",
  },
  {
    id: 14,
    name: "Lidl Express Hamburg-Schnelsen",
    lat: 53.5511,
    lng: 9.9937,
    score: 4.6,
    status: "success",
    type: "Lidl Express",
    address: "Hamburg, Schnelsen",
  },
  {
    id: 15,
    name: "Lidl Express Kiel-Innenstadt",
    lat: 54.3233,
    lng: 10.1228,
    score: 4.6,
    status: "success",
    type: "Lidl Express",
    address: "Kiel, Innenstadt",
  },
  {
    id: 16,
    name: "Lidl Kiel-Gaarden",
    lat: 54.3233,
    lng: 10.1228,
    score: 3.9,
    status: "warning",
    type: "Lidl",
    address: "Kiel, Gaarden",
  },
  {
    id: 17,
    name: "Lidl Express Kiel-Mettenhof",
    lat: 54.3233,
    lng: 10.1228,
    score: 4.3,
    status: "success",
    type: "Lidl Express",
    address: "Kiel, Mettenhof",
  },
  {
    id: 18,
    name: "Lidl Express Kiel-Elmschenhagen",
    lat: 54.3233,
    lng: 10.1228,
    score: 2.8,
    status: "danger",
    type: "Lidl Express",
    address: "Kiel, Elmschenhagen",
  },
  {
    id: 19,
    name: "Lidl Express Kiel-Suchsdorf",
    lat: 54.3233,
    lng: 10.1228,
    score: 4.2,
    status: "warning",
    type: "Lidl Express",
    address: "Kiel, Suchsdorf",
  },
  {
    id: 20,
    name: "Lidl Lübeck-Altstadt",
    lat: 53.8655,
    lng: 10.6866,
    score: 2.6,
    status: "danger",
    type: "Lidl",
    address: "Lübeck, Altstadt",
  },
  {
    id: 21,
    name: "Lidl Express Lübeck-St. Lorenz",
    lat: 53.8655,
    lng: 10.6866,
    score: 3.8,
    status: "warning",
    type: "Lidl Express",
    address: "Lübeck, St. Lorenz",
  },
  {
    id: 22,
    name: "Lidl Express Lübeck-Kücknitz",
    lat: 53.8655,
    lng: 10.6866,
    score: 4.6,
    status: "success",
    type: "Lidl Express",
    address: "Lübeck, Kücknitz",
  },
  {
    id: 23,
    name: "Lidl Lübeck-Travemünde",
    lat: 53.8655,
    lng: 10.6866,
    score: 3.6,
    status: "warning",
    type: "Lidl",
    address: "Lübeck, Travemünde",
  },
  {
    id: 24,
    name: "Lidl Express Lübeck-Moisling",
    lat: 53.8655,
    lng: 10.6866,
    score: 3.9,
    status: "warning",
    type: "Lidl Express",
    address: "Lübeck, Moisling",
  },
  {
    id: 25,
    name: "Lidl Bremen-Mitte",
    lat: 53.0793,
    lng: 8.8017,
    score: 3.1,
    status: "danger",
    type: "Lidl",
    address: "Bremen, Mitte",
  },
  {
    id: 26,
    name: "Lidl Express Bremen-Vegesack",
    lat: 53.0793,
    lng: 8.8017,
    score: 4.6,
    status: "success",
    type: "Lidl Express",
    address: "Bremen, Vegesack",
  },
  {
    id: 27,
    name: "Lidl Bremen-Blumenthal",
    lat: 53.0793,
    lng: 8.8017,
    score: 3.3,
    status: "danger",
    type: "Lidl",
    address: "Bremen, Blumenthal",
  },
  {
    id: 28,
    name: "Lidl Express Bremen-Huchting",
    lat: 53.0793,
    lng: 8.8017,
    score: 4.7,
    status: "success",
    type: "Lidl Express",
    address: "Bremen, Huchting",
  },
  {
    id: 29,
    name: "Lidl XL Bremen-Oberneuland",
    lat: 53.0793,
    lng: 8.8017,
    score: 4.3,
    status: "success",
    type: "Lidl XL",
    address: "Bremen, Oberneuland",
  },
  {
    id: 30,
    name: "Lidl Express Bremen-Hemelingen",
    lat: 53.0793,
    lng: 8.8017,
    score: 3.6,
    status: "warning",
    type: "Lidl Express",
    address: "Bremen, Hemelingen",
  },
  {
    id: 31,
    name: "Lidl XL Bremen-Walle",
    lat: 53.0793,
    lng: 8.8017,
    score: 3.4,
    status: "warning",
    type: "Lidl XL",
    address: "Bremen, Walle",
  },
  {
    id: 32,
    name: "Lidl Bremen-Gröpelingen",
    lat: 53.0793,
    lng: 8.8017,
    score: 3.6,
    status: "warning",
    type: "Lidl",
    address: "Bremen, Gröpelingen",
  },
  {
    id: 33,
    name: "Lidl XL Oldenburg-Zentrum",
    lat: 53.1435,
    lng: 8.2146,
    score: 3.9,
    status: "warning",
    type: "Lidl XL",
    address: "Oldenburg, Zentrum",
  },
  {
    id: 34,
    name: "Lidl XL Oldenburg-Eversten",
    lat: 53.1435,
    lng: 8.2146,
    score: 3.3,
    status: "danger",
    type: "Lidl XL",
    address: "Oldenburg, Eversten",
  },
  {
    id: 35,
    name: "Lidl Oldenburg-Ofenerdiek",
    lat: 53.1435,
    lng: 8.2146,
    score: 3.8,
    status: "warning",
    type: "Lidl",
    address: "Oldenburg, Ofenerdiek",
  },
  {
    id: 36,
    name: "Lidl Oldenburg-Kreyenbrück",
    lat: 53.1435,
    lng: 8.2146,
    score: 4.4,
    status: "success",
    type: "Lidl",
    address: "Oldenburg, Kreyenbrück",
  },
  {
    id: 37,
    name: "Lidl XL Rostock-Stadtmitte",
    lat: 54.0924,
    lng: 12.0991,
    score: 4,
    status: "warning",
    type: "Lidl XL",
    address: "Rostock, Stadtmitte",
  },
  {
    id: 38,
    name: "Lidl XL Rostock-Lütten Klein",
    lat: 54.0924,
    lng: 12.0991,
    score: 2.9,
    status: "danger",
    type: "Lidl XL",
    address: "Rostock, Lütten Klein",
  },
  {
    id: 39,
    name: "Lidl Rostock-Dierkow",
    lat: 54.0924,
    lng: 12.0991,
    score: 3.7,
    status: "warning",
    type: "Lidl",
    address: "Rostock, Dierkow",
  },
  {
    id: 40,
    name: "Lidl XL Rostock-Evershagen",
    lat: 54.0924,
    lng: 12.0991,
    score: 2.8,
    status: "danger",
    type: "Lidl XL",
    address: "Rostock, Evershagen",
  },
  {
    id: 41,
    name: "Lidl Rostock-Reutershagen",
    lat: 54.0924,
    lng: 12.0991,
    score: 3.7,
    status: "warning",
    type: "Lidl",
    address: "Rostock, Reutershagen",
  },
  {
    id: 42,
    name: "Lidl XL Rostock-Warnemünde",
    lat: 54.0924,
    lng: 12.0991,
    score: 4.4,
    status: "success",
    type: "Lidl XL",
    address: "Rostock, Warnemünde",
  },
  {
    id: 43,
    name: "Lidl Express Berlin-Mitte",
    lat: 52.52,
    lng: 13.405,
    score: 3.4,
    status: "warning",
    type: "Lidl Express",
    address: "Berlin, Mitte",
  },
  {
    id: 44,
    name: "Lidl Berlin-Kreuzberg",
    lat: 52.52,
    lng: 13.405,
    score: 3.5,
    status: "warning",
    type: "Lidl",
    address: "Berlin, Kreuzberg",
  },
  {
    id: 45,
    name: "Lidl Express Berlin-Prenzlauer Berg",
    lat: 52.52,
    lng: 13.405,
    score: 4.2,
    status: "warning",
    type: "Lidl Express",
    address: "Berlin, Prenzlauer Berg",
  },
  {
    id: 46,
    name: "Lidl XL Berlin-Charlottenburg",
    lat: 52.52,
    lng: 13.405,
    score: 3.3,
    status: "danger",
    type: "Lidl XL",
    address: "Berlin, Charlottenburg",
  },
  {
    id: 47,
    name: "Lidl Express Berlin-Spandau",
    lat: 52.52,
    lng: 13.405,
    score: 3.9,
    status: "warning",
    type: "Lidl Express",
    address: "Berlin, Spandau",
  },
  {
    id: 48,
    name: "Lidl Express Berlin-Steglitz",
    lat: 52.52,
    lng: 13.405,
    score: 3.8,
    status: "warning",
    type: "Lidl Express",
    address: "Berlin, Steglitz",
  },
  {
    id: 49,
    name: "Lidl Express Berlin-Pankow",
    lat: 52.52,
    lng: 13.405,
    score: 2.8,
    status: "danger",
    type: "Lidl Express",
    address: "Berlin, Pankow",
  },
  {
    id: 50,
    name: "Lidl Berlin-Neukölln",
    lat: 52.52,
    lng: 13.405,
    score: 3,
    status: "danger",
    type: "Lidl",
    address: "Berlin, Neukölln",
  },
  {
    id: 51,
    name: "Lidl Berlin-Friedrichshain",
    lat: 52.52,
    lng: 13.405,
    score: 2.7,
    status: "danger",
    type: "Lidl",
    address: "Berlin, Friedrichshain",
  },
  {
    id: 52,
    name: "Lidl Berlin-Wedding",
    lat: 52.52,
    lng: 13.405,
    score: 4,
    status: "warning",
    type: "Lidl",
    address: "Berlin, Wedding",
  },
  {
    id: 53,
    name: "Lidl Berlin-Tempelhof",
    lat: 52.52,
    lng: 13.405,
    score: 3.9,
    status: "warning",
    type: "Lidl",
    address: "Berlin, Tempelhof",
  },
  {
    id: 54,
    name: "Lidl XL Berlin-Lichtenberg",
    lat: 52.52,
    lng: 13.405,
    score: 4.7,
    status: "success",
    type: "Lidl XL",
    address: "Berlin, Lichtenberg",
  },
  {
    id: 55,
    name: "Lidl Berlin-Reinickendorf",
    lat: 52.52,
    lng: 13.405,
    score: 3.8,
    status: "warning",
    type: "Lidl",
    address: "Berlin, Reinickendorf",
  },
  {
    id: 56,
    name: "Lidl Express Berlin-Marzahn",
    lat: 52.52,
    lng: 13.405,
    score: 3.1,
    status: "danger",
    type: "Lidl Express",
    address: "Berlin, Marzahn",
  },
  {
    id: 57,
    name: "Lidl Express Berlin-Treptow",
    lat: 52.52,
    lng: 13.405,
    score: 3,
    status: "danger",
    type: "Lidl Express",
    address: "Berlin, Treptow",
  },
  {
    id: 58,
    name: "Lidl XL Potsdam-Innenstadt",
    lat: 52.3906,
    lng: 13.0645,
    score: 3.1,
    status: "danger",
    type: "Lidl XL",
    address: "Potsdam, Innenstadt",
  },
  {
    id: 59,
    name: "Lidl Express Potsdam-Babelsberg",
    lat: 52.3906,
    lng: 13.0645,
    score: 3.6,
    status: "warning",
    type: "Lidl Express",
    address: "Potsdam, Babelsberg",
  },
  {
    id: 60,
    name: "Lidl Potsdam-Drewitz",
    lat: 52.3906,
    lng: 13.0645,
    score: 3.6,
    status: "warning",
    type: "Lidl",
    address: "Potsdam, Drewitz",
  },
  {
    id: 61,
    name: "Lidl Express Potsdam-Stern",
    lat: 52.3906,
    lng: 13.0645,
    score: 3.2,
    status: "danger",
    type: "Lidl Express",
    address: "Potsdam, Stern",
  },
  {
    id: 62,
    name: "Lidl XL Potsdam-Waldstadt",
    lat: 52.3906,
    lng: 13.0645,
    score: 3.4,
    status: "warning",
    type: "Lidl XL",
    address: "Potsdam, Waldstadt",
  },
  {
    id: 63,
    name: "Lidl Köln-Ehrenfeld",
    lat: 50.9375,
    lng: 6.9203,
    score: 2.6,
    status: "danger",
    type: "Lidl",
    address: "Köln, Ehrenfeld",
  },
  {
    id: 64,
    name: "Lidl XL Köln-Deutz",
    lat: 50.9375,
    lng: 6.9203,
    score: 5,
    status: "success",
    type: "Lidl XL",
    address: "Köln, Deutz",
  },
  {
    id: 65,
    name: "Lidl Köln-Nippes",
    lat: 50.9375,
    lng: 6.9203,
    score: 2.9,
    status: "danger",
    type: "Lidl",
    address: "Köln, Nippes",
  },
  {
    id: 66,
    name: "Lidl Express Köln-Porz",
    lat: 50.9375,
    lng: 6.9203,
    score: 4.3,
    status: "success",
    type: "Lidl Express",
    address: "Köln, Porz",
  },
  {
    id: 67,
    name: "Lidl Express Köln-Lindenthal",
    lat: 50.9375,
    lng: 6.9203,
    score: 4.7,
    status: "success",
    type: "Lidl Express",
    address: "Köln, Lindenthal",
  },
  {
    id: 68,
    name: "Lidl Köln-Chorweiler",
    lat: 50.9375,
    lng: 6.9203,
    score: 4.6,
    status: "success",
    type: "Lidl",
    address: "Köln, Chorweiler",
  },
  {
    id: 69,
    name: "Lidl Express Köln-Kalk",
    lat: 50.9375,
    lng: 6.9203,
    score: 2.6,
    status: "danger",
    type: "Lidl Express",
    address: "Köln, Kalk",
  },
  {
    id: 70,
    name: "Lidl XL Düsseldorf-Bilk",
    lat: 51.2077,
    lng: 6.7735,
    score: 4.9,
    status: "success",
    type: "Lidl XL",
    address: "Düsseldorf, Bilk",
  },
  {
    id: 71,
    name: "Lidl Express Düsseldorf-Oberkassel",
    lat: 51.2077,
    lng: 6.7735,
    score: 3.9,
    status: "warning",
    type: "Lidl Express",
    address: "Düsseldorf, Oberkassel",
  },
  {
    id: 72,
    name: "Lidl Express Düsseldorf-Flingern",
    lat: 51.2077,
    lng: 6.7735,
    score: 4.8,
    status: "success",
    type: "Lidl Express",
    address: "Düsseldorf, Flingern",
  },
  {
    id: 73,
    name: "Lidl Düsseldorf-Benrath",
    lat: 51.2077,
    lng: 6.7735,
    score: 4.5,
    status: "success",
    type: "Lidl",
    address: "Düsseldorf, Benrath",
  },
  {
    id: 74,
    name: "Lidl Express Düsseldorf-Gerresheim",
    lat: 51.2077,
    lng: 6.7735,
    score: 3.8,
    status: "warning",
    type: "Lidl Express",
    address: "Düsseldorf, Gerresheim",
  },
  {
    id: 75,
    name: "Lidl Düsseldorf-Unterbach",
    lat: 51.2077,
    lng: 6.7735,
    score: 3.7,
    status: "warning",
    type: "Lidl",
    address: "Düsseldorf, Unterbach",
  },
  {
    id: 76,
    name: "Lidl XL Essen-Rüttenscheid",
    lat: 51.4356,
    lng: 7.0016,
    score: 3.9,
    status: "warning",
    type: "Lidl XL",
    address: "Essen, Rüttenscheid",
  },
  {
    id: 77,
    name: "Lidl Express Essen-Werden",
    lat: 51.4356,
    lng: 7.0016,
    score: 3.5,
    status: "warning",
    type: "Lidl Express",
    address: "Essen, Werden",
  },
  {
    id: 78,
    name: "Lidl XL Essen-Steele",
    lat: 51.4356,
    lng: 7.0016,
    score: 2.8,
    status: "danger",
    type: "Lidl XL",
    address: "Essen, Steele",
  },
  {
    id: 79,
    name: "Lidl Essen-Kettwig",
    lat: 51.4356,
    lng: 7.0016,
    score: 4.6,
    status: "success",
    type: "Lidl",
    address: "Essen, Kettwig",
  },
  {
    id: 80,
    name: "Lidl Essen-Borbeck",
    lat: 51.4356,
    lng: 7.0016,
    score: 3.3,
    status: "danger",
    type: "Lidl",
    address: "Essen, Borbeck",
  },
  {
    id: 81,
    name: "Lidl Express Essen-Altenessen",
    lat: 51.4356,
    lng: 7.0016,
    score: 3.4,
    status: "warning",
    type: "Lidl Express",
    address: "Essen, Altenessen",
  },
  {
    id: 82,
    name: "Lidl Express Essen-Frohnhausen",
    lat: 51.4356,
    lng: 7.0016,
    score: 3.9,
    status: "warning",
    type: "Lidl Express",
    address: "Essen, Frohnhausen",
  },
  {
    id: 83,
    name: "Lidl Express Dortmund-Innenstadt",
    lat: 51.5136,
    lng: 7.4653,
    score: 4.1,
    status: "warning",
    type: "Lidl Express",
    address: "Dortmund, Innenstadt",
  },
  {
    id: 84,
    name: "Lidl Express Dortmund-Hörde",
    lat: 51.5136,
    lng: 7.4653,
    score: 4,
    status: "warning",
    type: "Lidl Express",
    address: "Dortmund, Hörde",
  },
  {
    id: 85,
    name: "Lidl Express Dortmund-Brackel",
    lat: 51.5136,
    lng: 7.4653,
    score: 4,
    status: "warning",
    type: "Lidl Express",
    address: "Dortmund, Brackel",
  },
  {
    id: 86,
    name: "Lidl Express Dortmund-Hombruch",
    lat: 51.5136,
    lng: 7.4653,
    score: 4.5,
    status: "success",
    type: "Lidl Express",
    address: "Dortmund, Hombruch",
  },
  {
    id: 87,
    name: "Lidl Express Dortmund-Lütgendortmund",
    lat: 51.5136,
    lng: 7.4653,
    score: 4.8,
    status: "success",
    type: "Lidl Express",
    address: "Dortmund, Lütgendortmund",
  },
  {
    id: 88,
    name: "Lidl XL Dortmund-Mengede",
    lat: 51.5136,
    lng: 7.4653,
    score: 3.7,
    status: "warning",
    type: "Lidl XL",
    address: "Dortmund, Mengede",
  },
  {
    id: 89,
    name: "Lidl Express Münster-Zentrum",
    lat: 51.9607,
    lng: 7.6261,
    score: 3.7,
    status: "warning",
    type: "Lidl Express",
    address: "Münster, Zentrum",
  },
  {
    id: 90,
    name: "Lidl XL Münster-Nord",
    lat: 51.9607,
    lng: 7.6261,
    score: 3.5,
    status: "warning",
    type: "Lidl XL",
    address: "Münster, Nord",
  },
  {
    id: 91,
    name: "Lidl Express Münster-Ost",
    lat: 51.9607,
    lng: 7.6261,
    score: 3.7,
    status: "warning",
    type: "Lidl Express",
    address: "Münster, Ost",
  },
  {
    id: 92,
    name: "Lidl Express Münster-Süd",
    lat: 51.9607,
    lng: 7.6261,
    score: 4.3,
    status: "success",
    type: "Lidl Express",
    address: "Münster, Süd",
  },
  {
    id: 93,
    name: "Lidl Münster-West",
    lat: 51.9607,
    lng: 7.6261,
    score: 2.6,
    status: "danger",
    type: "Lidl",
    address: "Münster, West",
  },
  {
    id: 94,
    name: "Lidl XL Münster-Hiltrup",
    lat: 51.9607,
    lng: 7.6261,
    score: 2.7,
    status: "danger",
    type: "Lidl XL",
    address: "Münster, Hiltrup",
  },
  {
    id: 95,
    name: "Lidl XL Münster-Roxel",
    lat: 51.9607,
    lng: 7.6261,
    score: 3.6,
    status: "warning",
    type: "Lidl XL",
    address: "Münster, Roxel",
  },
  {
    id: 96,
    name: "Lidl Express Duisburg-Mitte",
    lat: 51.4344,
    lng: 6.7623,
    score: 3.7,
    status: "warning",
    type: "Lidl Express",
    address: "Duisburg, Mitte",
  },
  {
    id: 97,
    name: "Lidl Duisburg-Süd",
    lat: 51.4344,
    lng: 6.7623,
    score: 4.5,
    status: "success",
    type: "Lidl",
    address: "Duisburg, Süd",
  },
  {
    id: 98,
    name: "Lidl XL Duisburg-Walsum",
    lat: 51.4344,
    lng: 6.7623,
    score: 4.2,
    status: "success",
    type: "Lidl XL",
    address: "Duisburg, Walsum",
  },
  {
    id: 99,
    name: "Lidl Express Duisburg-Hamborn",
    lat: 51.4344,
    lng: 6.7623,
    score: 3.3,
    status: "danger",
    type: "Lidl Express",
    address: "Duisburg, Hamborn",
  },
  {
    id: 100,
    name: "Lidl XL Duisburg-Meiderich",
    lat: 51.4344,
    lng: 6.7623,
    score: 4.1,
    status: "warning",
    type: "Lidl XL",
    address: "Duisburg, Meiderich",
  },
  {
    id: 101,
    name: "Lidl Duisburg-Rheinhausen",
    lat: 51.4344,
    lng: 6.7623,
    score: 3.6,
    status: "warning",
    type: "Lidl",
    address: "Duisburg, Rheinhausen",
  },
  {
    id: 102,
    name: "Lidl XL Bonn-Bad Godesberg",
    lat: 50.6851,
    lng: 7.1531,
    score: 3.8,
    status: "warning",
    type: "Lidl XL",
    address: "Bonn, Bad Godesberg",
  },
  {
    id: 103,
    name: "Lidl Bonn-Beuel",
    lat: 50.6851,
    lng: 7.1531,
    score: 4.2,
    status: "success",
    type: "Lidl",
    address: "Bonn, Beuel",
  },
  {
    id: 104,
    name: "Lidl Express Bonn-Poppelsdorf",
    lat: 50.6851,
    lng: 7.1531,
    score: 3.3,
    status: "danger",
    type: "Lidl Express",
    address: "Bonn, Poppelsdorf",
  },
  {
    id: 105,
    name: "Lidl XL Bonn-Endenich",
    lat: 50.6851,
    lng: 7.1531,
    score: 4,
    status: "warning",
    type: "Lidl XL",
    address: "Bonn, Endenich",
  },
  {
    id: 106,
    name: "Lidl Express Bonn-Dottendorf",
    lat: 50.6851,
    lng: 7.1531,
    score: 3.6,
    status: "warning",
    type: "Lidl Express",
    address: "Bonn, Dottendorf",
  },
  {
    id: 107,
    name: "Lidl XL Wuppertal-Elberfeld",
    lat: 51.2562,
    lng: 7.1508,
    score: 4.6,
    status: "success",
    type: "Lidl XL",
    address: "Wuppertal, Elberfeld",
  },
  {
    id: 108,
    name: "Lidl Wuppertal-Barmen",
    lat: 51.2562,
    lng: 7.1508,
    score: 4,
    status: "warning",
    type: "Lidl",
    address: "Wuppertal, Barmen",
  },
  {
    id: 109,
    name: "Lidl Wuppertal-Oberbarmen",
    lat: 51.2562,
    lng: 7.1508,
    score: 4.4,
    status: "success",
    type: "Lidl",
    address: "Wuppertal, Oberbarmen",
  },
  {
    id: 110,
    name: "Lidl Wuppertal-Ronsdorf",
    lat: 51.2562,
    lng: 7.1508,
    score: 4.9,
    status: "success",
    type: "Lidl",
    address: "Wuppertal, Ronsdorf",
  },
  {
    id: 111,
    name: "Lidl Wuppertal-Cronenberg",
    lat: 51.2562,
    lng: 7.1508,
    score: 3.5,
    status: "warning",
    type: "Lidl",
    address: "Wuppertal, Cronenberg",
  },
  {
    id: 112,
    name: "Lidl XL Wuppertal-Vohwinkel",
    lat: 51.2562,
    lng: 7.1508,
    score: 3.4,
    status: "warning",
    type: "Lidl XL",
    address: "Wuppertal, Vohwinkel",
  },
  {
    id: 113,
    name: "Lidl Frankfurt-Sachsenhausen",
    lat: 50.1009,
    lng: 8.6821,
    score: 3.5,
    status: "warning",
    type: "Lidl",
    address: "Frankfurt, Sachsenhausen",
  },
  {
    id: 114,
    name: "Lidl Express Frankfurt-Nordend",
    lat: 50.1009,
    lng: 8.6821,
    score: 4.7,
    status: "success",
    type: "Lidl Express",
    address: "Frankfurt, Nordend",
  },
  {
    id: 115,
    name: "Lidl XL Frankfurt-Bockenheim",
    lat: 50.1009,
    lng: 8.6821,
    score: 4.3,
    status: "success",
    type: "Lidl XL",
    address: "Frankfurt, Bockenheim",
  },
  {
    id: 116,
    name: "Lidl Express Frankfurt-Höchst",
    lat: 50.1009,
    lng: 8.6821,
    score: 2.8,
    status: "danger",
    type: "Lidl Express",
    address: "Frankfurt, Höchst",
  },
  {
    id: 117,
    name: "Lidl XL Frankfurt-Bornheim",
    lat: 50.1009,
    lng: 8.6821,
    score: 4.4,
    status: "success",
    type: "Lidl XL",
    address: "Frankfurt, Bornheim",
  },
  {
    id: 118,
    name: "Lidl Express Frankfurt-Ostend",
    lat: 50.1009,
    lng: 8.6821,
    score: 4.6,
    status: "success",
    type: "Lidl Express",
    address: "Frankfurt, Ostend",
  },
  {
    id: 119,
    name: "Lidl XL Frankfurt-Westend",
    lat: 50.1009,
    lng: 8.6821,
    score: 3.9,
    status: "warning",
    type: "Lidl XL",
    address: "Frankfurt, Westend",
  },
  {
    id: 120,
    name: "Lidl XL Frankfurt-Süd",
    lat: 50.1009,
    lng: 8.6821,
    score: 3.3,
    status: "danger",
    type: "Lidl XL",
    address: "Frankfurt, Süd",
  },
  {
    id: 121,
    name: "Lidl Wiesbaden-Innenstadt",
    lat: 50.0782,
    lng: 8.2398,
    score: 4.9,
    status: "success",
    type: "Lidl",
    address: "Wiesbaden, Innenstadt",
  },
  {
    id: 122,
    name: "Lidl Express Wiesbaden-Nordost",
    lat: 50.0782,
    lng: 8.2398,
    score: 3.7,
    status: "warning",
    type: "Lidl Express",
    address: "Wiesbaden, Nordost",
  },
  {
    id: 123,
    name: "Lidl Wiesbaden-Rheingauviertel",
    lat: 50.0782,
    lng: 8.2398,
    score: 4.7,
    status: "success",
    type: "Lidl",
    address: "Wiesbaden, Rheingauviertel",
  },
  {
    id: 124,
    name: "Lidl Wiesbaden-Südost",
    lat: 50.0782,
    lng: 8.2398,
    score: 3.7,
    status: "warning",
    type: "Lidl",
    address: "Wiesbaden, Südost",
  },
  {
    id: 125,
    name: "Lidl Express Wiesbaden-Biebrich",
    lat: 50.0782,
    lng: 8.2398,
    score: 3.7,
    status: "warning",
    type: "Lidl Express",
    address: "Wiesbaden, Biebrich",
  },
  {
    id: 126,
    name: "Lidl Wiesbaden-Dotzheim",
    lat: 50.0782,
    lng: 8.2398,
    score: 5,
    status: "success",
    type: "Lidl",
    address: "Wiesbaden, Dotzheim",
  },
  {
    id: 127,
    name: "Lidl Express Mainz-Altstadt",
    lat: 49.9929,
    lng: 8.2473,
    score: 4,
    status: "warning",
    type: "Lidl Express",
    address: "Mainz, Altstadt",
  },
  {
    id: 128,
    name: "Lidl XL Mainz-Gonsenheim",
    lat: 49.9929,
    lng: 8.2473,
    score: 4,
    status: "warning",
    type: "Lidl XL",
    address: "Mainz, Gonsenheim",
  },
  {
    id: 129,
    name: "Lidl Mainz-Mombach",
    lat: 49.9929,
    lng: 8.2473,
    score: 4.1,
    status: "warning",
    type: "Lidl",
    address: "Mainz, Mombach",
  },
  {
    id: 130,
    name: "Lidl XL Mainz-Bretzenheim",
    lat: 49.9929,
    lng: 8.2473,
    score: 2.8,
    status: "danger",
    type: "Lidl XL",
    address: "Mainz, Bretzenheim",
  },
  {
    id: 131,
    name: "Lidl XL Mainz-Laubenheim",
    lat: 49.9929,
    lng: 8.2473,
    score: 4.9,
    status: "success",
    type: "Lidl XL",
    address: "Mainz, Laubenheim",
  },
  {
    id: 132,
    name: "Lidl Express Mainz-Neustadt",
    lat: 49.9929,
    lng: 8.2473,
    score: 4.6,
    status: "success",
    type: "Lidl Express",
    address: "Mainz, Neustadt",
  },
  {
    id: 133,
    name: "Lidl Express Kassel-Mitte",
    lat: 51.3127,
    lng: 9.4797,
    score: 3.6,
    status: "warning",
    type: "Lidl Express",
    address: "Kassel, Mitte",
  },
  {
    id: 134,
    name: "Lidl Kassel-Nord-Holland",
    lat: 51.3127,
    lng: 9.4797,
    score: 4.9,
    status: "success",
    type: "Lidl",
    address: "Kassel, Nord-Holland",
  },
  {
    id: 135,
    name: "Lidl XL Kassel-Süd",
    lat: 51.3127,
    lng: 9.4797,
    score: 4.7,
    status: "success",
    type: "Lidl XL",
    address: "Kassel, Süd",
  },
  {
    id: 136,
    name: "Lidl Express Kassel-West",
    lat: 51.3127,
    lng: 9.4797,
    score: 2.5,
    status: "danger",
    type: "Lidl Express",
    address: "Kassel, West",
  },
  {
    id: 137,
    name: "Lidl XL Kassel-Vorderer Westen",
    lat: 51.3127,
    lng: 9.4797,
    score: 4.8,
    status: "success",
    type: "Lidl XL",
    address: "Kassel, Vorderer Westen",
  },
  {
    id: 138,
    name: "Lidl Express Kassel-Bettenhausen",
    lat: 51.3127,
    lng: 9.4797,
    score: 3.1,
    status: "danger",
    type: "Lidl Express",
    address: "Kassel, Bettenhausen",
  },
  {
    id: 139,
    name: "Lidl XL München-Schwabing",
    lat: 48.1551,
    lng: 11.582,
    score: 3.6,
    status: "warning",
    type: "Lidl XL",
    address: "München, Schwabing",
  },
  {
    id: 140,
    name: "Lidl Express München-Haidhausen",
    lat: 48.1551,
    lng: 11.582,
    score: 5,
    status: "success",
    type: "Lidl Express",
    address: "München, Haidhausen",
  },
  {
    id: 141,
    name: "Lidl München-Pasing",
    lat: 48.1551,
    lng: 11.582,
    score: 4.9,
    status: "success",
    type: "Lidl",
    address: "München, Pasing",
  },
  {
    id: 142,
    name: "Lidl Express München-Sendling",
    lat: 48.1551,
    lng: 11.582,
    score: 4.6,
    status: "success",
    type: "Lidl Express",
    address: "München, Sendling",
  },
  {
    id: 143,
    name: "Lidl München-Bogenhausen",
    lat: 48.1551,
    lng: 11.582,
    score: 3.8,
    status: "warning",
    type: "Lidl",
    address: "München, Bogenhausen",
  },
  {
    id: 144,
    name: "Lidl Express München-Laim",
    lat: 48.1551,
    lng: 11.582,
    score: 3.4,
    status: "warning",
    type: "Lidl Express",
    address: "München, Laim",
  },
  {
    id: 145,
    name: "Lidl München-Trudering",
    lat: 48.1551,
    lng: 11.582,
    score: 3.7,
    status: "warning",
    type: "Lidl",
    address: "München, Trudering",
  },
  {
    id: 146,
    name: "Lidl Express München-Freimann",
    lat: 48.1551,
    lng: 11.582,
    score: 2.7,
    status: "danger",
    type: "Lidl Express",
    address: "München, Freimann",
  },
  {
    id: 147,
    name: "Lidl XL München-Moosach",
    lat: 48.1551,
    lng: 11.582,
    score: 3.9,
    status: "warning",
    type: "Lidl XL",
    address: "München, Moosach",
  },
  {
    id: 148,
    name: "Lidl München-Allach",
    lat: 48.1551,
    lng: 11.582,
    score: 3.4,
    status: "warning",
    type: "Lidl",
    address: "München, Allach",
  },
  {
    id: 149,
    name: "Lidl XL Nürnberg-Gostenhof",
    lat: 49.4521,
    lng: 11.0567,
    score: 2.8,
    status: "danger",
    type: "Lidl XL",
    address: "Nürnberg, Gostenhof",
  },
  {
    id: 150,
    name: "Lidl XL Nürnberg-Zentrum",
    lat: 49.4521,
    lng: 11.0567,
    score: 4.4,
    status: "success",
    type: "Lidl XL",
    address: "Nürnberg, Zentrum",
  },
  {
    id: 151,
    name: "Lidl XL Nürnberg-Südstadt",
    lat: 49.4521,
    lng: 11.0567,
    score: 4.5,
    status: "success",
    type: "Lidl XL",
    address: "Nürnberg, Südstadt",
  },
  {
    id: 152,
    name: "Lidl Express Nürnberg-Nordost",
    lat: 49.4521,
    lng: 11.0567,
    score: 2.8,
    status: "danger",
    type: "Lidl Express",
    address: "Nürnberg, Nordost",
  },
  {
    id: 153,
    name: "Lidl XL Nürnberg-West",
    lat: 49.4521,
    lng: 11.0567,
    score: 5,
    status: "success",
    type: "Lidl XL",
    address: "Nürnberg, West",
  },
  {
    id: 154,
    name: "Lidl Express Nürnberg-Langwasser",
    lat: 49.4521,
    lng: 11.0567,
    score: 4.3,
    status: "success",
    type: "Lidl Express",
    address: "Nürnberg, Langwasser",
  },
  {
    id: 155,
    name: "Lidl Augsburg-Innenstadt",
    lat: 48.3705,
    lng: 10.8978,
    score: 4,
    status: "warning",
    type: "Lidl",
    address: "Augsburg, Innenstadt",
  },
  {
    id: 156,
    name: "Lidl Augsburg-Oberhausen",
    lat: 48.3705,
    lng: 10.8978,
    score: 4.6,
    status: "success",
    type: "Lidl",
    address: "Augsburg, Oberhausen",
  },
  {
    id: 157,
    name: "Lidl Augsburg-Pfersee",
    lat: 48.3705,
    lng: 10.8978,
    score: 4.4,
    status: "success",
    type: "Lidl",
    address: "Augsburg, Pfersee",
  },
  {
    id: 158,
    name: "Lidl XL Augsburg-Hochfeld",
    lat: 48.3705,
    lng: 10.8978,
    score: 3,
    status: "danger",
    type: "Lidl XL",
    address: "Augsburg, Hochfeld",
  },
  {
    id: 159,
    name: "Lidl Express Augsburg-Lechhausen",
    lat: 48.3705,
    lng: 10.8978,
    score: 3.9,
    status: "warning",
    type: "Lidl Express",
    address: "Augsburg, Lechhausen",
  },
  {
    id: 160,
    name: "Lidl XL Augsburg-Göggingen",
    lat: 48.3705,
    lng: 10.8978,
    score: 3.6,
    status: "warning",
    type: "Lidl XL",
    address: "Augsburg, Göggingen",
  },
  {
    id: 161,
    name: "Lidl Regensburg-Altstadt",
    lat: 49.0134,
    lng: 12.1016,
    score: 4.2,
    status: "success",
    type: "Lidl",
    address: "Regensburg, Altstadt",
  },
  {
    id: 162,
    name: "Lidl Regensburg-Stadtamhof",
    lat: 49.0134,
    lng: 12.1016,
    score: 3,
    status: "danger",
    type: "Lidl",
    address: "Regensburg, Stadtamhof",
  },
  {
    id: 163,
    name: "Lidl XL Regensburg-Sallern",
    lat: 49.0134,
    lng: 12.1016,
    score: 3.3,
    status: "danger",
    type: "Lidl XL",
    address: "Regensburg, Sallern",
  },
  {
    id: 164,
    name: "Lidl Regensburg-Weichs",
    lat: 49.0134,
    lng: 12.1016,
    score: 3.8,
    status: "warning",
    type: "Lidl",
    address: "Regensburg, Weichs",
  },
  {
    id: 165,
    name: "Lidl XL Regensburg-Kumpfmühl",
    lat: 49.0134,
    lng: 12.1016,
    score: 2.5,
    status: "danger",
    type: "Lidl XL",
    address: "Regensburg, Kumpfmühl",
  },
  {
    id: 166,
    name: "Lidl XL Würzburg-Sanderau",
    lat: 49.7913,
    lng: 9.9534,
    score: 4.5,
    status: "success",
    type: "Lidl XL",
    address: "Würzburg, Sanderau",
  },
  {
    id: 167,
    name: "Lidl Express Würzburg-Zellerau",
    lat: 49.7913,
    lng: 9.9534,
    score: 3.4,
    status: "danger",
    type: "Lidl Express",
    address: "Würzburg, Zellerau",
  },
  {
    id: 168,
    name: "Lidl Express Würzburg-Grombühl",
    lat: 49.7913,
    lng: 9.9534,
    score: 4.4,
    status: "success",
    type: "Lidl Express",
    address: "Würzburg, Grombühl",
  },
  {
    id: 169,
    name: "Lidl Express Würzburg-Lengfeld",
    lat: 49.7913,
    lng: 9.9534,
    score: 4.3,
    status: "success",
    type: "Lidl Express",
    address: "Würzburg, Lengfeld",
  },
  {
    id: 170,
    name: "Lidl XL Würzburg-Heidingsfeld",
    lat: 49.7913,
    lng: 9.9534,
    score: 2.8,
    status: "danger",
    type: "Lidl XL",
    address: "Würzburg, Heidingsfeld",
  },
  {
    id: 171,
    name: "Lidl Stuttgart-West",
    lat: 48.7758,
    lng: 9.1629,
    score: 2.7,
    status: "danger",
    type: "Lidl",
    address: "Stuttgart, West",
  },
  {
    id: 172,
    name: "Lidl Express Stuttgart-Mitte",
    lat: 48.7758,
    lng: 9.1629,
    score: 3.8,
    status: "warning",
    type: "Lidl Express",
    address: "Stuttgart, Mitte",
  },
  {
    id: 173,
    name: "Lidl Express Stuttgart-Bad Cannstatt",
    lat: 48.7758,
    lng: 9.1629,
    score: 2.7,
    status: "danger",
    type: "Lidl Express",
    address: "Stuttgart, Bad Cannstatt",
  },
  {
    id: 174,
    name: "Lidl XL Stuttgart-Vaihingen",
    lat: 48.7758,
    lng: 9.1629,
    score: 3.8,
    status: "warning",
    type: "Lidl XL",
    address: "Stuttgart, Vaihingen",
  },
  {
    id: 175,
    name: "Lidl Express Stuttgart-Zuffenhausen",
    lat: 48.7758,
    lng: 9.1629,
    score: 3.8,
    status: "warning",
    type: "Lidl Express",
    address: "Stuttgart, Zuffenhausen",
  },
  {
    id: 176,
    name: "Lidl Express Stuttgart-Feuerbach",
    lat: 48.7758,
    lng: 9.1629,
    score: 4.3,
    status: "success",
    type: "Lidl Express",
    address: "Stuttgart, Feuerbach",
  },
  {
    id: 177,
    name: "Lidl XL Stuttgart-Ost",
    lat: 48.7758,
    lng: 9.1629,
    score: 3.5,
    status: "warning",
    type: "Lidl XL",
    address: "Stuttgart, Ost",
  },
  {
    id: 178,
    name: "Lidl XL Stuttgart-Sillenbuch",
    lat: 48.7758,
    lng: 9.1629,
    score: 4,
    status: "warning",
    type: "Lidl XL",
    address: "Stuttgart, Sillenbuch",
  },
  {
    id: 179,
    name: "Lidl Karlsruhe-Innenstadt",
    lat: 49.0069,
    lng: 8.4037,
    score: 4,
    status: "warning",
    type: "Lidl",
    address: "Karlsruhe, Innenstadt",
  },
  {
    id: 180,
    name: "Lidl XL Karlsruhe-Oststadt",
    lat: 49.0069,
    lng: 8.4037,
    score: 3.7,
    status: "warning",
    type: "Lidl XL",
    address: "Karlsruhe, Oststadt",
  },
  {
    id: 181,
    name: "Lidl Express Karlsruhe-Südstadt",
    lat: 49.0069,
    lng: 8.4037,
    score: 3.4,
    status: "warning",
    type: "Lidl Express",
    address: "Karlsruhe, Südstadt",
  },
  {
    id: 182,
    name: "Lidl Karlsruhe-Mühlburg",
    lat: 49.0069,
    lng: 8.4037,
    score: 4.7,
    status: "success",
    type: "Lidl",
    address: "Karlsruhe, Mühlburg",
  },
  {
    id: 183,
    name: "Lidl Karlsruhe-Durlach",
    lat: 49.0069,
    lng: 8.4037,
    score: 4.9,
    status: "success",
    type: "Lidl",
    address: "Karlsruhe, Durlach",
  },
  {
    id: 184,
    name: "Lidl Karlsruhe-Neureut",
    lat: 49.0069,
    lng: 8.4037,
    score: 2.5,
    status: "danger",
    type: "Lidl",
    address: "Karlsruhe, Neureut",
  },
  {
    id: 185,
    name: "Lidl XL Karlsruhe-Rintheim",
    lat: 49.0069,
    lng: 8.4037,
    score: 4.3,
    status: "success",
    type: "Lidl XL",
    address: "Karlsruhe, Rintheim",
  },
  {
    id: 186,
    name: "Lidl XL Mannheim-Quadrate",
    lat: 49.4875,
    lng: 8.466,
    score: 3.7,
    status: "warning",
    type: "Lidl XL",
    address: "Mannheim, Quadrate",
  },
  {
    id: 187,
    name: "Lidl Express Mannheim-Lindenhof",
    lat: 49.4875,
    lng: 8.466,
    score: 3.3,
    status: "danger",
    type: "Lidl Express",
    address: "Mannheim, Lindenhof",
  },
  {
    id: 188,
    name: "Lidl XL Mannheim-Neckarstadt",
    lat: 49.4875,
    lng: 8.466,
    score: 3.5,
    status: "warning",
    type: "Lidl XL",
    address: "Mannheim, Neckarstadt",
  },
  {
    id: 189,
    name: "Lidl Express Mannheim-Feudenheim",
    lat: 49.4875,
    lng: 8.466,
    score: 4.3,
    status: "success",
    type: "Lidl Express",
    address: "Mannheim, Feudenheim",
  },
  {
    id: 190,
    name: "Lidl Express Mannheim-Seckenheim",
    lat: 49.4875,
    lng: 8.466,
    score: 3.3,
    status: "danger",
    type: "Lidl Express",
    address: "Mannheim, Seckenheim",
  },
  {
    id: 191,
    name: "Lidl Express Mannheim-Rheinau",
    lat: 49.4875,
    lng: 8.466,
    score: 3.5,
    status: "warning",
    type: "Lidl Express",
    address: "Mannheim, Rheinau",
  },
  {
    id: 192,
    name: "Lidl XL Freiburg-Altstadt",
    lat: 47.999,
    lng: 7.8421,
    score: 5,
    status: "success",
    type: "Lidl XL",
    address: "Freiburg, Altstadt",
  },
  {
    id: 193,
    name: "Lidl XL Freiburg-Herdern",
    lat: 47.999,
    lng: 7.8421,
    score: 3.7,
    status: "warning",
    type: "Lidl XL",
    address: "Freiburg, Herdern",
  },
  {
    id: 194,
    name: "Lidl XL Freiburg-Zähringen",
    lat: 47.999,
    lng: 7.8421,
    score: 3.8,
    status: "warning",
    type: "Lidl XL",
    address: "Freiburg, Zähringen",
  },
  {
    id: 195,
    name: "Lidl Express Freiburg-Brühl",
    lat: 47.999,
    lng: 7.8421,
    score: 4.6,
    status: "success",
    type: "Lidl Express",
    address: "Freiburg, Brühl",
  },
  {
    id: 196,
    name: "Lidl XL Freiburg-Haslach",
    lat: 47.999,
    lng: 7.8421,
    score: 4,
    status: "warning",
    type: "Lidl XL",
    address: "Freiburg, Haslach",
  },
  {
    id: 197,
    name: "Lidl Freiburg-Stühlinger",
    lat: 47.999,
    lng: 7.8421,
    score: 3.6,
    status: "warning",
    type: "Lidl",
    address: "Freiburg, Stühlinger",
  },
  {
    id: 198,
    name: "Lidl XL Freiburg-Weingarten",
    lat: 47.999,
    lng: 7.8421,
    score: 5,
    status: "success",
    type: "Lidl XL",
    address: "Freiburg, Weingarten",
  },
  {
    id: 199,
    name: "Lidl Express Heidelberg-Altstadt",
    lat: 49.3988,
    lng: 8.6724,
    score: 4.2,
    status: "warning",
    type: "Lidl Express",
    address: "Heidelberg, Altstadt",
  },
  {
    id: 200,
    name: "Lidl XL Heidelberg-Bergheim",
    lat: 49.3988,
    lng: 8.6724,
    score: 3,
    status: "danger",
    type: "Lidl XL",
    address: "Heidelberg, Bergheim",
  },
  {
    id: 201,
    name: "Lidl Heidelberg-Weststadt",
    lat: 49.3988,
    lng: 8.6724,
    score: 3.1,
    status: "danger",
    type: "Lidl",
    address: "Heidelberg, Weststadt",
  },
  {
    id: 202,
    name: "Lidl XL Heidelberg-Rohrbach",
    lat: 49.3988,
    lng: 8.6724,
    score: 3.9,
    status: "warning",
    type: "Lidl XL",
    address: "Heidelberg, Rohrbach",
  },
  {
    id: 203,
    name: "Lidl Express Heidelberg-Handschuhsheim",
    lat: 49.3988,
    lng: 8.6724,
    score: 2.6,
    status: "danger",
    type: "Lidl Express",
    address: "Heidelberg, Handschuhsheim",
  },
  {
    id: 204,
    name: "Lidl Heidelberg-Neuenheim",
    lat: 49.3988,
    lng: 8.6724,
    score: 4.5,
    status: "success",
    type: "Lidl",
    address: "Heidelberg, Neuenheim",
  },
  {
    id: 205,
    name: "Lidl Express Ulm-Innenstadt",
    lat: 48.4011,
    lng: 9.9876,
    score: 4.4,
    status: "success",
    type: "Lidl Express",
    address: "Ulm, Innenstadt",
  },
  {
    id: 206,
    name: "Lidl Express Ulm-Söfingen",
    lat: 48.4011,
    lng: 9.9876,
    score: 4.6,
    status: "success",
    type: "Lidl Express",
    address: "Ulm, Söfingen",
  },
  {
    id: 207,
    name: "Lidl Express Ulm-Grimmelfingen",
    lat: 48.4011,
    lng: 9.9876,
    score: 4,
    status: "warning",
    type: "Lidl Express",
    address: "Ulm, Grimmelfingen",
  },
  {
    id: 208,
    name: "Lidl XL Ulm-Wiblingen",
    lat: 48.4011,
    lng: 9.9876,
    score: 4.1,
    status: "warning",
    type: "Lidl XL",
    address: "Ulm, Wiblingen",
  },
  {
    id: 209,
    name: "Lidl Express Ulm-Böfingen",
    lat: 48.4011,
    lng: 9.9876,
    score: 3.4,
    status: "warning",
    type: "Lidl Express",
    address: "Ulm, Böfingen",
  },
  {
    id: 210,
    name: "Lidl Leipzig-Zentrum",
    lat: 51.3397,
    lng: 12.3731,
    score: 4.8,
    status: "success",
    type: "Lidl",
    address: "Leipzig, Zentrum",
  },
  {
    id: 211,
    name: "Lidl Leipzig-Süd",
    lat: 51.3397,
    lng: 12.3731,
    score: 4,
    status: "warning",
    type: "Lidl",
    address: "Leipzig, Süd",
  },
  {
    id: 212,
    name: "Lidl Leipzig-West",
    lat: 51.3397,
    lng: 12.3731,
    score: 3.6,
    status: "warning",
    type: "Lidl",
    address: "Leipzig, West",
  },
  {
    id: 213,
    name: "Lidl Express Leipzig-Connewitz",
    lat: 51.3397,
    lng: 12.3731,
    score: 2.6,
    status: "danger",
    type: "Lidl Express",
    address: "Leipzig, Connewitz",
  },
  {
    id: 214,
    name: "Lidl XL Leipzig-Plagwitz",
    lat: 51.3397,
    lng: 12.3731,
    score: 4.5,
    status: "success",
    type: "Lidl XL",
    address: "Leipzig, Plagwitz",
  },
  {
    id: 215,
    name: "Lidl Leipzig-Grünau",
    lat: 51.3397,
    lng: 12.3731,
    score: 3.1,
    status: "danger",
    type: "Lidl",
    address: "Leipzig, Grünau",
  },
  {
    id: 216,
    name: "Lidl Express Leipzig-Mitte",
    lat: 51.3397,
    lng: 12.3731,
    score: 4.4,
    status: "success",
    type: "Lidl Express",
    address: "Leipzig, Mitte",
  },
  {
    id: 217,
    name: "Lidl Express Leipzig-Nord",
    lat: 51.3397,
    lng: 12.3731,
    score: 4.5,
    status: "success",
    type: "Lidl Express",
    address: "Leipzig, Nord",
  },
  {
    id: 218,
    name: "Lidl Express Leipzig-Ost",
    lat: 51.3397,
    lng: 12.3731,
    score: 4.1,
    status: "warning",
    type: "Lidl Express",
    address: "Leipzig, Ost",
  },
  {
    id: 219,
    name: "Lidl Express Dresden-Altstadt",
    lat: 51.0504,
    lng: 13.7373,
    score: 4.4,
    status: "success",
    type: "Lidl Express",
    address: "Dresden, Altstadt",
  },
  {
    id: 220,
    name: "Lidl XL Dresden-Neustadt",
    lat: 51.0504,
    lng: 13.7373,
    score: 4.4,
    status: "success",
    type: "Lidl XL",
    address: "Dresden, Neustadt",
  },
  {
    id: 221,
    name: "Lidl Express Dresden-Blasewitz",
    lat: 51.0504,
    lng: 13.7373,
    score: 3.2,
    status: "danger",
    type: "Lidl Express",
    address: "Dresden, Blasewitz",
  },
  {
    id: 222,
    name: "Lidl Dresden-Cotta",
    lat: 51.0504,
    lng: 13.7373,
    score: 2.8,
    status: "danger",
    type: "Lidl",
    address: "Dresden, Cotta",
  },
  {
    id: 223,
    name: "Lidl Dresden-Prohlis",
    lat: 51.0504,
    lng: 13.7373,
    score: 3,
    status: "danger",
    type: "Lidl",
    address: "Dresden, Prohlis",
  },
  {
    id: 224,
    name: "Lidl Express Dresden-Pieschen",
    lat: 51.0504,
    lng: 13.7373,
    score: 4.1,
    status: "warning",
    type: "Lidl Express",
    address: "Dresden, Pieschen",
  },
  {
    id: 225,
    name: "Lidl XL Dresden-Klotzsche",
    lat: 51.0504,
    lng: 13.7373,
    score: 3.2,
    status: "danger",
    type: "Lidl XL",
    address: "Dresden, Klotzsche",
  },
  {
    id: 226,
    name: "Lidl Express Erfurt-Innenstadt",
    lat: 50.9787,
    lng: 11.0328,
    score: 4.2,
    status: "warning",
    type: "Lidl Express",
    address: "Erfurt, Innenstadt",
  },
  {
    id: 227,
    name: "Lidl Erfurt-Nord",
    lat: 50.9787,
    lng: 11.0328,
    score: 3.6,
    status: "warning",
    type: "Lidl",
    address: "Erfurt, Nord",
  },
  {
    id: 228,
    name: "Lidl XL Erfurt-Süd",
    lat: 50.9787,
    lng: 11.0328,
    score: 3.2,
    status: "danger",
    type: "Lidl XL",
    address: "Erfurt, Süd",
  },
  {
    id: 229,
    name: "Lidl Erfurt-Ost",
    lat: 50.9787,
    lng: 11.0328,
    score: 3.5,
    status: "warning",
    type: "Lidl",
    address: "Erfurt, Ost",
  },
  {
    id: 230,
    name: "Lidl Express Erfurt-West",
    lat: 50.9787,
    lng: 11.0328,
    score: 4.4,
    status: "success",
    type: "Lidl Express",
    address: "Erfurt, West",
  },
  {
    id: 231,
    name: "Lidl Erfurt-Brühlervorstadt",
    lat: 50.9787,
    lng: 11.0328,
    score: 4,
    status: "warning",
    type: "Lidl",
    address: "Erfurt, Brühlervorstadt",
  },
  {
    id: 232,
    name: "Lidl Express Jena-Zentrum",
    lat: 50.9271,
    lng: 11.5892,
    score: 3.9,
    status: "warning",
    type: "Lidl Express",
    address: "Jena, Zentrum",
  },
  {
    id: 233,
    name: "Lidl Express Jena-Nord",
    lat: 50.9271,
    lng: 11.5892,
    score: 3.4,
    status: "warning",
    type: "Lidl Express",
    address: "Jena, Nord",
  },
  {
    id: 234,
    name: "Lidl XL Jena-West",
    lat: 50.9271,
    lng: 11.5892,
    score: 4.9,
    status: "success",
    type: "Lidl XL",
    address: "Jena, West",
  },
  {
    id: 235,
    name: "Lidl XL Jena-Lobeda",
    lat: 50.9271,
    lng: 11.5892,
    score: 2.6,
    status: "danger",
    type: "Lidl XL",
    address: "Jena, Lobeda",
  },
  {
    id: 236,
    name: "Lidl XL Jena-Winzerla",
    lat: 50.9271,
    lng: 11.5892,
    score: 3.6,
    status: "warning",
    type: "Lidl XL",
    address: "Jena, Winzerla",
  },
  {
    id: 237,
    name: "Lidl Hannover-List",
    lat: 52.3859,
    lng: 9.752,
    score: 4.1,
    status: "warning",
    type: "Lidl",
    address: "Hannover, List",
  },
  {
    id: 238,
    name: "Lidl Hannover-Linden",
    lat: 52.3859,
    lng: 9.752,
    score: 3.2,
    status: "danger",
    type: "Lidl",
    address: "Hannover, Linden",
  },
  {
    id: 239,
    name: "Lidl Express Hannover-Nordstadt",
    lat: 52.3859,
    lng: 9.752,
    score: 2.9,
    status: "danger",
    type: "Lidl Express",
    address: "Hannover, Nordstadt",
  },
  {
    id: 240,
    name: "Lidl XL Hannover-Südstadt",
    lat: 52.3859,
    lng: 9.752,
    score: 4,
    status: "warning",
    type: "Lidl XL",
    address: "Hannover, Südstadt",
  },
  {
    id: 241,
    name: "Lidl Express Hannover-Oststadt",
    lat: 52.3859,
    lng: 9.752,
    score: 2.8,
    status: "danger",
    type: "Lidl Express",
    address: "Hannover, Oststadt",
  },
  {
    id: 242,
    name: "Lidl XL Hannover-Mitte",
    lat: 52.3859,
    lng: 9.752,
    score: 4.2,
    status: "success",
    type: "Lidl XL",
    address: "Hannover, Mitte",
  },
  {
    id: 243,
    name: "Lidl Express Hannover-Döhren",
    lat: 52.3859,
    lng: 9.752,
    score: 4.8,
    status: "success",
    type: "Lidl Express",
    address: "Hannover, Döhren",
  },
  {
    id: 244,
    name: "Lidl Express Hannover-Wülfel",
    lat: 52.3859,
    lng: 9.752,
    score: 2.8,
    status: "danger",
    type: "Lidl Express",
    address: "Hannover, Wülfel",
  },
  {
    id: 245,
    name: "Lidl XL Braunschweig-Innenstadt",
    lat: 52.2689,
    lng: 10.5268,
    score: 3.6,
    status: "warning",
    type: "Lidl XL",
    address: "Braunschweig, Innenstadt",
  },
  {
    id: 246,
    name: "Lidl Express Braunschweig-Nord",
    lat: 52.2689,
    lng: 10.5268,
    score: 4.8,
    status: "success",
    type: "Lidl Express",
    address: "Braunschweig, Nord",
  },
  {
    id: 247,
    name: "Lidl Express Braunschweig-Ost",
    lat: 52.2689,
    lng: 10.5268,
    score: 4.2,
    status: "success",
    type: "Lidl Express",
    address: "Braunschweig, Ost",
  },
  {
    id: 248,
    name: "Lidl Express Braunschweig-Süd",
    lat: 52.2689,
    lng: 10.5268,
    score: 3.2,
    status: "danger",
    type: "Lidl Express",
    address: "Braunschweig, Süd",
  },
  {
    id: 249,
    name: "Lidl XL Braunschweig-West",
    lat: 52.2689,
    lng: 10.5268,
    score: 4,
    status: "warning",
    type: "Lidl XL",
    address: "Braunschweig, West",
  },
  {
    id: 250,
    name: "Lidl Braunschweig-Lehndorf",
    lat: 52.2689,
    lng: 10.5268,
    score: 3.6,
    status: "warning",
    type: "Lidl",
    address: "Braunschweig, Lehndorf",
  },
  {
    id: 251,
    name: "Lidl XL Braunschweig-Wenden",
    lat: 52.2689,
    lng: 10.5268,
    score: 4,
    status: "warning",
    type: "Lidl XL",
    address: "Braunschweig, Wenden",
  },
  {
    id: 252,
    name: "Lidl Göttingen-Zentrum",
    lat: 51.5413,
    lng: 9.9158,
    score: 3.4,
    status: "danger",
    type: "Lidl",
    address: "Göttingen, Zentrum",
  },
  {
    id: 253,
    name: "Lidl Göttingen-Nord",
    lat: 51.5413,
    lng: 9.9158,
    score: 3.1,
    status: "danger",
    type: "Lidl",
    address: "Göttingen, Nord",
  },
  {
    id: 254,
    name: "Lidl Express Göttingen-Ost",
    lat: 51.5413,
    lng: 9.9158,
    score: 4.9,
    status: "success",
    type: "Lidl Express",
    address: "Göttingen, Ost",
  },
  {
    id: 255,
    name: "Lidl Göttingen-Weende",
    lat: 51.5413,
    lng: 9.9158,
    score: 3.3,
    status: "danger",
    type: "Lidl",
    address: "Göttingen, Weende",
  },
  {
    id: 256,
    name: "Lidl Göttingen-Geismar",
    lat: 51.5413,
    lng: 9.9158,
    score: 3.6,
    status: "warning",
    type: "Lidl",
    address: "Göttingen, Geismar",
  },
  {
    id: 257,
    name: "Lidl XL Osnabrück-Innenstadt",
    lat: 52.2799,
    lng: 8.0472,
    score: 3.8,
    status: "warning",
    type: "Lidl XL",
    address: "Osnabrück, Innenstadt",
  },
  {
    id: 258,
    name: "Lidl XL Osnabrück-West",
    lat: 52.2799,
    lng: 8.0472,
    score: 4,
    status: "warning",
    type: "Lidl XL",
    address: "Osnabrück, West",
  },
  {
    id: 259,
    name: "Lidl XL Osnabrück-Nord",
    lat: 52.2799,
    lng: 8.0472,
    score: 2.7,
    status: "danger",
    type: "Lidl XL",
    address: "Osnabrück, Nord",
  },
  {
    id: 260,
    name: "Lidl XL Osnabrück-Süd",
    lat: 52.2799,
    lng: 8.0472,
    score: 4.2,
    status: "warning",
    type: "Lidl XL",
    address: "Osnabrück, Süd",
  },
  {
    id: 261,
    name: "Lidl Osnabrück-Westerberg",
    lat: 52.2799,
    lng: 8.0472,
    score: 4.3,
    status: "success",
    type: "Lidl",
    address: "Osnabrück, Westerberg",
  },
  {
    id: 262,
    name: "Lidl Express Osnabrück-Schinkel",
    lat: 52.2799,
    lng: 8.0472,
    score: 4.8,
    status: "success",
    type: "Lidl Express",
    address: "Osnabrück, Schinkel",
  },
  {
    id: 263,
    name: "Lidl Wolfsburg-Zentrum",
    lat: 52.4227,
    lng: 10.7865,
    score: 4.3,
    status: "success",
    type: "Lidl",
    address: "Wolfsburg, Zentrum",
  },
  {
    id: 264,
    name: "Lidl Wolfsburg-Nord",
    lat: 52.4227,
    lng: 10.7865,
    score: 3.6,
    status: "warning",
    type: "Lidl",
    address: "Wolfsburg, Nord",
  },
  {
    id: 265,
    name: "Lidl XL Wolfsburg-Süd",
    lat: 52.4227,
    lng: 10.7865,
    score: 4.2,
    status: "warning",
    type: "Lidl XL",
    address: "Wolfsburg, Süd",
  },
  {
    id: 266,
    name: "Lidl Express Wolfsburg-West",
    lat: 52.4227,
    lng: 10.7865,
    score: 3.4,
    status: "danger",
    type: "Lidl Express",
    address: "Wolfsburg, West",
  },
  {
    id: 267,
    name: "Lidl Express Wolfsburg-Fallersleben",
    lat: 52.4227,
    lng: 10.7865,
    score: 3.9,
    status: "warning",
    type: "Lidl Express",
    address: "Wolfsburg, Fallersleben",
  },
  {
    id: 268,
    name: "Lidl Wolfsburg-Vorsfelde",
    lat: 52.4227,
    lng: 10.7865,
    score: 4.8,
    status: "success",
    type: "Lidl",
    address: "Wolfsburg, Vorsfelde",
  },
  {
    id: 269,
    name: "Lidl Flensburg-Zentrum",
    lat: 54.7937,
    lng: 9.4469,
    score: 4.2,
    status: "warning",
    type: "Lidl",
    address: "Flensburg, Zentrum",
  },
  {
    id: 270,
    name: "Lidl XL Flensburg-Nord",
    lat: 54.7937,
    lng: 9.4469,
    score: 4.5,
    status: "success",
    type: "Lidl XL",
    address: "Flensburg, Nord",
  },
  {
    id: 271,
    name: "Lidl Express Flensburg-Süd",
    lat: 54.7937,
    lng: 9.4469,
    score: 4.1,
    status: "warning",
    type: "Lidl Express",
    address: "Flensburg, Süd",
  },
  {
    id: 272,
    name: "Lidl Express Flensburg-West",
    lat: 54.7937,
    lng: 9.4469,
    score: 3.2,
    status: "danger",
    type: "Lidl Express",
    address: "Flensburg, West",
  },
  {
    id: 273,
    name: "Lidl Flensburg-Friesischer Berg",
    lat: 54.7937,
    lng: 9.4469,
    score: 4.5,
    status: "success",
    type: "Lidl",
    address: "Flensburg, Friesischer Berg",
  },
  {
    id: 274,
    name: "Lidl Neumünster-Innenstadt",
    lat: 54.0712,
    lng: 9.9819,
    score: 4.3,
    status: "success",
    type: "Lidl",
    address: "Neumünster, Innenstadt",
  },
  {
    id: 275,
    name: "Lidl XL Neumünster-Nord",
    lat: 54.0712,
    lng: 9.9819,
    score: 3.8,
    status: "warning",
    type: "Lidl XL",
    address: "Neumünster, Nord",
  },
  {
    id: 276,
    name: "Lidl XL Neumünster-Süd",
    lat: 54.0712,
    lng: 9.9819,
    score: 2.5,
    status: "danger",
    type: "Lidl XL",
    address: "Neumünster, Süd",
  },
  {
    id: 277,
    name: "Lidl XL Neumünster-Gartenstadt",
    lat: 54.0712,
    lng: 9.9819,
    score: 3.4,
    status: "warning",
    type: "Lidl XL",
    address: "Neumünster, Gartenstadt",
  },
  {
    id: 278,
    name: "Lidl Schwerin-Altstadt",
    lat: 53.6355,
    lng: 11.4012,
    score: 3.5,
    status: "warning",
    type: "Lidl",
    address: "Schwerin, Altstadt",
  },
  {
    id: 279,
    name: "Lidl Express Schwerin-West",
    lat: 53.6355,
    lng: 11.4012,
    score: 4.3,
    status: "success",
    type: "Lidl Express",
    address: "Schwerin, West",
  },
  {
    id: 280,
    name: "Lidl XL Schwerin-Nord",
    lat: 53.6355,
    lng: 11.4012,
    score: 3.9,
    status: "warning",
    type: "Lidl XL",
    address: "Schwerin, Nord",
  },
  {
    id: 281,
    name: "Lidl Schwerin-Lankow",
    lat: 53.6355,
    lng: 11.4012,
    score: 3.9,
    status: "warning",
    type: "Lidl",
    address: "Schwerin, Lankow",
  },
  {
    id: 282,
    name: "Lidl Schwerin-Werdervorstadt",
    lat: 53.6355,
    lng: 11.4012,
    score: 3.7,
    status: "warning",
    type: "Lidl",
    address: "Schwerin, Werdervorstadt",
  },
  {
    id: 283,
    name: "Lidl XL Stralsund-Altstadt",
    lat: 54.3096,
    lng: 13.0818,
    score: 4.5,
    status: "success",
    type: "Lidl XL",
    address: "Stralsund, Altstadt",
  },
  {
    id: 284,
    name: "Lidl Express Stralsund-Tribseer",
    lat: 54.3096,
    lng: 13.0818,
    score: 3.7,
    status: "warning",
    type: "Lidl Express",
    address: "Stralsund, Tribseer",
  },
  {
    id: 285,
    name: "Lidl XL Stralsund-Grünhufe",
    lat: 54.3096,
    lng: 13.0818,
    score: 3.9,
    status: "warning",
    type: "Lidl XL",
    address: "Stralsund, Grünhufe",
  },
,
  {
    id: 286,
    name: "Lidl XL Debrecen-Hajdúszoboszló",
    lat: 47.5458,
    lng: 21.6415,
    score: 2.6,
    status: "danger",
    type: "Lidl XL",
    address: "Debrecen, Hajdúszoboszló",
  },
  {
    id: 287,
    name: "Lidl XL Lucerne-Altstadt",
    lat: 47.0599,
    lng: 8.2879,
    score: 3.7,
    status: "warning",
    type: "Lidl XL",
    address: "Lucerne, Altstadt",
  },
  {
    id: 288,
    name: "Lidl XL Funchal-Santo António",
    lat: 32.6469,
    lng: -16.9247,
    score: 4.3,
    status: "success",
    type: "Lidl XL",
    address: "Funchal, Santo António",
  },
  {
    id: 289,
    name: "Lidl Edinburgh-Newington",
    lat: 55.9379,
    lng: -3.2098,
    score: 5,
    status: "success",
    type: "Lidl",
    address: "Edinburgh, Newington",
  },
  {
    id: 290,
    name: "Lidl Express Paris-15e",
    lat: 48.8688,
    lng: 2.35,
    score: 3.9,
    status: "warning",
    type: "Lidl Express",
    address: "Paris, 15e",
  },
  {
    id: 291,
    name: "Lidl Express Nîmes-Valdegour",
    lat: 43.8133,
    lng: 4.3848,
    score: 4.1,
    status: "warning",
    type: "Lidl Express",
    address: "Nîmes, Valdegour",
  },
  {
    id: 292,
    name: "Lidl Nice-Cimiez",
    lat: 43.7163,
    lng: 7.274,
    score: 4.5,
    status: "success",
    type: "Lidl",
    address: "Nice, Cimiez",
  },
  {
    id: 293,
    name: "Lidl XL Bristol-Horfield",
    lat: 51.432,
    lng: -2.5962,
    score: 3.2,
    status: "danger",
    type: "Lidl XL",
    address: "Bristol, Horfield",
  },
  {
    id: 294,
    name: "Lidl Express Milan-Baggio",
    lat: 45.4675,
    lng: 9.1662,
    score: 3.7,
    status: "warning",
    type: "Lidl Express",
    address: "Milan, Baggio",
  },
  {
    id: 295,
    name: "Lidl Washington-Navy Yard",
    lat: 38.8825,
    lng: -77.0488,
    score: 4.9,
    status: "success",
    type: "Lidl",
    address: "Washington, Navy Yard",
  },
  {
    id: 296,
    name: "Lidl XL Venice-Mestre",
    lat: 45.4558,
    lng: 12.3173,
    score: 3.5,
    status: "warning",
    type: "Lidl XL",
    address: "Venice, Mestre",
  },
  {
    id: 297,
    name: "Lidl XL Haarlem-Schalkwijk",
    lat: 52.3732,
    lng: 4.6346,
    score: 4.6,
    status: "success",
    type: "Lidl XL",
    address: "Haarlem, Schalkwijk",
  },
  {
    id: 298,
    name: "Lidl Express Oradea-Centru",
    lat: 47.059,
    lng: 21.9256,
    score: 3.7,
    status: "warning",
    type: "Lidl Express",
    address: "Oradea, Centru",
  },
  {
    id: 299,
    name: "Lidl Express St. Gallen-Zentrum",
    lat: 47.4493,
    lng: 9.3789,
    score: 4.8,
    status: "success",
    type: "Lidl Express",
    address: "St. Gallen, Zentrum",
  },
  {
    id: 300,
    name: "Lidl Express Milan-Bicocca",
    lat: 45.4628,
    lng: 9.2114,
    score: 4.7,
    status: "success",
    type: "Lidl Express",
    address: "Milan, Bicocca",
  },
  {
    id: 301,
    name: "Lidl Brighton-Preston Park",
    lat: 50.831,
    lng: -0.1218,
    score: 3.9,
    status: "warning",
    type: "Lidl",
    address: "Brighton, Preston Park",
  },
  {
    id: 302,
    name: "Lidl XL Bilbao-Abando",
    lat: 43.262,
    lng: -2.9546,
    score: 4.2,
    status: "success",
    type: "Lidl XL",
    address: "Bilbao, Abando",
  },
  {
    id: 303,
    name: "Lidl Express Limerick-Raheen",
    lat: 52.6536,
    lng: -8.6136,
    score: 3.4,
    status: "warning",
    type: "Lidl Express",
    address: "Limerick, Raheen",
  },
  {
    id: 304,
    name: "Lidl Limerick-Roxborough",
    lat: 52.6408,
    lng: -8.6429,
    score: 3.6,
    status: "warning",
    type: "Lidl",
    address: "Limerick, Roxborough",
  },
  {
    id: 305,
    name: "Lidl Express Torun-Bydgoskie",
    lat: 53.0079,
    lng: 18.5803,
    score: 3,
    status: "danger",
    type: "Lidl Express",
    address: "Torun, Bydgoskie",
  },
  {
    id: 306,
    name: "Lidl Express Baltimore-Fells Point",
    lat: 39.3135,
    lng: -76.588,
    score: 4.8,
    status: "success",
    type: "Lidl Express",
    address: "Baltimore, Fells Point",
  },
  {
    id: 307,
    name: "Lidl Express Funchal-Monte",
    lat: 32.6526,
    lng: -16.909,
    score: 3.7,
    status: "warning",
    type: "Lidl Express",
    address: "Funchal, Monte",
  },
  {
    id: 308,
    name: "Lidl Express Sofia-Vitosha",
    lat: 42.6904,
    lng: 23.3137,
    score: 3.7,
    status: "warning",
    type: "Lidl Express",
    address: "Sofia, Vitosha",
  },
  {
    id: 309,
    name: "Lidl Newcastle-Byker",
    lat: 54.9836,
    lng: -1.6067,
    score: 2.7,
    status: "danger",
    type: "Lidl",
    address: "Newcastle, Byker",
  },
  {
    id: 310,
    name: "Lidl Rome-Tiburtino",
    lat: 41.918,
    lng: 12.4887,
    score: 3.9,
    status: "warning",
    type: "Lidl",
    address: "Rome, Tiburtino",
  },
  {
    id: 311,
    name: "Lidl XL Nantes-Chantenay",
    lat: 47.2327,
    lng: -1.5519,
    score: 3.7,
    status: "warning",
    type: "Lidl XL",
    address: "Nantes, Chantenay",
  },
  {
    id: 312,
    name: "Lidl Express Glasgow-Southside",
    lat: 55.8454,
    lng: -4.2689,
    score: 4.6,
    status: "success",
    type: "Lidl Express",
    address: "Glasgow, Southside",
  },
  {
    id: 313,
    name: "Lidl Galway-Newcastle",
    lat: 53.263,
    lng: -9.045,
    score: 4.1,
    status: "warning",
    type: "Lidl",
    address: "Galway, Newcastle",
  },
  {
    id: 314,
    name: "Lidl Express Timisoara-Elisabetin",
    lat: 45.769,
    lng: 21.1973,
    score: 3.4,
    status: "danger",
    type: "Lidl Express",
    address: "Timisoara, Elisabetin",
  },
  {
    id: 315,
    name: "Lidl Budapest-District VIII",
    lat: 47.4855,
    lng: 19.0581,
    score: 3.4,
    status: "warning",
    type: "Lidl",
    address: "Budapest, District VIII",
  },
  {
    id: 316,
    name: "Lidl Ljubljana-Centrum",
    lat: 46.0553,
    lng: 14.517,
    score: 2.9,
    status: "danger",
    type: "Lidl",
    address: "Ljubljana, Centrum",
  },
  {
    id: 317,
    name: "Lidl XL Rotterdam-Pernis",
    lat: 51.9114,
    lng: 4.4932,
    score: 3.3,
    status: "danger",
    type: "Lidl XL",
    address: "Rotterdam, Pernis",
  },
  {
    id: 318,
    name: "Lidl XL Warsaw-Wawer",
    lat: 52.2477,
    lng: 20.9951,
    score: 4.5,
    status: "success",
    type: "Lidl XL",
    address: "Warsaw, Wawer",
  },
  {
    id: 319,
    name: "Lidl Express Marseille-16e",
    lat: 43.2889,
    lng: 5.3697,
    score: 3.6,
    status: "warning",
    type: "Lidl Express",
    address: "Marseille, 16e",
  },
  {
    id: 320,
    name: "Lidl XL Leeds-Hyde Park",
    lat: 53.8143,
    lng: -1.5734,
    score: 3.4,
    status: "danger",
    type: "Lidl XL",
    address: "Leeds, Hyde Park",
  },
  {
    id: 321,
    name: "Lidl Thessaloniki-Centre",
    lat: 40.6191,
    lng: 22.9375,
    score: 3.6,
    status: "warning",
    type: "Lidl",
    address: "Thessaloniki, Centre",
  },
  {
    id: 322,
    name: "Lidl Express Amsterdam-Noord",
    lat: 52.3487,
    lng: 4.9231,
    score: 4.6,
    status: "success",
    type: "Lidl Express",
    address: "Amsterdam, Noord",
  },
  {
    id: 323,
    name: "Lidl Basel-St. Johann",
    lat: 47.5542,
    lng: 7.5714,
    score: 3.4,
    status: "warning",
    type: "Lidl",
    address: "Basel, St. Johann",
  },
  {
    id: 324,
    name: "Lidl Barcelona-Sant Martí",
    lat: 41.3628,
    lng: 2.1745,
    score: 4.3,
    status: "success",
    type: "Lidl",
    address: "Barcelona, Sant Martí",
  },
  {
    id: 325,
    name: "Lidl Marseille-1er",
    lat: 43.3132,
    lng: 5.3693,
    score: 4.3,
    status: "success",
    type: "Lidl",
    address: "Marseille, 1er",
  },
  {
    id: 326,
    name: "Lidl Setubal-São Julião",
    lat: 38.5153,
    lng: -8.8771,
    score: 4.5,
    status: "success",
    type: "Lidl",
    address: "Setubal, São Julião",
  },
  {
    id: 327,
    name: "Lidl Palma-Ponent",
    lat: 39.5562,
    lng: 2.6542,
    score: 3.8,
    status: "warning",
    type: "Lidl",
    address: "Palma, Ponent",
  },
  {
    id: 328,
    name: "Lidl Express Antwerp-Ekeren",
    lat: 51.2038,
    lng: 4.394,
    score: 4.6,
    status: "success",
    type: "Lidl Express",
    address: "Antwerp, Ekeren",
  },
  {
    id: 329,
    name: "Lidl Sofia-Nadezhda",
    lat: 42.7054,
    lng: 23.3166,
    score: 4.6,
    status: "success",
    type: "Lidl",
    address: "Sofia, Nadezhda",
  },
  {
    id: 330,
    name: "Lidl XL Lublin-Węglin",
    lat: 51.2261,
    lng: 22.5571,
    score: 3,
    status: "danger",
    type: "Lidl XL",
    address: "Lublin, Węglin",
  },
  {
    id: 331,
    name: "Lidl Express Wels-Zentrum",
    lat: 48.1394,
    lng: 14.0408,
    score: 3.3,
    status: "danger",
    type: "Lidl Express",
    address: "Wels, Zentrum",
  },
  {
    id: 332,
    name: "Lidl Genoa-Centro",
    lat: 44.43,
    lng: 8.9315,
    score: 4,
    status: "warning",
    type: "Lidl",
    address: "Genoa, Centro",
  },
  {
    id: 333,
    name: "Lidl Poznan-Stare Miasto",
    lat: 52.3844,
    lng: 16.913,
    score: 4.4,
    status: "success",
    type: "Lidl",
    address: "Poznan, Stare Miasto",
  },
  {
    id: 334,
    name: "Lidl Express Leeds-City Centre",
    lat: 53.7809,
    lng: -1.567,
    score: 4.9,
    status: "success",
    type: "Lidl Express",
    address: "Leeds, City Centre",
  },
  {
    id: 335,
    name: "Lidl XL Dundalk-Castletown",
    lat: 54.0146,
    lng: -6.4109,
    score: 3.9,
    status: "warning",
    type: "Lidl XL",
    address: "Dundalk, Castletown",
  },
  {
    id: 336,
    name: "Lidl Express Zagreb-Stenjevec",
    lat: 45.8392,
    lng: 15.9974,
    score: 4.9,
    status: "success",
    type: "Lidl Express",
    address: "Zagreb, Stenjevec",
  },
  {
    id: 337,
    name: "Lidl Express Sofia-Mladost",
    lat: 42.6967,
    lng: 23.3219,
    score: 3,
    status: "danger",
    type: "Lidl Express",
    address: "Sofia, Mladost",
  },
  {
    id: 338,
    name: "Lidl XL Palma-Nord",
    lat: 39.5469,
    lng: 2.6571,
    score: 3.8,
    status: "warning",
    type: "Lidl XL",
    address: "Palma, Nord",
  },
  {
    id: 339,
    name: "Lidl Funchal-São Martinho",
    lat: 32.6675,
    lng: -16.9255,
    score: 3.9,
    status: "warning",
    type: "Lidl",
    address: "Funchal, São Martinho",
  },
  {
    id: 340,
    name: "Lidl XL Amsterdam-West",
    lat: 52.3749,
    lng: 4.8963,
    score: 4.4,
    status: "success",
    type: "Lidl XL",
    address: "Amsterdam, West",
  },
  {
    id: 341,
    name: "Lidl Express Sheffield-Broomhill",
    lat: 53.3808,
    lng: -1.4751,
    score: 3.6,
    status: "warning",
    type: "Lidl Express",
    address: "Sheffield, Broomhill",
  },
  {
    id: 342,
    name: "Lidl Enschede-Centrum",
    lat: 52.2314,
    lng: 6.9085,
    score: 3.2,
    status: "danger",
    type: "Lidl",
    address: "Enschede, Centrum",
  },
  {
    id: 343,
    name: "Lidl Express Warsaw-Ochota",
    lat: 52.2167,
    lng: 21.0047,
    score: 3.1,
    status: "danger",
    type: "Lidl Express",
    address: "Warsaw, Ochota",
  },
  {
    id: 344,
    name: "Lidl XL Miskolc-Avas",
    lat: 48.0803,
    lng: 20.7751,
    score: 4.7,
    status: "success",
    type: "Lidl XL",
    address: "Miskolc, Avas",
  },
  {
    id: 345,
    name: "Lidl Express Prague-Smíchov",
    lat: 50.0744,
    lng: 14.4197,
    score: 4.2,
    status: "success",
    type: "Lidl Express",
    address: "Prague, Smíchov",
  },
  {
    id: 346,
    name: "Lidl Express Washington-Georgetown",
    lat: 38.916,
    lng: -77.0163,
    score: 4.7,
    status: "success",
    type: "Lidl Express",
    address: "Washington, Georgetown",
  },
  {
    id: 347,
    name: "Lidl Express Antwerp-Centrum",
    lat: 51.2101,
    lng: 4.4036,
    score: 4.9,
    status: "success",
    type: "Lidl Express",
    address: "Antwerp, Centrum",
  },
  {
    id: 348,
    name: "Lidl Brasov-Astra",
    lat: 45.6201,
    lng: 25.5659,
    score: 3.8,
    status: "warning",
    type: "Lidl",
    address: "Brasov, Astra",
  },
  {
    id: 349,
    name: "Lidl Express Paris-12e",
    lat: 48.8704,
    lng: 2.3737,
    score: 3.6,
    status: "warning",
    type: "Lidl Express",
    address: "Paris, 12e",
  },
  {
    id: 350,
    name: "Lidl XL Bologna-Santo Stefano",
    lat: 44.4938,
    lng: 11.3312,
    score: 3.8,
    status: "warning",
    type: "Lidl XL",
    address: "Bologna, Santo Stefano",
  },
  {
    id: 351,
    name: "Lidl Express Vigo-Lavadores",
    lat: 42.2651,
    lng: -8.7436,
    score: 4.7,
    status: "success",
    type: "Lidl Express",
    address: "Vigo, Lavadores",
  },
  {
    id: 352,
    name: "Lidl XL Baltimore-Mount Vernon",
    lat: 39.2878,
    lng: -76.6139,
    score: 3.6,
    status: "warning",
    type: "Lidl XL",
    address: "Baltimore, Mount Vernon",
  },
  {
    id: 353,
    name: "Lidl XL Constanta-Lazu",
    lat: 44.1439,
    lng: 28.6492,
    score: 4.3,
    status: "success",
    type: "Lidl XL",
    address: "Constanta, Lazu",
  },
  {
    id: 354,
    name: "Lidl XL Namur-Centre",
    lat: 50.472,
    lng: 4.8689,
    score: 4.8,
    status: "success",
    type: "Lidl XL",
    address: "Namur, Centre",
  },
  {
    id: 355,
    name: "Lidl Cordoba-Centro",
    lat: 37.8664,
    lng: -4.7983,
    score: 3.7,
    status: "warning",
    type: "Lidl",
    address: "Cordoba, Centro",
  },
  {
    id: 356,
    name: "Lidl XL Rome-Trastevere",
    lat: 41.8901,
    lng: 12.4984,
    score: 3.2,
    status: "danger",
    type: "Lidl XL",
    address: "Rome, Trastevere",
  },
  {
    id: 357,
    name: "Lidl XL Charleroi-Marcinelle",
    lat: 50.4207,
    lng: 4.4571,
    score: 4.6,
    status: "success",
    type: "Lidl XL",
    address: "Charleroi, Marcinelle",
  },
  {
    id: 358,
    name: "Lidl Express New York-Harlem",
    lat: 40.6991,
    lng: -74.0301,
    score: 4.8,
    status: "success",
    type: "Lidl Express",
    address: "New York, Harlem",
  },
  {
    id: 359,
    name: "Lidl Naples-Centro Storico",
    lat: 40.8482,
    lng: 14.2601,
    score: 4.3,
    status: "success",
    type: "Lidl",
    address: "Naples, Centro Storico",
  },
  {
    id: 360,
    name: "Lidl Dublin-Raheny",
    lat: 53.3576,
    lng: -6.242,
    score: 3.5,
    status: "warning",
    type: "Lidl",
    address: "Dublin, Raheny",
  },
  {
    id: 361,
    name: "Lidl XL Rome-Aurelio",
    lat: 41.9137,
    lng: 12.5058,
    score: 4.8,
    status: "success",
    type: "Lidl XL",
    address: "Rome, Aurelio",
  },
  {
    id: 362,
    name: "Lidl XL Dornbirn-Zentrum",
    lat: 47.4073,
    lng: 9.7556,
    score: 3.5,
    status: "warning",
    type: "Lidl XL",
    address: "Dornbirn, Zentrum",
  },
  {
    id: 363,
    name: "Lidl XL Zaanstad-Wormerveer",
    lat: 52.4524,
    lng: 4.8135,
    score: 3.9,
    status: "warning",
    type: "Lidl XL",
    address: "Zaanstad, Wormerveer",
  },
  {
    id: 364,
    name: "Lidl Express Basel-Grossbasel",
    lat: 47.5446,
    lng: 7.5697,
    score: 4.6,
    status: "success",
    type: "Lidl Express",
    address: "Basel, Grossbasel",
  },
  {
    id: 365,
    name: "Lidl The Hague-Laak",
    lat: 52.0659,
    lng: 4.2955,
    score: 3.4,
    status: "warning",
    type: "Lidl",
    address: "The Hague, Laak",
  },
  {
    id: 366,
    name: "Lidl Express Villeurbanne-Tonkin",
    lat: 45.7478,
    lng: 4.8583,
    score: 4.3,
    status: "success",
    type: "Lidl Express",
    address: "Villeurbanne, Tonkin",
  },
  {
    id: 367,
    name: "Lidl Express Katowice-Koszutka",
    lat: 50.2762,
    lng: 19.0317,
    score: 4,
    status: "warning",
    type: "Lidl Express",
    address: "Katowice, Koszutka",
  },
  {
    id: 368,
    name: "Lidl XL Varna-Asparuhovo",
    lat: 43.2112,
    lng: 27.9001,
    score: 4.2,
    status: "warning",
    type: "Lidl XL",
    address: "Varna, Asparuhovo",
  },
  {
    id: 369,
    name: "Lidl XL Czestochowa-Tysiąclecie",
    lat: 50.8102,
    lng: 19.1447,
    score: 3.1,
    status: "danger",
    type: "Lidl XL",
    address: "Czestochowa, Tysiąclecie",
  },
  {
    id: 370,
    name: "Lidl Celje-Centrum",
    lat: 46.2461,
    lng: 15.2795,
    score: 3.9,
    status: "warning",
    type: "Lidl",
    address: "Celje, Centrum",
  },
  {
    id: 371,
    name: "Lidl Madrid-Centro",
    lat: 40.4321,
    lng: -3.6914,
    score: 3.2,
    status: "danger",
    type: "Lidl",
    address: "Madrid, Centro",
  },
  {
    id: 372,
    name: "Lidl XL Geneva-Plainpalais",
    lat: 46.2199,
    lng: 6.1641,
    score: 3.2,
    status: "danger",
    type: "Lidl XL",
    address: "Geneva, Plainpalais",
  },
  {
    id: 373,
    name: "Lidl XL Barcelona-Ciutat Vella",
    lat: 41.3896,
    lng: 2.1904,
    score: 2.7,
    status: "danger",
    type: "Lidl XL",
    address: "Barcelona, Ciutat Vella",
  },
  {
    id: 374,
    name: "Lidl Express Oradea-Rogerius",
    lat: 47.0633,
    lng: 21.9153,
    score: 4.6,
    status: "success",
    type: "Lidl Express",
    address: "Oradea, Rogerius",
  },
  {
    id: 375,
    name: "Lidl Nîmes-Centre",
    lat: 43.8504,
    lng: 4.3568,
    score: 4.2,
    status: "warning",
    type: "Lidl",
    address: "Nîmes, Centre",
  },
  {
    id: 376,
    name: "Lidl Prague-Karlín",
    lat: 50.0818,
    lng: 14.4362,
    score: 4.5,
    status: "success",
    type: "Lidl",
    address: "Prague, Karlín",
  },
  {
    id: 377,
    name: "Lidl Express Liverpool-Southport",
    lat: 53.4303,
    lng: -2.9951,
    score: 3.7,
    status: "warning",
    type: "Lidl Express",
    address: "Liverpool, Southport",
  },
  {
    id: 378,
    name: "Lidl Express Birmingham-Solihull",
    lat: 52.487,
    lng: -1.8827,
    score: 4.7,
    status: "success",
    type: "Lidl Express",
    address: "Birmingham, Solihull",
  },
  {
    id: 379,
    name: "Lidl Express Drogheda-South",
    lat: 53.7155,
    lng: -6.3699,
    score: 3.8,
    status: "warning",
    type: "Lidl Express",
    address: "Drogheda, South",
  },
  {
    id: 380,
    name: "Lidl Sosnowiec-Maczki",
    lat: 50.3095,
    lng: 19.0885,
    score: 4.1,
    status: "warning",
    type: "Lidl",
    address: "Sosnowiec, Maczki",
  },
  {
    id: 381,
    name: "Lidl Express Osijek-Centar",
    lat: 45.578,
    lng: 18.6718,
    score: 4.5,
    status: "success",
    type: "Lidl Express",
    address: "Osijek, Centar",
  },
  {
    id: 382,
    name: "Lidl Express Paris-6e",
    lat: 48.8814,
    lng: 2.3311,
    score: 4.5,
    status: "success",
    type: "Lidl Express",
    address: "Paris, 6e",
  },
  {
    id: 383,
    name: "Lidl XL Venice-Castello",
    lat: 45.4202,
    lng: 12.2976,
    score: 5,
    status: "success",
    type: "Lidl XL",
    address: "Venice, Castello",
  },
  {
    id: 384,
    name: "Lidl Express Eindhoven-Stratum",
    lat: 51.43,
    lng: 5.4873,
    score: 4.7,
    status: "success",
    type: "Lidl Express",
    address: "Eindhoven, Stratum",
  },
  {
    id: 385,
    name: "Lidl Lisbon-Alfama",
    lat: 38.7374,
    lng: -9.1234,
    score: 4.9,
    status: "success",
    type: "Lidl",
    address: "Lisbon, Alfama",
  },
  {
    id: 386,
    name: "Lidl Marseille-14e",
    lat: 43.2927,
    lng: 5.3471,
    score: 3.6,
    status: "warning",
    type: "Lidl",
    address: "Marseille, 14e",
  },
  {
    id: 387,
    name: "Lidl Bordeaux-Cauderan",
    lat: 44.8252,
    lng: -0.597,
    score: 3.5,
    status: "warning",
    type: "Lidl",
    address: "Bordeaux, Cauderan",
  },
  {
    id: 388,
    name: "Lidl Express Porto-Cedofeita",
    lat: 41.1337,
    lng: -8.6509,
    score: 2.8,
    status: "danger",
    type: "Lidl Express",
    address: "Porto, Cedofeita",
  },
  {
    id: 389,
    name: "Lidl Express Lublin-Bronowice",
    lat: 51.2667,
    lng: 22.5508,
    score: 3.5,
    status: "warning",
    type: "Lidl Express",
    address: "Lublin, Bronowice",
  },
  {
    id: 390,
    name: "Lidl Prague-Žižkov",
    lat: 50.0883,
    lng: 14.4525,
    score: 2.6,
    status: "danger",
    type: "Lidl",
    address: "Prague, Žižkov",
  },
  {
    id: 391,
    name: "Lidl Budapest-District X",
    lat: 47.5183,
    lng: 19.0434,
    score: 4.3,
    status: "success",
    type: "Lidl",
    address: "Budapest, District X",
  },
  {
    id: 392,
    name: "Lidl Express Varna-Chayka",
    lat: 43.2389,
    lng: 27.9099,
    score: 3.3,
    status: "danger",
    type: "Lidl Express",
    address: "Varna, Chayka",
  },
  {
    id: 393,
    name: "Lidl Express Naples-Vomero",
    lat: 40.8344,
    lng: 14.2816,
    score: 4.1,
    status: "warning",
    type: "Lidl Express",
    address: "Naples, Vomero",
  },
  {
    id: 394,
    name: "Lidl XL Madrid-Barajas",
    lat: 40.4288,
    lng: -3.7034,
    score: 3.5,
    status: "warning",
    type: "Lidl XL",
    address: "Madrid, Barajas",
  },
  {
    id: 395,
    name: "Lidl Express Seville-Santa Cruz",
    lat: 37.3967,
    lng: -5.9992,
    score: 4.7,
    status: "success",
    type: "Lidl Express",
    address: "Seville, Santa Cruz",
  },
  {
    id: 396,
    name: "Lidl XL Waterford-City Centre",
    lat: 52.2696,
    lng: -7.1237,
    score: 4.9,
    status: "success",
    type: "Lidl XL",
    address: "Waterford, City Centre",
  },
  {
    id: 397,
    name: "Lidl Express Athens-Peristeri",
    lat: 37.9707,
    lng: 23.7183,
    score: 4.7,
    status: "success",
    type: "Lidl Express",
    address: "Athens, Peristeri",
  },
  {
    id: 398,
    name: "Lidl XL Newcastle-West End",
    lat: 54.9598,
    lng: -1.6298,
    score: 3.8,
    status: "warning",
    type: "Lidl XL",
    address: "Newcastle, West End",
  },
  {
    id: 399,
    name: "Lidl Rome-Rebibbia",
    lat: 41.8942,
    lng: 12.4826,
    score: 3.6,
    status: "warning",
    type: "Lidl",
    address: "Rome, Rebibbia",
  },
  {
    id: 400,
    name: "Lidl Express Liberec-Centrum",
    lat: 50.7472,
    lng: 15.0357,
    score: 4.4,
    status: "success",
    type: "Lidl Express",
    address: "Liberec, Centrum",
  },
  {
    id: 401,
    name: "Lidl Express Granada-Chana",
    lat: 37.1719,
    lng: -3.5742,
    score: 4.7,
    status: "success",
    type: "Lidl Express",
    address: "Granada, Chana",
  },
  {
    id: 402,
    name: "Lidl Graz-Andritz",
    lat: 47.0535,
    lng: 15.4362,
    score: 3.9,
    status: "warning",
    type: "Lidl",
    address: "Graz, Andritz",
  },
  {
    id: 403,
    name: "Lidl XL Bari-Carrassi",
    lat: 41.1202,
    lng: 16.8672,
    score: 4,
    status: "warning",
    type: "Lidl XL",
    address: "Bari, Carrassi",
  },
  {
    id: 404,
    name: "Lidl XL Vienna-Favoriten",
    lat: 48.2253,
    lng: 16.3591,
    score: 4.4,
    status: "success",
    type: "Lidl XL",
    address: "Vienna, Favoriten",
  },
  {
    id: 405,
    name: "Lidl Express Olomouc-Centrum",
    lat: 49.6068,
    lng: 17.2391,
    score: 3,
    status: "danger",
    type: "Lidl Express",
    address: "Olomouc, Centrum",
  },
  {
    id: 406,
    name: "Lidl Szczecin-Dąbie",
    lat: 53.4113,
    lng: 14.5512,
    score: 3.7,
    status: "warning",
    type: "Lidl",
    address: "Szczecin, Dąbie",
  },
  {
    id: 407,
    name: "Lidl Szczecin-Pomorzany",
    lat: 53.4118,
    lng: 14.547,
    score: 5,
    status: "success",
    type: "Lidl",
    address: "Szczecin, Pomorzany",
  },
  {
    id: 408,
    name: "Lidl Express Lublin-Tatary",
    lat: 51.2496,
    lng: 22.579,
    score: 4.7,
    status: "success",
    type: "Lidl Express",
    address: "Lublin, Tatary",
  },
  {
    id: 409,
    name: "Lidl Express Granada-Albaicín",
    lat: 37.191,
    lng: -3.5745,
    score: 4.5,
    status: "success",
    type: "Lidl Express",
    address: "Granada, Albaicín",
  },
  {
    id: 410,
    name: "Lidl Express Cardiff-Cathays",
    lat: 51.5044,
    lng: -3.1847,
    score: 4.2,
    status: "success",
    type: "Lidl Express",
    address: "Cardiff, Cathays",
  },
  {
    id: 411,
    name: "Lidl Express Toulon-Centre",
    lat: 43.1294,
    lng: 5.9184,
    score: 3.9,
    status: "warning",
    type: "Lidl Express",
    address: "Toulon, Centre",
  },
  {
    id: 412,
    name: "Lidl Budapest-Pest",
    lat: 47.481,
    lng: 19.0649,
    score: 4.7,
    status: "success",
    type: "Lidl",
    address: "Budapest, Pest",
  },
  {
    id: 413,
    name: "Lidl Express Eindhoven-Centrum",
    lat: 51.4188,
    lng: 5.47,
    score: 4,
    status: "warning",
    type: "Lidl Express",
    address: "Eindhoven, Centrum",
  },
  {
    id: 414,
    name: "Lidl Express Rome-Trieste",
    lat: 41.8979,
    lng: 12.5011,
    score: 3.2,
    status: "danger",
    type: "Lidl Express",
    address: "Rome, Trieste",
  },
  {
    id: 415,
    name: "Lidl Express Rome-Monti",
    lat: 41.9147,
    lng: 12.4834,
    score: 4.4,
    status: "success",
    type: "Lidl Express",
    address: "Rome, Monti",
  },
  {
    id: 416,
    name: "Lidl XL Leuven-Centrum",
    lat: 50.8714,
    lng: 4.7185,
    score: 5,
    status: "success",
    type: "Lidl XL",
    address: "Leuven, Centrum",
  },
  {
    id: 417,
    name: "Lidl Express Lyon-8e",
    lat: 45.7796,
    lng: 4.8173,
    score: 4.5,
    status: "success",
    type: "Lidl Express",
    address: "Lyon, 8e",
  },
  {
    id: 418,
    name: "Lidl Express Murcia-Sur",
    lat: 37.9913,
    lng: -1.1236,
    score: 3.6,
    status: "warning",
    type: "Lidl Express",
    address: "Murcia, Sur",
  },
  {
    id: 419,
    name: "Lidl Express Nijmegen-Noord",
    lat: 51.863,
    lng: 5.8377,
    score: 3.6,
    status: "warning",
    type: "Lidl Express",
    address: "Nijmegen, Noord",
  },
  {
    id: 420,
    name: "Lidl Rome-Nomentano",
    lat: 41.8859,
    lng: 12.4807,
    score: 3.7,
    status: "warning",
    type: "Lidl",
    address: "Rome, Nomentano",
  },
  {
    id: 421,
    name: "Lidl Białystok-Słoneczny Stok",
    lat: 53.1362,
    lng: 23.1486,
    score: 3.3,
    status: "danger",
    type: "Lidl",
    address: "Białystok, Słoneczny Stok",
  },
  {
    id: 422,
    name: "Lidl XL Sheffield-Nether Edge",
    lat: 53.4051,
    lng: -1.4751,
    score: 2.8,
    status: "danger",
    type: "Lidl XL",
    address: "Sheffield, Nether Edge",
  },
  {
    id: 423,
    name: "Lidl Express Ceske Budejovice-Suché Vrbné",
    lat: 48.9586,
    lng: 14.4529,
    score: 4.4,
    status: "success",
    type: "Lidl Express",
    address: "Ceske Budejovice, Suché Vrbné",
  },
  {
    id: 424,
    name: "Lidl Express Wels-Noitzmühle",
    lat: 48.1617,
    lng: 14.0505,
    score: 4.1,
    status: "warning",
    type: "Lidl Express",
    address: "Wels, Noitzmühle",
  },
  {
    id: 425,
    name: "Lidl Express Poznan-Ławica",
    lat: 52.4179,
    lng: 16.9003,
    score: 2.7,
    status: "danger",
    type: "Lidl Express",
    address: "Poznan, Ławica",
  },
  {
    id: 426,
    name: "Lidl XL Funchal-Centro",
    lat: 32.6705,
    lng: -16.9141,
    score: 4.6,
    status: "success",
    type: "Lidl XL",
    address: "Funchal, Centro",
  },
  {
    id: 427,
    name: "Lidl Philadelphia-West Philly",
    lat: 39.9751,
    lng: -75.1621,
    score: 3.9,
    status: "warning",
    type: "Lidl",
    address: "Philadelphia, West Philly",
  },
  {
    id: 428,
    name: "Lidl Faro-Penha",
    lat: 37.008,
    lng: -7.9491,
    score: 4.3,
    status: "success",
    type: "Lidl",
    address: "Faro, Penha",
  },
  {
    id: 429,
    name: "Lidl Eindhoven-Woensel",
    lat: 51.427,
    lng: 5.4734,
    score: 3.8,
    status: "warning",
    type: "Lidl",
    address: "Eindhoven, Woensel",
  },
  {
    id: 430,
    name: "Lidl XL Valencia-Pobles de l'Oest",
    lat: 39.4791,
    lng: -0.3948,
    score: 2.6,
    status: "danger",
    type: "Lidl XL",
    address: "Valencia, Pobles de l'Oest",
  },
  {
    id: 431,
    name: "Lidl Grenoble-Echirolles",
    lat: 45.2044,
    lng: 5.7182,
    score: 3.7,
    status: "warning",
    type: "Lidl",
    address: "Grenoble, Echirolles",
  },
  {
    id: 432,
    name: "Lidl XL Seville-Bellavista",
    lat: 37.3693,
    lng: -6.0019,
    score: 2.9,
    status: "danger",
    type: "Lidl XL",
    address: "Seville, Bellavista",
  },
  {
    id: 433,
    name: "Lidl Zaragoza-Torrero",
    lat: 41.6591,
    lng: -0.8655,
    score: 4,
    status: "warning",
    type: "Lidl",
    address: "Zaragoza, Torrero",
  },
  {
    id: 434,
    name: "Lidl XL Prague-Praha 3",
    lat: 50.0763,
    lng: 14.4288,
    score: 4.4,
    status: "success",
    type: "Lidl XL",
    address: "Prague, Praha 3",
  },
  {
    id: 435,
    name: "Lidl Lyon-Part-Dieu",
    lat: 45.7652,
    lng: 4.8292,
    score: 5,
    status: "success",
    type: "Lidl",
    address: "Lyon, Part-Dieu",
  },
  {
    id: 436,
    name: "Lidl Express Manchester-City Centre",
    lat: 53.4896,
    lng: -2.2496,
    score: 4.2,
    status: "success",
    type: "Lidl Express",
    address: "Manchester, City Centre",
  },
  {
    id: 437,
    name: "Lidl Cardiff-Canton",
    lat: 51.4657,
    lng: -3.1969,
    score: 4.6,
    status: "success",
    type: "Lidl",
    address: "Cardiff, Canton",
  },
  {
    id: 438,
    name: "Lidl Express Innsbruck-Innenstadt",
    lat: 47.2691,
    lng: 11.3811,
    score: 3.5,
    status: "warning",
    type: "Lidl Express",
    address: "Innsbruck, Innenstadt",
  },
  {
    id: 439,
    name: "Lidl XL Athens-Exarcheia",
    lat: 37.9937,
    lng: 23.7365,
    score: 3.5,
    status: "warning",
    type: "Lidl XL",
    address: "Athens, Exarcheia",
  },
  {
    id: 440,
    name: "Lidl Express Verona-Centro",
    lat: 45.4568,
    lng: 10.9738,
    score: 3.6,
    status: "warning",
    type: "Lidl Express",
    address: "Verona, Centro",
  },
  {
    id: 441,
    name: "Lidl Amsterdam-Zuidoost",
    lat: 52.3544,
    lng: 4.8998,
    score: 3.8,
    status: "warning",
    type: "Lidl",
    address: "Amsterdam, Zuidoost",
  },
  {
    id: 442,
    name: "Lidl Express Sofia-Studentski",
    lat: 42.6748,
    lng: 23.302,
    score: 4.6,
    status: "success",
    type: "Lidl Express",
    address: "Sofia, Studentski",
  },
  {
    id: 443,
    name: "Lidl XL Bristol-Henleaze",
    lat: 51.4777,
    lng: -2.5826,
    score: 4.6,
    status: "success",
    type: "Lidl XL",
    address: "Bristol, Henleaze",
  },
  {
    id: 444,
    name: "Lidl XL Paris-19e",
    lat: 48.8318,
    lng: 2.3713,
    score: 4.1,
    status: "warning",
    type: "Lidl XL",
    address: "Paris, 19e",
  },
  {
    id: 445,
    name: "Lidl XL Klagenfurt-Zentrum",
    lat: 46.6005,
    lng: 14.2944,
    score: 3.2,
    status: "danger",
    type: "Lidl XL",
    address: "Klagenfurt, Zentrum",
  },
  {
    id: 446,
    name: "Lidl XL The Hague-Scheveningen",
    lat: 52.046,
    lng: 4.2992,
    score: 2.7,
    status: "danger",
    type: "Lidl XL",
    address: "The Hague, Scheveningen",
  },
  {
    id: 447,
    name: "Lidl Express Dublin-Clontarf",
    lat: 53.3607,
    lng: -6.2568,
    score: 4.9,
    status: "success",
    type: "Lidl Express",
    address: "Dublin, Clontarf",
  },
  {
    id: 448,
    name: "Lidl XL Valencia-Rascanya",
    lat: 39.46,
    lng: -0.385,
    score: 4.3,
    status: "success",
    type: "Lidl XL",
    address: "Valencia, Rascanya",
  },
  {
    id: 449,
    name: "Lidl XL Hradec Kralove-Kukleny",
    lat: 50.2304,
    lng: 15.8544,
    score: 3,
    status: "danger",
    type: "Lidl XL",
    address: "Hradec Kralove, Kukleny",
  },
  {
    id: 450,
    name: "Lidl XL Florence-Oltrarno",
    lat: 43.7587,
    lng: 11.2654,
    score: 3.7,
    status: "warning",
    type: "Lidl XL",
    address: "Florence, Oltrarno",
  },
  {
    id: 451,
    name: "Lidl XL Olomouc-Nová Ulice",
    lat: 49.6175,
    lng: 17.2441,
    score: 3.3,
    status: "danger",
    type: "Lidl XL",
    address: "Olomouc, Nová Ulice",
  },
  {
    id: 452,
    name: "Lidl Express Pilsen-Centrum",
    lat: 49.7724,
    lng: 13.3701,
    score: 2.9,
    status: "danger",
    type: "Lidl Express",
    address: "Pilsen, Centrum",
  },
  {
    id: 453,
    name: "Lidl Reims-Wilson",
    lat: 49.2724,
    lng: 4.0359,
    score: 2.9,
    status: "danger",
    type: "Lidl",
    address: "Reims, Wilson",
  },
  {
    id: 454,
    name: "Lidl XL Dundalk-Blackrock",
    lat: 54.0126,
    lng: -6.389,
    score: 3.4,
    status: "danger",
    type: "Lidl XL",
    address: "Dundalk, Blackrock",
  },
  {
    id: 455,
    name: "Lidl XL Salzburg-Lehen",
    lat: 47.8235,
    lng: 13.0326,
    score: 4.5,
    status: "success",
    type: "Lidl XL",
    address: "Salzburg, Lehen",
  },
  {
    id: 456,
    name: "Lidl Split-Kaštela",
    lat: 43.5051,
    lng: 16.4356,
    score: 4,
    status: "warning",
    type: "Lidl",
    address: "Split, Kaštela",
  },
  {
    id: 457,
    name: "Lidl Almere-Buiten",
    lat: 52.35,
    lng: 5.2641,
    score: 3.9,
    status: "warning",
    type: "Lidl",
    address: "Almere, Buiten",
  },
  {
    id: 458,
    name: "Lidl XL Madrid-Vicálvaro",
    lat: 40.4254,
    lng: -3.7143,
    score: 4.3,
    status: "success",
    type: "Lidl XL",
    address: "Madrid, Vicálvaro",
  },
  {
    id: 459,
    name: "Lidl XL Utrecht-Oost",
    lat: 52.0908,
    lng: 5.1044,
    score: 3.6,
    status: "warning",
    type: "Lidl XL",
    address: "Utrecht, Oost",
  },
  {
    id: 460,
    name: "Lidl Express Sosnowiec-Śródmieście",
    lat: 50.3026,
    lng: 19.1118,
    score: 4.5,
    status: "success",
    type: "Lidl Express",
    address: "Sosnowiec, Śródmieście",
  },
  {
    id: 461,
    name: "Lidl Express Lucerne-Reussbühl",
    lat: 47.062,
    lng: 8.3242,
    score: 4.9,
    status: "success",
    type: "Lidl Express",
    address: "Lucerne, Reussbühl",
  },
  {
    id: 462,
    name: "Lidl Express Pardubice-Pardubice III",
    lat: 50.0156,
    lng: 15.7739,
    score: 3.1,
    status: "danger",
    type: "Lidl Express",
    address: "Pardubice, Pardubice III",
  },
  {
    id: 463,
    name: "Lidl Express Czestochowa-Południe",
    lat: 50.7904,
    lng: 19.1366,
    score: 3.3,
    status: "danger",
    type: "Lidl Express",
    address: "Czestochowa, Południe",
  },
  {
    id: 464,
    name: "Lidl Leeds-Headingley",
    lat: 53.8022,
    lng: -1.5321,
    score: 4.6,
    status: "success",
    type: "Lidl",
    address: "Leeds, Headingley",
  },
  {
    id: 465,
    name: "Lidl XL Salzburg-Altstadt",
    lat: 47.8037,
    lng: 13.0575,
    score: 4.7,
    status: "success",
    type: "Lidl XL",
    address: "Salzburg, Altstadt",
  },
  {
    id: 466,
    name: "Lidl Express Birmingham-Harborne",
    lat: 52.4826,
    lng: -1.9005,
    score: 4.4,
    status: "success",
    type: "Lidl Express",
    address: "Birmingham, Harborne",
  },
  {
    id: 467,
    name: "Lidl Southampton-Bitterne",
    lat: 50.934,
    lng: -1.3955,
    score: 4.4,
    status: "success",
    type: "Lidl",
    address: "Southampton, Bitterne",
  },
  {
    id: 468,
    name: "Lidl Vienna-Wieden",
    lat: 48.2093,
    lng: 16.3492,
    score: 4.4,
    status: "success",
    type: "Lidl",
    address: "Vienna, Wieden",
  },
  {
    id: 469,
    name: "Lidl Express Charlotte-Plaza Midwood",
    lat: 35.2175,
    lng: -80.8616,
    score: 3.5,
    status: "warning",
    type: "Lidl Express",
    address: "Charlotte, Plaza Midwood",
  },
  {
    id: 470,
    name: "Lidl Express Sheffield-Walkley",
    lat: 53.3854,
    lng: -1.4901,
    score: 4.1,
    status: "warning",
    type: "Lidl Express",
    address: "Sheffield, Walkley",
  },
  {
    id: 471,
    name: "Lidl Raleigh-Cameron Village",
    lat: 35.7852,
    lng: -78.6411,
    score: 4.6,
    status: "success",
    type: "Lidl",
    address: "Raleigh, Cameron Village",
  },
  {
    id: 472,
    name: "Lidl Miskolc-Tapolca",
    lat: 48.1086,
    lng: 20.7663,
    score: 3.8,
    status: "warning",
    type: "Lidl",
    address: "Miskolc, Tapolca",
  },
  {
    id: 473,
    name: "Lidl Express Turin-San Salvario",
    lat: 45.0465,
    lng: 7.702,
    score: 3.5,
    status: "warning",
    type: "Lidl Express",
    address: "Turin, San Salvario",
  },
  {
    id: 474,
    name: "Lidl St. Pölten-Harland",
    lat: 48.1972,
    lng: 15.631,
    score: 2.7,
    status: "danger",
    type: "Lidl",
    address: "St. Pölten, Harland",
  },
  {
    id: 475,
    name: "Lidl Białystok-Śródmieście",
    lat: 53.1541,
    lng: 23.1495,
    score: 4.6,
    status: "success",
    type: "Lidl",
    address: "Białystok, Śródmieście",
  },
  {
    id: 476,
    name: "Lidl Palermo-Mondello",
    lat: 38.116,
    lng: 13.3466,
    score: 4.1,
    status: "warning",
    type: "Lidl",
    address: "Palermo, Mondello",
  },
  {
    id: 477,
    name: "Lidl Philadelphia-Manayunk",
    lat: 39.9661,
    lng: -75.1668,
    score: 3.8,
    status: "warning",
    type: "Lidl",
    address: "Philadelphia, Manayunk",
  },
  {
    id: 478,
    name: "Lidl XL Winterthur-Töss",
    lat: 47.5042,
    lng: 8.7196,
    score: 3.9,
    status: "warning",
    type: "Lidl XL",
    address: "Winterthur, Töss",
  },
  {
    id: 479,
    name: "Lidl Prague-Praha 2",
    lat: 50.0933,
    lng: 14.4327,
    score: 2.9,
    status: "danger",
    type: "Lidl",
    address: "Prague, Praha 2",
  },
  {
    id: 480,
    name: "Lidl Express The Hague-Loosduinen",
    lat: 52.0464,
    lng: 4.3089,
    score: 4.1,
    status: "warning",
    type: "Lidl Express",
    address: "The Hague, Loosduinen",
  },
  {
    id: 481,
    name: "Lidl Express Lublin-Śródmieście",
    lat: 51.2463,
    lng: 22.5519,
    score: 4.8,
    status: "success",
    type: "Lidl Express",
    address: "Lublin, Śródmieście",
  },
  {
    id: 482,
    name: "Lidl Dornbirn-Rohrbach",
    lat: 47.412,
    lng: 9.7584,
    score: 4,
    status: "warning",
    type: "Lidl",
    address: "Dornbirn, Rohrbach",
  },
  {
    id: 483,
    name: "Lidl Pécs-Belváros",
    lat: 46.0726,
    lng: 18.2119,
    score: 3.1,
    status: "danger",
    type: "Lidl",
    address: "Pécs, Belváros",
  },
  {
    id: 484,
    name: "Lidl XL New York-Chelsea",
    lat: 40.7243,
    lng: -74.0064,
    score: 4.1,
    status: "warning",
    type: "Lidl XL",
    address: "New York, Chelsea",
  },
  {
    id: 485,
    name: "Lidl Express Innsbruck-Pradl",
    lat: 47.2701,
    lng: 11.3906,
    score: 2.6,
    status: "danger",
    type: "Lidl Express",
    address: "Innsbruck, Pradl",
  },
  {
    id: 486,
    name: "Lidl Express Groningen-Zuid",
    lat: 53.2096,
    lng: 6.5715,
    score: 3.5,
    status: "warning",
    type: "Lidl Express",
    address: "Groningen, Zuid",
  },
  {
    id: 487,
    name: "Lidl Lyon-1er",
    lat: 45.7635,
    lng: 4.8326,
    score: 3.5,
    status: "warning",
    type: "Lidl",
    address: "Lyon, 1er",
  },
  {
    id: 488,
    name: "Lidl XL Cardiff-City Centre",
    lat: 51.4963,
    lng: -3.1787,
    score: 2.9,
    status: "danger",
    type: "Lidl XL",
    address: "Cardiff, City Centre",
  },
  {
    id: 489,
    name: "Lidl XL Debrecen-Tócó",
    lat: 47.5248,
    lng: 21.6215,
    score: 4.3,
    status: "success",
    type: "Lidl XL",
    address: "Debrecen, Tócó",
  },
  {
    id: 490,
    name: "Lidl Express Alicante-Villafranqueza",
    lat: 38.3441,
    lng: -0.473,
    score: 2.7,
    status: "danger",
    type: "Lidl Express",
    address: "Alicante, Villafranqueza",
  },
  {
    id: 491,
    name: "Lidl Express Milan-Città Studi",
    lat: 45.4462,
    lng: 9.1892,
    score: 4.2,
    status: "warning",
    type: "Lidl Express",
    address: "Milan, Città Studi",
  },
  {
    id: 492,
    name: "Lidl Ploiesti-Nord",
    lat: 44.9161,
    lng: 25.9889,
    score: 4.2,
    status: "warning",
    type: "Lidl",
    address: "Ploiesti, Nord",
  },
  {
    id: 493,
    name: "Lidl XL Nottingham-Mapperley",
    lat: 52.9695,
    lng: -1.1587,
    score: 3.1,
    status: "danger",
    type: "Lidl XL",
    address: "Nottingham, Mapperley",
  },
  {
    id: 494,
    name: "Lidl Express Lille-Vieux-Lille",
    lat: 50.6359,
    lng: 3.0681,
    score: 4.9,
    status: "success",
    type: "Lidl Express",
    address: "Lille, Vieux-Lille",
  },
  {
    id: 495,
    name: "Lidl Bordeaux-Bacalan",
    lat: 44.8161,
    lng: -0.5685,
    score: 3.9,
    status: "warning",
    type: "Lidl",
    address: "Bordeaux, Bacalan",
  },
  {
    id: 496,
    name: "Lidl Express Dublin-Dún Laoghaire",
    lat: 53.3698,
    lng: -6.2441,
    score: 4.1,
    status: "warning",
    type: "Lidl Express",
    address: "Dublin, Dún Laoghaire",
  },
  {
    id: 497,
    name: "Lidl XL Hradec Kralove-Nový Hradec",
    lat: 50.2044,
    lng: 15.8143,
    score: 3.6,
    status: "warning",
    type: "Lidl XL",
    address: "Hradec Kralove, Nový Hradec",
  },
  {
    id: 498,
    name: "Lidl Express Brescia-Ovest",
    lat: 45.5602,
    lng: 10.2067,
    score: 2.9,
    status: "danger",
    type: "Lidl Express",
    address: "Brescia, Ovest",
  },
  {
    id: 499,
    name: "Lidl Galway-City Centre",
    lat: 53.253,
    lng: -9.0809,
    score: 3.6,
    status: "warning",
    type: "Lidl",
    address: "Galway, City Centre",
  },
  {
    id: 500,
    name: "Lidl Almada-Centro",
    lat: 38.6826,
    lng: -9.1614,
    score: 4.5,
    status: "success",
    type: "Lidl",
    address: "Almada, Centro",
  },
  {
    id: 501,
    name: "Lidl Turin-Centro",
    lat: 45.0454,
    lng: 7.6762,
    score: 3.8,
    status: "warning",
    type: "Lidl",
    address: "Turin, Centro",
  },
  {
    id: 502,
    name: "Lidl Burgas-Izgrev",
    lat: 42.5173,
    lng: 27.4667,
    score: 3,
    status: "danger",
    type: "Lidl",
    address: "Burgas, Izgrev",
  },
  {
    id: 503,
    name: "Lidl Cork-City Centre",
    lat: 51.8867,
    lng: -8.466,
    score: 4,
    status: "warning",
    type: "Lidl",
    address: "Cork, City Centre",
  },
  {
    id: 504,
    name: "Lidl Tilburg-Centrum",
    lat: 51.5573,
    lng: 5.1051,
    score: 3.4,
    status: "danger",
    type: "Lidl",
    address: "Tilburg, Centrum",
  },
  {
    id: 505,
    name: "Lidl Express Birmingham-Moseley",
    lat: 52.475,
    lng: -1.8845,
    score: 4.5,
    status: "success",
    type: "Lidl Express",
    address: "Birmingham, Moseley",
  },
  {
    id: 506,
    name: "Lidl Express Rome-Primavalle",
    lat: 41.9006,
    lng: 12.4723,
    score: 3.6,
    status: "warning",
    type: "Lidl Express",
    address: "Rome, Primavalle",
  },
  {
    id: 507,
    name: "Lidl XL Nantes-Breil",
    lat: 47.2157,
    lng: -1.5353,
    score: 3.8,
    status: "warning",
    type: "Lidl XL",
    address: "Nantes, Breil",
  },
  {
    id: 508,
    name: "Lidl Express Baltimore-Canton",
    lat: 39.2769,
    lng: -76.6338,
    score: 3.1,
    status: "danger",
    type: "Lidl Express",
    address: "Baltimore, Canton",
  },
  {
    id: 509,
    name: "Lidl Saint-Étienne-Terrasse",
    lat: 45.4184,
    lng: 4.3683,
    score: 3.3,
    status: "danger",
    type: "Lidl",
    address: "Saint-Étienne, Terrasse",
  },
  {
    id: 510,
    name: "Lidl Express Almada-Costa da Caparica",
    lat: 38.678,
    lng: -9.1424,
    score: 5,
    status: "success",
    type: "Lidl Express",
    address: "Almada, Costa da Caparica",
  },
  {
    id: 511,
    name: "Lidl New York-Staten Island",
    lat: 40.7298,
    lng: -73.9845,
    score: 4.9,
    status: "success",
    type: "Lidl",
    address: "New York, Staten Island",
  },
  {
    id: 512,
    name: "Lidl Charleroi-Montignies",
    lat: 50.3978,
    lng: 4.4526,
    score: 4,
    status: "warning",
    type: "Lidl",
    address: "Charleroi, Montignies",
  },
  {
    id: 513,
    name: "Lidl Express Edinburgh-Leith",
    lat: 55.9449,
    lng: -3.1636,
    score: 3.8,
    status: "warning",
    type: "Lidl Express",
    address: "Edinburgh, Leith",
  },
  {
    id: 514,
    name: "Lidl Express Saint-Étienne-Centre",
    lat: 45.4523,
    lng: 4.4003,
    score: 3.2,
    status: "danger",
    type: "Lidl Express",
    address: "Saint-Étienne, Centre",
  },
  {
    id: 515,
    name: "Lidl Express Ghent-Ledeberg",
    lat: 51.0776,
    lng: 3.6964,
    score: 4.7,
    status: "success",
    type: "Lidl Express",
    address: "Ghent, Ledeberg",
  },
  {
    id: 516,
    name: "Lidl Brno-Řečkovice",
    lat: 49.1742,
    lng: 16.6048,
    score: 4.9,
    status: "success",
    type: "Lidl",
    address: "Brno, Řečkovice",
  },
  {
    id: 517,
    name: "Lidl XL Amsterdam-Centrum",
    lat: 52.3635,
    lng: 4.892,
    score: 4,
    status: "warning",
    type: "Lidl XL",
    address: "Amsterdam, Centrum",
  },
  {
    id: 518,
    name: "Lidl Express Antwerp-Wilrijk",
    lat: 51.2211,
    lng: 4.4244,
    score: 3.8,
    status: "warning",
    type: "Lidl Express",
    address: "Antwerp, Wilrijk",
  },
  {
    id: 519,
    name: "Lidl Express Budapest-District XI",
    lat: 47.5033,
    lng: 19.0628,
    score: 2.5,
    status: "danger",
    type: "Lidl Express",
    address: "Budapest, District XI",
  },
  {
    id: 520,
    name: "Lidl Enschede-Noord",
    lat: 52.2144,
    lng: 6.9039,
    score: 3.5,
    status: "warning",
    type: "Lidl",
    address: "Enschede, Noord",
  },
  {
    id: 521,
    name: "Lidl Alicante-San Blas",
    lat: 38.3624,
    lng: -0.4968,
    score: 4.9,
    status: "success",
    type: "Lidl",
    address: "Alicante, San Blas",
  },
  {
    id: 522,
    name: "Lidl Express Szeged-Belváros",
    lat: 46.2579,
    lng: 20.1202,
    score: 4.8,
    status: "success",
    type: "Lidl Express",
    address: "Szeged, Belváros",
  },
  {
    id: 523,
    name: "Lidl XL Nottingham-West Bridgford",
    lat: 52.9736,
    lng: -1.1674,
    score: 4.7,
    status: "success",
    type: "Lidl XL",
    address: "Nottingham, West Bridgford",
  },
  {
    id: 524,
    name: "Lidl Padua-Sud",
    lat: 45.4009,
    lng: 11.873,
    score: 4.9,
    status: "success",
    type: "Lidl",
    address: "Padua, Sud",
  },
  {
    id: 525,
    name: "Lidl Express Athens-Pangrati",
    lat: 38.0025,
    lng: 23.7104,
    score: 3.6,
    status: "warning",
    type: "Lidl Express",
    address: "Athens, Pangrati",
  },
  {
    id: 526,
    name: "Lidl Split-Centar",
    lat: 43.5025,
    lng: 16.4165,
    score: 4.4,
    status: "success",
    type: "Lidl",
    address: "Split, Centar",
  },
  {
    id: 527,
    name: "Lidl XL Budapest-District XII",
    lat: 47.4967,
    lng: 19.0435,
    score: 3.4,
    status: "warning",
    type: "Lidl XL",
    address: "Budapest, District XII",
  },
  {
    id: 528,
    name: "Lidl XL Cardiff-Grangetown",
    lat: 51.4682,
    lng: -3.1654,
    score: 4.2,
    status: "success",
    type: "Lidl XL",
    address: "Cardiff, Grangetown",
  },
  {
    id: 529,
    name: "Lidl Paris-2e",
    lat: 48.8635,
    lng: 2.3388,
    score: 3.6,
    status: "warning",
    type: "Lidl",
    address: "Paris, 2e",
  },
  {
    id: 530,
    name: "Lidl Osijek-Tvrđa",
    lat: 45.5629,
    lng: 18.7025,
    score: 4.7,
    status: "success",
    type: "Lidl",
    address: "Osijek, Tvrđa",
  },
  {
    id: 531,
    name: "Lidl XL Bucharest-Sector 3",
    lat: 44.4235,
    lng: 26.1251,
    score: 2.6,
    status: "danger",
    type: "Lidl XL",
    address: "Bucharest, Sector 3",
  },
  {
    id: 532,
    name: "Lidl XL Hradec Kralove-Centrum",
    lat: 50.1871,
    lng: 15.8372,
    score: 3.2,
    status: "danger",
    type: "Lidl XL",
    address: "Hradec Kralove, Centrum",
  },
  {
    id: 533,
    name: "Lidl XL Birmingham-City Centre",
    lat: 52.4619,
    lng: -1.8925,
    score: 3.8,
    status: "warning",
    type: "Lidl XL",
    address: "Birmingham, City Centre",
  },
  {
    id: 534,
    name: "Lidl Padua-Stanga",
    lat: 45.3955,
    lng: 11.8778,
    score: 2.7,
    status: "danger",
    type: "Lidl",
    address: "Padua, Stanga",
  },
  {
    id: 535,
    name: "Lidl Express Palermo-Brancaccio",
    lat: 38.1366,
    lng: 13.3443,
    score: 3.6,
    status: "warning",
    type: "Lidl Express",
    address: "Palermo, Brancaccio",
  },
  {
    id: 536,
    name: "Lidl Ghent-Dampoort",
    lat: 51.0655,
    lng: 3.7382,
    score: 3.2,
    status: "danger",
    type: "Lidl",
    address: "Ghent, Dampoort",
  },
  {
    id: 537,
    name: "Lidl XL Szeged-Centrum",
    lat: 46.2509,
    lng: 20.1583,
    score: 4,
    status: "warning",
    type: "Lidl XL",
    address: "Szeged, Centrum",
  },
  {
    id: 538,
    name: "Lidl Express Rijeka-Centar",
    lat: 45.3227,
    lng: 14.4602,
    score: 2.6,
    status: "danger",
    type: "Lidl Express",
    address: "Rijeka, Centar",
  },
  {
    id: 539,
    name: "Lidl Express Bucharest-Sector 2",
    lat: 44.4403,
    lng: 26.0875,
    score: 4.1,
    status: "warning",
    type: "Lidl Express",
    address: "Bucharest, Sector 2",
  },
  {
    id: 540,
    name: "Lidl Zagreb-Trešnjevka",
    lat: 45.8321,
    lng: 15.9715,
    score: 2.7,
    status: "danger",
    type: "Lidl",
    address: "Zagreb, Trešnjevka",
  },
  {
    id: 541,
    name: "Lidl Express Richmond-Carytown",
    lat: 37.5379,
    lng: -77.4393,
    score: 3.5,
    status: "warning",
    type: "Lidl Express",
    address: "Richmond, Carytown",
  },
  {
    id: 542,
    name: "Lidl XL Milan-Navigli",
    lat: 45.485,
    lng: 9.1979,
    score: 3.2,
    status: "danger",
    type: "Lidl XL",
    address: "Milan, Navigli",
  },
  {
    id: 543,
    name: "Lidl XL Liverpool-Toxteth",
    lat: 53.3901,
    lng: -2.9865,
    score: 4,
    status: "warning",
    type: "Lidl XL",
    address: "Liverpool, Toxteth",
  },
  {
    id: 544,
    name: "Lidl Poznan-Jeżyce",
    lat: 52.3939,
    lng: 16.901,
    score: 3.7,
    status: "warning",
    type: "Lidl",
    address: "Poznan, Jeżyce",
  },
  {
    id: 545,
    name: "Lidl Iasi-Dacia",
    lat: 47.1436,
    lng: 27.6183,
    score: 3.5,
    status: "warning",
    type: "Lidl",
    address: "Iasi, Dacia",
  },
  {
    id: 546,
    name: "Lidl Linz-Pichling",
    lat: 48.2925,
    lng: 14.3075,
    score: 4,
    status: "warning",
    type: "Lidl",
    address: "Linz, Pichling",
  },
  {
    id: 547,
    name: "Lidl Bilbao-Uribarri",
    lat: 43.27,
    lng: -2.9299,
    score: 4.7,
    status: "success",
    type: "Lidl",
    address: "Bilbao, Uribarri",
  },
  {
    id: 548,
    name: "Lidl Express St. Gallen-Rotmonten",
    lat: 47.4292,
    lng: 9.3935,
    score: 4.3,
    status: "success",
    type: "Lidl Express",
    address: "St. Gallen, Rotmonten",
  },
  {
    id: 549,
    name: "Lidl Express Dijon-Fontaine",
    lat: 47.3051,
    lng: 5.0203,
    score: 2.9,
    status: "danger",
    type: "Lidl Express",
    address: "Dijon, Fontaine",
  },
  {
    id: 550,
    name: "Lidl XL Gdynia-Chylonia",
    lat: 54.5076,
    lng: 18.5144,
    score: 4.2,
    status: "success",
    type: "Lidl XL",
    address: "Gdynia, Chylonia",
  },
  {
    id: 551,
    name: "Lidl Lille-Fives",
    lat: 50.6541,
    lng: 3.0668,
    score: 3.5,
    status: "warning",
    type: "Lidl",
    address: "Lille, Fives",
  },
  {
    id: 552,
    name: "Lidl Express Aveiro-Esgueira",
    lat: 40.6396,
    lng: -8.6378,
    score: 4.7,
    status: "success",
    type: "Lidl Express",
    address: "Aveiro, Esgueira",
  },
  {
    id: 553,
    name: "Lidl XL Lyon-5e",
    lat: 45.7735,
    lng: 4.8211,
    score: 2.9,
    status: "danger",
    type: "Lidl XL",
    address: "Lyon, 5e",
  },
  {
    id: 554,
    name: "Lidl Bordeaux-Saint-Augustin",
    lat: 44.8606,
    lng: -0.5985,
    score: 4.4,
    status: "success",
    type: "Lidl",
    address: "Bordeaux, Saint-Augustin",
  },
  {
    id: 555,
    name: "Lidl Express Almada-Cova da Piedade",
    lat: 38.6931,
    lng: -9.1671,
    score: 4.9,
    status: "success",
    type: "Lidl Express",
    address: "Almada, Cova da Piedade",
  },
  {
    id: 556,
    name: "Lidl XL Charleston-Mount Pleasant",
    lat: 32.7682,
    lng: -79.9362,
    score: 4.1,
    status: "warning",
    type: "Lidl XL",
    address: "Charleston, Mount Pleasant",
  },
  {
    id: 557,
    name: "Lidl XL Philadelphia-Northeast",
    lat: 39.9743,
    lng: -75.163,
    score: 3.7,
    status: "warning",
    type: "Lidl XL",
    address: "Philadelphia, Northeast",
  },
  {
    id: 558,
    name: "Lidl Express Graz-Liebenau",
    lat: 47.0811,
    lng: 15.4206,
    score: 4.8,
    status: "success",
    type: "Lidl Express",
    address: "Graz, Liebenau",
  },
  {
    id: 559,
    name: "Lidl XL Bristol-Clifton",
    lat: 51.4471,
    lng: -2.5968,
    score: 4.2,
    status: "success",
    type: "Lidl XL",
    address: "Bristol, Clifton",
  },
  {
    id: 560,
    name: "Lidl XL Drogheda-Centre",
    lat: 53.7111,
    lng: -6.3763,
    score: 4,
    status: "warning",
    type: "Lidl XL",
    address: "Drogheda, Centre",
  },
  {
    id: 561,
    name: "Lidl Express Warsaw-Włochy",
    lat: 52.2062,
    lng: 21.0042,
    score: 4.5,
    status: "success",
    type: "Lidl Express",
    address: "Warsaw, Włochy",
  },
  {
    id: 562,
    name: "Lidl Vigo-Coia",
    lat: 42.2629,
    lng: -8.7313,
    score: 2.8,
    status: "danger",
    type: "Lidl",
    address: "Vigo, Coia",
  },
  {
    id: 563,
    name: "Lidl Arnhem-Noord",
    lat: 51.987,
    lng: 5.906,
    score: 4.9,
    status: "success",
    type: "Lidl",
    address: "Arnhem, Noord",
  },
  {
    id: 564,
    name: "Lidl XL Athens-Kallithea",
    lat: 37.9784,
    lng: 23.7461,
    score: 4.7,
    status: "success",
    type: "Lidl XL",
    address: "Athens, Kallithea",
  },
  {
    id: 565,
    name: "Lidl Express Lausanne-Chailly",
    lat: 46.5252,
    lng: 6.6126,
    score: 2.7,
    status: "danger",
    type: "Lidl Express",
    address: "Lausanne, Chailly",
  },
  {
    id: 566,
    name: "Lidl Nijmegen-Oost",
    lat: 51.8302,
    lng: 5.852,
    score: 4.5,
    status: "success",
    type: "Lidl",
    address: "Nijmegen, Oost",
  },
  {
    id: 567,
    name: "Lidl XL London-Ealing",
    lat: 51.5137,
    lng: -0.1054,
    score: 4.5,
    status: "success",
    type: "Lidl XL",
    address: "London, Ealing",
  },
  {
    id: 568,
    name: "Lidl Express Braga-São Victor",
    lat: 41.5529,
    lng: -8.3996,
    score: 2.8,
    status: "danger",
    type: "Lidl Express",
    address: "Braga, São Victor",
  },
  {
    id: 569,
    name: "Lidl Express London-Brent",
    lat: 51.5292,
    lng: -0.1228,
    score: 4,
    status: "warning",
    type: "Lidl Express",
    address: "London, Brent",
  },
  {
    id: 570,
    name: "Lidl Norfolk-Chesapeake",
    lat: 36.8667,
    lng: -76.302,
    score: 2.8,
    status: "danger",
    type: "Lidl",
    address: "Norfolk, Chesapeake",
  },
  {
    id: 571,
    name: "Lidl XL Madrid-Latina",
    lat: 40.4312,
    lng: -3.696,
    score: 4.6,
    status: "success",
    type: "Lidl XL",
    address: "Madrid, Latina",
  },
  {
    id: 572,
    name: "Lidl Express Nottingham-Sherwood",
    lat: 52.9728,
    lng: -1.1713,
    score: 2.7,
    status: "danger",
    type: "Lidl Express",
    address: "Nottingham, Sherwood",
  },
  {
    id: 573,
    name: "Lidl Express Plovdiv-Trakia",
    lat: 42.1364,
    lng: 24.7622,
    score: 3.6,
    status: "warning",
    type: "Lidl Express",
    address: "Plovdiv, Trakia",
  },
  {
    id: 574,
    name: "Lidl XL Glasgow-Shawlands",
    lat: 55.8462,
    lng: -4.2757,
    score: 4.9,
    status: "success",
    type: "Lidl XL",
    address: "Glasgow, Shawlands",
  },
  {
    id: 575,
    name: "Lidl XL Liberec-Rochlice",
    lat: 50.7626,
    lng: 15.0678,
    score: 4,
    status: "warning",
    type: "Lidl XL",
    address: "Liberec, Rochlice",
  },
  {
    id: 576,
    name: "Lidl Utrecht-Overvecht",
    lat: 52.0823,
    lng: 5.1213,
    score: 4.5,
    status: "success",
    type: "Lidl",
    address: "Utrecht, Overvecht",
  },
  {
    id: 577,
    name: "Lidl Express Prague-Praha 5",
    lat: 50.0592,
    lng: 14.4293,
    score: 3.8,
    status: "warning",
    type: "Lidl Express",
    address: "Prague, Praha 5",
  },
  {
    id: 578,
    name: "Lidl Express Gijon-Centro",
    lat: 43.5604,
    lng: -5.639,
    score: 4.2,
    status: "success",
    type: "Lidl Express",
    address: "Gijon, Centro",
  },
  {
    id: 579,
    name: "Lidl XL Granada-Centro",
    lat: 37.1552,
    lng: -3.6016,
    score: 4.2,
    status: "warning",
    type: "Lidl XL",
    address: "Granada, Centro",
  },
  {
    id: 580,
    name: "Lidl Express Newcastle-Walker",
    lat: 54.9572,
    lng: -1.6141,
    score: 3.9,
    status: "warning",
    type: "Lidl Express",
    address: "Newcastle, Walker",
  },
  {
    id: 581,
    name: "Lidl Express Granada-Zaidín",
    lat: 37.1975,
    lng: -3.586,
    score: 3.9,
    status: "warning",
    type: "Lidl Express",
    address: "Granada, Zaidín",
  },
  {
    id: 582,
    name: "Lidl XL London-Croydon",
    lat: 51.5243,
    lng: -0.1297,
    score: 4.7,
    status: "success",
    type: "Lidl XL",
    address: "London, Croydon",
  },
  {
    id: 583,
    name: "Lidl Express Charleston-Downtown",
    lat: 32.7615,
    lng: -79.9404,
    score: 4.6,
    status: "success",
    type: "Lidl Express",
    address: "Charleston, Downtown",
  },
  {
    id: 584,
    name: "Lidl Express Saint-Étienne-Métare",
    lat: 45.4317,
    lng: 4.3795,
    score: 4.8,
    status: "success",
    type: "Lidl Express",
    address: "Saint-Étienne, Métare",
  },
  {
    id: 585,
    name: "Lidl Debrecen-Nagyerdei",
    lat: 47.5543,
    lng: 21.6026,
    score: 4,
    status: "warning",
    type: "Lidl",
    address: "Debrecen, Nagyerdei",
  },
  {
    id: 586,
    name: "Lidl Sheffield-City Centre",
    lat: 53.4024,
    lng: -1.4462,
    score: 4.8,
    status: "success",
    type: "Lidl",
    address: "Sheffield, City Centre",
  },
  {
    id: 587,
    name: "Lidl XL Barcelona-Sants-Montjuïc",
    lat: 41.3746,
    lng: 2.1513,
    score: 3.3,
    status: "danger",
    type: "Lidl XL",
    address: "Barcelona, Sants-Montjuïc",
  },
  {
    id: 588,
    name: "Lidl Pilsen-Lobzy",
    lat: 49.7298,
    lng: 13.3902,
    score: 3.7,
    status: "warning",
    type: "Lidl",
    address: "Pilsen, Lobzy",
  },
  {
    id: 589,
    name: "Lidl Express Turin-Nizza Millefonti",
    lat: 45.0677,
    lng: 7.7072,
    score: 3.1,
    status: "danger",
    type: "Lidl Express",
    address: "Turin, Nizza Millefonti",
  },
  {
    id: 590,
    name: "Lidl XL Brighton-Kemptown",
    lat: 50.838,
    lng: -0.1448,
    score: 3.6,
    status: "warning",
    type: "Lidl XL",
    address: "Brighton, Kemptown",
  },
  {
    id: 591,
    name: "Lidl XL Montpellier-Port Marianne",
    lat: 43.6063,
    lng: 3.8757,
    score: 3.8,
    status: "warning",
    type: "Lidl XL",
    address: "Montpellier, Port Marianne",
  },
  {
    id: 592,
    name: "Lidl XL Bucharest-Dorobanti",
    lat: 44.4249,
    lng: 26.109,
    score: 2.9,
    status: "danger",
    type: "Lidl XL",
    address: "Bucharest, Dorobanti",
  },
  {
    id: 593,
    name: "Lidl XL Celje-Lava",
    lat: 46.2329,
    lng: 15.2414,
    score: 4.4,
    status: "success",
    type: "Lidl XL",
    address: "Celje, Lava",
  },
  {
    id: 594,
    name: "Lidl Express Leicester-Belgrave",
    lat: 52.6462,
    lng: -1.1208,
    score: 4,
    status: "warning",
    type: "Lidl Express",
    address: "Leicester, Belgrave",
  },
  {
    id: 595,
    name: "Lidl Express Olomouc-Holice",
    lat: 49.5745,
    lng: 17.2538,
    score: 3.5,
    status: "warning",
    type: "Lidl Express",
    address: "Olomouc, Holice",
  },
  {
    id: 596,
    name: "Lidl Brno-Komín",
    lat: 49.1957,
    lng: 16.6306,
    score: 3.3,
    status: "danger",
    type: "Lidl",
    address: "Brno, Komín",
  },
  {
    id: 597,
    name: "Lidl New York-Brooklyn",
    lat: 40.6936,
    lng: -74.0204,
    score: 3.6,
    status: "warning",
    type: "Lidl",
    address: "New York, Brooklyn",
  },
  {
    id: 598,
    name: "Lidl Villach-Nord",
    lat: 46.593,
    lng: 13.8745,
    score: 4.5,
    status: "success",
    type: "Lidl",
    address: "Villach, Nord",
  },
  {
    id: 599,
    name: "Lidl XL Manchester-Fallowfield",
    lat: 53.4757,
    lng: -2.2604,
    score: 2.5,
    status: "danger",
    type: "Lidl XL",
    address: "Manchester, Fallowfield",
  },
  {
    id: 600,
    name: "Lidl XL Bucharest-Pantelimon",
    lat: 44.4076,
    lng: 26.117,
    score: 4.2,
    status: "warning",
    type: "Lidl XL",
    address: "Bucharest, Pantelimon",
  },
  {
    id: 601,
    name: "Lidl Express Rennes-Cleunay",
    lat: 48.1391,
    lng: -1.6837,
    score: 3.4,
    status: "warning",
    type: "Lidl Express",
    address: "Rennes, Cleunay",
  },
  {
    id: 602,
    name: "Lidl Brussels-Woluwe",
    lat: 50.8677,
    lng: 4.3623,
    score: 4,
    status: "warning",
    type: "Lidl",
    address: "Brussels, Woluwe",
  },
  {
    id: 603,
    name: "Lidl The Hague-Escamp",
    lat: 52.0481,
    lng: 4.2981,
    score: 4.1,
    status: "warning",
    type: "Lidl",
    address: "The Hague, Escamp",
  },
  {
    id: 604,
    name: "Lidl Express Marseille-5e",
    lat: 43.2747,
    lng: 5.3688,
    score: 3.5,
    status: "warning",
    type: "Lidl Express",
    address: "Marseille, 5e",
  },
  {
    id: 605,
    name: "Lidl Express Sheffield-Crookes",
    lat: 53.3769,
    lng: -1.462,
    score: 4,
    status: "warning",
    type: "Lidl Express",
    address: "Sheffield, Crookes",
  },
  {
    id: 606,
    name: "Lidl XL Southampton-Bassett",
    lat: 50.9075,
    lng: -1.422,
    score: 4.9,
    status: "success",
    type: "Lidl XL",
    address: "Southampton, Bassett",
  },
  {
    id: 607,
    name: "Lidl XL Manchester-Rusholme",
    lat: 53.4601,
    lng: -2.2373,
    score: 3.1,
    status: "danger",
    type: "Lidl XL",
    address: "Manchester, Rusholme",
  },
  {
    id: 608,
    name: "Lidl XL Patras-Agios Dimitrios",
    lat: 38.225,
    lng: 21.7233,
    score: 4.4,
    status: "success",
    type: "Lidl XL",
    address: "Patras, Agios Dimitrios",
  },
  {
    id: 609,
    name: "Lidl Lausanne-Pully",
    lat: 46.5146,
    lng: 6.6368,
    score: 4.5,
    status: "success",
    type: "Lidl",
    address: "Lausanne, Pully",
  },
  {
    id: 610,
    name: "Lidl Express Bologna-Navile",
    lat: 44.473,
    lng: 11.3476,
    score: 4.7,
    status: "success",
    type: "Lidl Express",
    address: "Bologna, Navile",
  },
  {
    id: 611,
    name: "Lidl Almere-Stad",
    lat: 52.3321,
    lng: 5.2845,
    score: 4.1,
    status: "warning",
    type: "Lidl",
    address: "Almere, Stad",
  },
  {
    id: 612,
    name: "Lidl Leicester-Rushey Mead",
    lat: 52.6427,
    lng: -1.1241,
    score: 4.2,
    status: "warning",
    type: "Lidl",
    address: "Leicester, Rushey Mead",
  },
  {
    id: 613,
    name: "Lidl Express Valencia-Campanar",
    lat: 39.4755,
    lng: -0.3627,
    score: 4.4,
    status: "success",
    type: "Lidl Express",
    address: "Valencia, Campanar",
  },
  {
    id: 614,
    name: "Lidl Express Richmond-Fan",
    lat: 37.5473,
    lng: -77.4588,
    score: 4.3,
    status: "success",
    type: "Lidl Express",
    address: "Richmond, Fan",
  },
  {
    id: 615,
    name: "Lidl XL Dijon-Ouche",
    lat: 47.3278,
    lng: 5.0335,
    score: 4.2,
    status: "warning",
    type: "Lidl XL",
    address: "Dijon, Ouche",
  },
  {
    id: 616,
    name: "Lidl Sheffield-Ecclesall",
    lat: 53.4009,
    lng: -1.4767,
    score: 3.5,
    status: "warning",
    type: "Lidl",
    address: "Sheffield, Ecclesall",
  },
  {
    id: 617,
    name: "Lidl Thessaloniki-Triandria",
    lat: 40.6352,
    lng: 22.9583,
    score: 3.3,
    status: "danger",
    type: "Lidl",
    address: "Thessaloniki, Triandria",
  },
  {
    id: 618,
    name: "Lidl Szczecin-Gumieńce",
    lat: 53.4435,
    lng: 14.541,
    score: 3,
    status: "danger",
    type: "Lidl",
    address: "Szczecin, Gumieńce",
  },
  {
    id: 619,
    name: "Lidl Iasi-Copou",
    lat: 47.1635,
    lng: 27.5871,
    score: 2.9,
    status: "danger",
    type: "Lidl",
    address: "Iasi, Copou",
  },
  {
    id: 620,
    name: "Lidl Express Venice-Lido",
    lat: 45.4482,
    lng: 12.2912,
    score: 3,
    status: "danger",
    type: "Lidl Express",
    address: "Venice, Lido",
  },
  {
    id: 621,
    name: "Lidl XL Leeds-Pudsey",
    lat: 53.8158,
    lng: -1.5446,
    score: 4.8,
    status: "success",
    type: "Lidl XL",
    address: "Leeds, Pudsey",
  },
  {
    id: 622,
    name: "Lidl XL Rome-Prati",
    lat: 41.886,
    lng: 12.4891,
    score: 3.8,
    status: "warning",
    type: "Lidl XL",
    address: "Rome, Prati",
  },
  {
    id: 623,
    name: "Lidl Express Warsaw-Bemowo",
    lat: 52.2109,
    lng: 21.008,
    score: 4.3,
    status: "success",
    type: "Lidl Express",
    address: "Warsaw, Bemowo",
  },
  {
    id: 624,
    name: "Lidl Express Pilsen-Doubravka",
    lat: 49.7331,
    lng: 13.3712,
    score: 4.5,
    status: "success",
    type: "Lidl Express",
    address: "Pilsen, Doubravka",
  },
  {
    id: 625,
    name: "Lidl XL Vienna-Meidling",
    lat: 48.2125,
    lng: 16.3848,
    score: 3.7,
    status: "warning",
    type: "Lidl XL",
    address: "Vienna, Meidling",
  },
  {
    id: 626,
    name: "Lidl Norfolk-Virginia Beach",
    lat: 36.8374,
    lng: -76.278,
    score: 4.2,
    status: "success",
    type: "Lidl",
    address: "Norfolk, Virginia Beach",
  },
  {
    id: 627,
    name: "Lidl Plovdiv-Karshiaka",
    lat: 42.1353,
    lng: 24.7237,
    score: 3.5,
    status: "warning",
    type: "Lidl",
    address: "Plovdiv, Karshiaka",
  },
  {
    id: 628,
    name: "Lidl XL Glasgow-Partick",
    lat: 55.8854,
    lng: -4.2305,
    score: 4.1,
    status: "warning",
    type: "Lidl XL",
    address: "Glasgow, Partick",
  },
  {
    id: 629,
    name: "Lidl Express Newcastle-Fenham",
    lat: 54.9685,
    lng: -1.6095,
    score: 2.6,
    status: "danger",
    type: "Lidl Express",
    address: "Newcastle, Fenham",
  },
  {
    id: 630,
    name: "Lidl Express Nice-Port",
    lat: 43.7255,
    lng: 7.2805,
    score: 4.2,
    status: "warning",
    type: "Lidl Express",
    address: "Nice, Port",
  },
  {
    id: 631,
    name: "Lidl XL Torun-Stare Miasto",
    lat: 53.0246,
    lng: 18.605,
    score: 3.6,
    status: "warning",
    type: "Lidl XL",
    address: "Torun, Stare Miasto",
  },
  {
    id: 632,
    name: "Lidl XL Krakow-Podgórze",
    lat: 50.0615,
    lng: 19.9599,
    score: 3.8,
    status: "warning",
    type: "Lidl XL",
    address: "Krakow, Podgórze",
  },
  {
    id: 633,
    name: "Lidl XL Leuven-Heverlee",
    lat: 50.8648,
    lng: 4.7046,
    score: 2.7,
    status: "danger",
    type: "Lidl XL",
    address: "Leuven, Heverlee",
  },
  {
    id: 634,
    name: "Lidl XL Porto-Ramalde",
    lat: 41.1407,
    lng: -8.6044,
    score: 3.9,
    status: "warning",
    type: "Lidl XL",
    address: "Porto, Ramalde",
  },
  {
    id: 635,
    name: "Lidl Rotterdam-Delfshaven",
    lat: 51.8986,
    lng: 4.4791,
    score: 3.9,
    status: "warning",
    type: "Lidl",
    address: "Rotterdam, Delfshaven",
  },
  {
    id: 636,
    name: "Lidl XL Sofia-Centar",
    lat: 42.6859,
    lng: 23.3433,
    score: 4.8,
    status: "success",
    type: "Lidl XL",
    address: "Sofia, Centar",
  },
  {
    id: 637,
    name: "Lidl XL Dublin-Drumcondra",
    lat: 53.3479,
    lng: -6.2381,
    score: 3.8,
    status: "warning",
    type: "Lidl XL",
    address: "Dublin, Drumcondra",
  },
  {
    id: 638,
    name: "Lidl Express Split-Bačvice",
    lat: 43.4889,
    lng: 16.4263,
    score: 3.6,
    status: "warning",
    type: "Lidl Express",
    address: "Split, Bačvice",
  },
  {
    id: 639,
    name: "Lidl Szeged-Rókus",
    lat: 46.2654,
    lng: 20.1325,
    score: 3.2,
    status: "danger",
    type: "Lidl",
    address: "Szeged, Rókus",
  },
  {
    id: 640,
    name: "Lidl Express Angers-Monplaisir",
    lat: 47.4941,
    lng: -0.5769,
    score: 3.7,
    status: "warning",
    type: "Lidl Express",
    address: "Angers, Monplaisir",
  },
  {
    id: 641,
    name: "Lidl Ljubljana-Šiška",
    lat: 46.0342,
    lng: 14.5011,
    score: 3.6,
    status: "warning",
    type: "Lidl",
    address: "Ljubljana, Šiška",
  },
  {
    id: 642,
    name: "Lidl Poznan-Grunwald",
    lat: 52.4011,
    lng: 16.9201,
    score: 2.7,
    status: "danger",
    type: "Lidl",
    address: "Poznan, Grunwald",
  },
  {
    id: 643,
    name: "Lidl Braga-Maximinos",
    lat: 41.5333,
    lng: -8.4157,
    score: 4.2,
    status: "success",
    type: "Lidl",
    address: "Braga, Maximinos",
  },
  {
    id: 644,
    name: "Lidl Eindhoven- Tongelre",
    lat: 51.4584,
    lng: 5.4916,
    score: 4.1,
    status: "warning",
    type: "Lidl",
    address: "Eindhoven,  Tongelre",
  },
  {
    id: 645,
    name: "Lidl Express Villach-Zentrum",
    lat: 46.5912,
    lng: 13.841,
    score: 3.7,
    status: "warning",
    type: "Lidl Express",
    address: "Villach, Zentrum",
  },
  {
    id: 646,
    name: "Lidl Express Marseille-4e",
    lat: 43.3001,
    lng: 5.3673,
    score: 3.9,
    status: "warning",
    type: "Lidl Express",
    address: "Marseille, 4e",
  },
  {
    id: 647,
    name: "Lidl Pécs-Kertváros",
    lat: 46.0973,
    lng: 18.2528,
    score: 2.6,
    status: "danger",
    type: "Lidl",
    address: "Pécs, Kertváros",
  },
  {
    id: 648,
    name: "Lidl XL Nice-Riquier",
    lat: 43.7111,
    lng: 7.2584,
    score: 4.4,
    status: "success",
    type: "Lidl XL",
    address: "Nice, Riquier",
  },
  {
    id: 649,
    name: "Lidl XL Constanta-Centru",
    lat: 44.1431,
    lng: 28.6453,
    score: 3.7,
    status: "warning",
    type: "Lidl XL",
    address: "Constanta, Centru",
  },
  {
    id: 650,
    name: "Lidl Express Pilsen-Skvrňany",
    lat: 49.7717,
    lng: 13.4008,
    score: 3.1,
    status: "danger",
    type: "Lidl Express",
    address: "Pilsen, Skvrňany",
  },
  {
    id: 651,
    name: "Lidl XL Gdansk-Wrzeszcz",
    lat: 54.357,
    lng: 18.6601,
    score: 3.5,
    status: "warning",
    type: "Lidl XL",
    address: "Gdansk, Wrzeszcz",
  },
  {
    id: 652,
    name: "Lidl Brighton-Hanover",
    lat: 50.8307,
    lng: -0.1584,
    score: 4,
    status: "warning",
    type: "Lidl",
    address: "Brighton, Hanover",
  },
  {
    id: 653,
    name: "Lidl Express Bordeaux-Bastide",
    lat: 44.8271,
    lng: -0.5844,
    score: 3.9,
    status: "warning",
    type: "Lidl Express",
    address: "Bordeaux, Bastide",
  },
  {
    id: 654,
    name: "Lidl XL Ceske Budejovice-Máj",
    lat: 48.9581,
    lng: 14.4783,
    score: 3.6,
    status: "warning",
    type: "Lidl XL",
    address: "Ceske Budejovice, Máj",
  },
  {
    id: 655,
    name: "Lidl Split-Žnjan",
    lat: 43.5163,
    lng: 16.4626,
    score: 3.2,
    status: "danger",
    type: "Lidl",
    address: "Split, Žnjan",
  },
  {
    id: 656,
    name: "Lidl XL Seville-Casco Antiguo",
    lat: 37.3828,
    lng: -5.9682,
    score: 3.5,
    status: "warning",
    type: "Lidl XL",
    address: "Seville, Casco Antiguo",
  },
  {
    id: 657,
    name: "Lidl Aveiro-Vera Cruz",
    lat: 40.6545,
    lng: -8.6612,
    score: 2.7,
    status: "danger",
    type: "Lidl",
    address: "Aveiro, Vera Cruz",
  },
  {
    id: 658,
    name: "Lidl XL Cordoba-Norte",
    lat: 37.8984,
    lng: -4.7571,
    score: 5,
    status: "success",
    type: "Lidl XL",
    address: "Cordoba, Norte",
  },
  {
    id: 659,
    name: "Lidl Birmingham-Erdington",
    lat: 52.501,
    lng: -1.8892,
    score: 4.6,
    status: "success",
    type: "Lidl",
    address: "Birmingham, Erdington",
  },
  {
    id: 660,
    name: "Lidl XL Usti nad Labem-Centrum",
    lat: 50.6504,
    lng: 14.0431,
    score: 3.9,
    status: "warning",
    type: "Lidl XL",
    address: "Usti nad Labem, Centrum",
  },
  {
    id: 661,
    name: "Lidl XL Nijmegen-Zuid",
    lat: 51.8319,
    lng: 5.8696,
    score: 4.2,
    status: "warning",
    type: "Lidl XL",
    address: "Nijmegen, Zuid",
  },
  {
    id: 662,
    name: "Lidl Greenville-Augusta Rd",
    lat: 34.8479,
    lng: -82.4138,
    score: 4,
    status: "warning",
    type: "Lidl",
    address: "Greenville, Augusta Rd",
  },
  {
    id: 663,
    name: "Lidl Express Dublin-Rathmines",
    lat: 53.3743,
    lng: -6.2722,
    score: 4.2,
    status: "warning",
    type: "Lidl Express",
    address: "Dublin, Rathmines",
  },
  {
    id: 664,
    name: "Lidl XL Lisbon-Estrela",
    lat: 38.7454,
    lng: -9.1171,
    score: 4.9,
    status: "success",
    type: "Lidl XL",
    address: "Lisbon, Estrela",
  },
  {
    id: 665,
    name: "Lidl Express Amsterdam-De Pijp",
    lat: 52.3693,
    lng: 4.9128,
    score: 4.7,
    status: "success",
    type: "Lidl Express",
    address: "Amsterdam, De Pijp",
  },
  {
    id: 666,
    name: "Lidl Brno-Střed",
    lat: 49.1729,
    lng: 16.5987,
    score: 4.3,
    status: "success",
    type: "Lidl",
    address: "Brno, Střed",
  },
  {
    id: 667,
    name: "Lidl Express Pardubice-Pardubice VI",
    lat: 50.0295,
    lng: 15.8059,
    score: 3.2,
    status: "danger",
    type: "Lidl Express",
    address: "Pardubice, Pardubice VI",
  },
  {
    id: 668,
    name: "Lidl Express Malaga-Churriana",
    lat: 36.7045,
    lng: -4.4022,
    score: 4.1,
    status: "warning",
    type: "Lidl Express",
    address: "Malaga, Churriana",
  },
  {
    id: 669,
    name: "Lidl Express Timisoara-Fabric",
    lat: 45.7612,
    lng: 21.2107,
    score: 2.8,
    status: "danger",
    type: "Lidl Express",
    address: "Timisoara, Fabric",
  },
  {
    id: 670,
    name: "Lidl Cluj-Napoca-Grigorescu",
    lat: 46.7802,
    lng: 23.6314,
    score: 4.5,
    status: "success",
    type: "Lidl",
    address: "Cluj-Napoca, Grigorescu",
  },
  {
    id: 671,
    name: "Lidl Express Utrecht-West",
    lat: 52.0972,
    lng: 5.0976,
    score: 3.8,
    status: "warning",
    type: "Lidl Express",
    address: "Utrecht, West",
  },
  {
    id: 672,
    name: "Lidl Express Barcelona-Les Corts",
    lat: 41.3842,
    lng: 2.1732,
    score: 3.6,
    status: "warning",
    type: "Lidl Express",
    address: "Barcelona, Les Corts",
  },
  {
    id: 673,
    name: "Lidl Almere-Haven",
    lat: 52.3372,
    lng: 5.258,
    score: 4.4,
    status: "success",
    type: "Lidl",
    address: "Almere, Haven",
  },
  {
    id: 674,
    name: "Lidl Baltimore-Federal Hill",
    lat: 39.2779,
    lng: -76.63,
    score: 4.5,
    status: "success",
    type: "Lidl",
    address: "Baltimore, Federal Hill",
  },
  {
    id: 675,
    name: "Lidl Express Turin-Lingotto",
    lat: 45.0788,
    lng: 7.7045,
    score: 4.6,
    status: "success",
    type: "Lidl Express",
    address: "Turin, Lingotto",
  },
  {
    id: 676,
    name: "Lidl Express Graz-Lend",
    lat: 47.0941,
    lng: 15.4182,
    score: 3,
    status: "danger",
    type: "Lidl Express",
    address: "Graz, Lend",
  },
  {
    id: 677,
    name: "Lidl Express Manchester-Ancoats",
    lat: 53.4945,
    lng: -2.2327,
    score: 2.6,
    status: "danger",
    type: "Lidl Express",
    address: "Manchester, Ancoats",
  },
  {
    id: 678,
    name: "Lidl Marseille-7e",
    lat: 43.2902,
    lng: 5.3661,
    score: 4.4,
    status: "success",
    type: "Lidl",
    address: "Marseille, 7e",
  },
  {
    id: 679,
    name: "Lidl Express Warsaw-Targówek",
    lat: 52.2413,
    lng: 21.0151,
    score: 2.7,
    status: "danger",
    type: "Lidl Express",
    address: "Warsaw, Targówek",
  },
  {
    id: 680,
    name: "Lidl XL Bydgoszcz-Fordon",
    lat: 53.1067,
    lng: 18.0278,
    score: 3.5,
    status: "warning",
    type: "Lidl XL",
    address: "Bydgoszcz, Fordon",
  },
  {
    id: 681,
    name: "Lidl Express Vienna-Landstraße",
    lat: 48.2295,
    lng: 16.3559,
    score: 4.8,
    status: "success",
    type: "Lidl Express",
    address: "Vienna, Landstraße",
  },
  {
    id: 682,
    name: "Lidl Express Rome-Esquilino",
    lat: 41.924,
    lng: 12.5134,
    score: 5,
    status: "success",
    type: "Lidl Express",
    address: "Rome, Esquilino",
  },
  {
    id: 683,
    name: "Lidl Express Warsaw-Śródmieście",
    lat: 52.2254,
    lng: 21.0264,
    score: 3.2,
    status: "danger",
    type: "Lidl Express",
    address: "Warsaw, Śródmieście",
  },
  {
    id: 684,
    name: "Lidl Express Valladolid-Pilarica",
    lat: 41.677,
    lng: -4.7069,
    score: 3.1,
    status: "danger",
    type: "Lidl Express",
    address: "Valladolid, Pilarica",
  },
  {
    id: 685,
    name: "Lidl Trieste-Centro",
    lat: 45.6535,
    lng: 13.769,
    score: 4,
    status: "warning",
    type: "Lidl",
    address: "Trieste, Centro",
  },
  {
    id: 686,
    name: "Lidl Express Vienna-Leopoldstadt",
    lat: 48.2117,
    lng: 16.3738,
    score: 3.6,
    status: "warning",
    type: "Lidl Express",
    address: "Vienna, Leopoldstadt",
  },
  {
    id: 687,
    name: "Lidl Dublin-Ballsbridge",
    lat: 53.326,
    lng: -6.2611,
    score: 4.7,
    status: "success",
    type: "Lidl",
    address: "Dublin, Ballsbridge",
  },
  {
    id: 688,
    name: "Lidl Toulon-Le Mourillon",
    lat: 43.1291,
    lng: 5.9317,
    score: 4.6,
    status: "success",
    type: "Lidl",
    address: "Toulon, Le Mourillon",
  },
  {
    id: 689,
    name: "Lidl Express Glasgow-North",
    lat: 55.8505,
    lng: -4.2288,
    score: 3.7,
    status: "warning",
    type: "Lidl Express",
    address: "Glasgow, North",
  },
  {
    id: 690,
    name: "Lidl Haarlem-Zuid",
    lat: 52.3939,
    lng: 4.6567,
    score: 4.5,
    status: "success",
    type: "Lidl",
    address: "Haarlem, Zuid",
  },
  {
    id: 691,
    name: "Lidl Coimbra-Centro",
    lat: 40.2046,
    lng: -8.4347,
    score: 3.8,
    status: "warning",
    type: "Lidl",
    address: "Coimbra, Centro",
  },
  {
    id: 692,
    name: "Lidl Paris-11e",
    lat: 48.8321,
    lng: 2.3521,
    score: 4.9,
    status: "success",
    type: "Lidl",
    address: "Paris, 11e",
  },
  {
    id: 693,
    name: "Lidl Express Zaanstad-Zaandam",
    lat: 52.4679,
    lng: 4.8039,
    score: 3.4,
    status: "danger",
    type: "Lidl Express",
    address: "Zaanstad, Zaandam",
  },
  {
    id: 694,
    name: "Lidl Sheffield-Dore",
    lat: 53.3985,
    lng: -1.4466,
    score: 4.2,
    status: "warning",
    type: "Lidl",
    address: "Sheffield, Dore",
  },
  {
    id: 695,
    name: "Lidl Ghent-Centrum",
    lat: 51.0791,
    lng: 3.7051,
    score: 2.7,
    status: "danger",
    type: "Lidl",
    address: "Ghent, Centrum",
  },
  {
    id: 696,
    name: "Lidl Nottingham-City Centre",
    lat: 52.9588,
    lng: -1.1695,
    score: 2.5,
    status: "danger",
    type: "Lidl",
    address: "Nottingham, City Centre",
  },
  {
    id: 697,
    name: "Lidl Express Washington-Adams Morgan",
    lat: 38.8932,
    lng: -77.0591,
    score: 3.5,
    status: "warning",
    type: "Lidl Express",
    address: "Washington, Adams Morgan",
  },
  {
    id: 698,
    name: "Lidl Nantes-Centre",
    lat: 47.1965,
    lng: -1.5718,
    score: 3.9,
    status: "warning",
    type: "Lidl",
    address: "Nantes, Centre",
  },
  {
    id: 699,
    name: "Lidl St. Gallen-St. Georgen",
    lat: 47.439,
    lng: 9.3864,
    score: 3.4,
    status: "danger",
    type: "Lidl",
    address: "St. Gallen, St. Georgen",
  },
  {
    id: 700,
    name: "Lidl XL Bucharest-Floreasca",
    lat: 44.4371,
    lng: 26.1041,
    score: 3,
    status: "danger",
    type: "Lidl XL",
    address: "Bucharest, Floreasca",
  },
  {
    id: 701,
    name: "Lidl Express Athens-Marousi",
    lat: 37.992,
    lng: 23.7343,
    score: 3.7,
    status: "warning",
    type: "Lidl Express",
    address: "Athens, Marousi",
  },
  {
    id: 702,
    name: "Lidl Prague-Praha 7",
    lat: 50.0642,
    lng: 14.4607,
    score: 2.7,
    status: "danger",
    type: "Lidl",
    address: "Prague, Praha 7",
  },
  {
    id: 703,
    name: "Lidl XL Montpellier-Centre",
    lat: 43.5978,
    lng: 3.8977,
    score: 4.2,
    status: "success",
    type: "Lidl XL",
    address: "Montpellier, Centre",
  },
  {
    id: 704,
    name: "Lidl Raleigh-Downtown",
    lat: 35.7908,
    lng: -78.6326,
    score: 2.8,
    status: "danger",
    type: "Lidl",
    address: "Raleigh, Downtown",
  },
  {
    id: 705,
    name: "Lidl XL Zagreb-Podsljeme",
    lat: 45.8375,
    lng: 15.9853,
    score: 4,
    status: "warning",
    type: "Lidl XL",
    address: "Zagreb, Podsljeme",
  },
  {
    id: 706,
    name: "Lidl XL Ostrava-Vítkovice",
    lat: 49.8241,
    lng: 18.262,
    score: 3.5,
    status: "warning",
    type: "Lidl XL",
    address: "Ostrava, Vítkovice",
  },
  {
    id: 707,
    name: "Lidl London-Harrow",
    lat: 51.5145,
    lng: -0.1303,
    score: 4.1,
    status: "warning",
    type: "Lidl",
    address: "London, Harrow",
  },
  {
    id: 708,
    name: "Lidl Bucharest-Sector 6",
    lat: 44.4254,
    lng: 26.1252,
    score: 4.7,
    status: "success",
    type: "Lidl",
    address: "Bucharest, Sector 6",
  },
  {
    id: 709,
    name: "Lidl Express Faro-Montenegro",
    lat: 37.0129,
    lng: -7.9295,
    score: 4.2,
    status: "success",
    type: "Lidl Express",
    address: "Faro, Montenegro",
  },
  {
    id: 710,
    name: "Lidl Southampton-Swaythling",
    lat: 50.8861,
    lng: -1.4009,
    score: 4.5,
    status: "success",
    type: "Lidl",
    address: "Southampton, Swaythling",
  },
  {
    id: 711,
    name: "Lidl XL Porto-Campanhã",
    lat: 41.1761,
    lng: -8.6208,
    score: 4.3,
    status: "success",
    type: "Lidl XL",
    address: "Porto, Campanhã",
  },
  {
    id: 712,
    name: "Lidl Gdansk-Przymorze",
    lat: 54.3404,
    lng: 18.6653,
    score: 4.9,
    status: "success",
    type: "Lidl",
    address: "Gdansk, Przymorze",
  },
  {
    id: 713,
    name: "Lidl Sofia-Krasna polyana",
    lat: 42.6838,
    lng: 23.3217,
    score: 4.3,
    status: "success",
    type: "Lidl",
    address: "Sofia, Krasna polyana",
  },
  {
    id: 714,
    name: "Lidl XL Baltimore-Dundalk",
    lat: 39.275,
    lng: -76.6051,
    score: 3.6,
    status: "warning",
    type: "Lidl XL",
    address: "Baltimore, Dundalk",
  },
  {
    id: 715,
    name: "Lidl XL Osijek-Gornji Grad",
    lat: 45.5792,
    lng: 18.703,
    score: 2.5,
    status: "danger",
    type: "Lidl XL",
    address: "Osijek, Gornji Grad",
  },
  {
    id: 716,
    name: "Lidl Express Sofia-Oborishte",
    lat: 42.6798,
    lng: 23.3383,
    score: 5,
    status: "success",
    type: "Lidl Express",
    address: "Sofia, Oborishte",
  },
  {
    id: 717,
    name: "Lidl Express Vienna-Josefstadt",
    lat: 48.2197,
    lng: 16.3565,
    score: 4.4,
    status: "success",
    type: "Lidl Express",
    address: "Vienna, Josefstadt",
  },
  {
    id: 718,
    name: "Lidl Burgas-Centar",
    lat: 42.493,
    lng: 27.4756,
    score: 4,
    status: "warning",
    type: "Lidl",
    address: "Burgas, Centar",
  },
  {
    id: 719,
    name: "Lidl XL Galway-Salthill",
    lat: 53.2564,
    lng: -9.08,
    score: 3.5,
    status: "warning",
    type: "Lidl XL",
    address: "Galway, Salthill",
  },
  {
    id: 720,
    name: "Lidl XL Szczecin-Śródmieście",
    lat: 53.4474,
    lng: 14.555,
    score: 4.3,
    status: "success",
    type: "Lidl XL",
    address: "Szczecin, Śródmieście",
  },
  {
    id: 721,
    name: "Lidl Express Groningen-Centrum",
    lat: 53.2427,
    lng: 6.5667,
    score: 4,
    status: "warning",
    type: "Lidl Express",
    address: "Groningen, Centrum",
  },
  {
    id: 722,
    name: "Lidl Lille-Hellemmes",
    lat: 50.6358,
    lng: 3.0531,
    score: 4.4,
    status: "success",
    type: "Lidl",
    address: "Lille, Hellemmes",
  },
  {
    id: 723,
    name: "Lidl XL Seville-Macarena",
    lat: 37.3854,
    lng: -5.9894,
    score: 4.2,
    status: "success",
    type: "Lidl XL",
    address: "Seville, Macarena",
  },
  {
    id: 724,
    name: "Lidl XL Trieste-Città Nuova",
    lat: 45.6731,
    lng: 13.7829,
    score: 3.7,
    status: "warning",
    type: "Lidl XL",
    address: "Trieste, Città Nuova",
  },
  {
    id: 725,
    name: "Lidl Budapest-District VI",
    lat: 47.499,
    lng: 19.0486,
    score: 3.4,
    status: "warning",
    type: "Lidl",
    address: "Budapest, District VI",
  },
  {
    id: 726,
    name: "Lidl Express Valladolid-Este",
    lat: 41.6747,
    lng: -4.7493,
    score: 3,
    status: "danger",
    type: "Lidl Express",
    address: "Valladolid, Este",
  },
  {
    id: 727,
    name: "Lidl Express Larissa-Nikea",
    lat: 39.6436,
    lng: 22.426,
    score: 2.6,
    status: "danger",
    type: "Lidl Express",
    address: "Larissa, Nikea",
  },
  {
    id: 728,
    name: "Lidl XL Rijeka-Pećine",
    lat: 45.3491,
    lng: 14.4238,
    score: 3.7,
    status: "warning",
    type: "Lidl XL",
    address: "Rijeka, Pećine",
  },
  {
    id: 729,
    name: "Lidl Toulouse-Capitole",
    lat: 43.6294,
    lng: 1.4691,
    score: 3.3,
    status: "danger",
    type: "Lidl",
    address: "Toulouse, Capitole",
  },
  {
    id: 730,
    name: "Lidl Express Milan-Centro",
    lat: 45.4554,
    lng: 9.1733,
    score: 3.6,
    status: "warning",
    type: "Lidl Express",
    address: "Milan, Centro",
  },
  {
    id: 731,
    name: "Lidl Express Katowice-Wełnowiec",
    lat: 50.2674,
    lng: 19.0315,
    score: 4.7,
    status: "success",
    type: "Lidl Express",
    address: "Katowice, Wełnowiec",
  },
  {
    id: 732,
    name: "Lidl XL Lyon-9e",
    lat: 45.753,
    lng: 4.8217,
    score: 3.4,
    status: "warning",
    type: "Lidl XL",
    address: "Lyon, 9e",
  },
  {
    id: 733,
    name: "Lidl XL Marseille-13e",
    lat: 43.31,
    lng: 5.3543,
    score: 4,
    status: "warning",
    type: "Lidl XL",
    address: "Marseille, 13e",
  },
  {
    id: 734,
    name: "Lidl Strasbourg-Centre",
    lat: 48.5486,
    lng: 7.7401,
    score: 4.9,
    status: "success",
    type: "Lidl",
    address: "Strasbourg, Centre",
  },
  {
    id: 735,
    name: "Lidl XL Białystok-Piaski",
    lat: 53.1524,
    lng: 23.1713,
    score: 4.6,
    status: "success",
    type: "Lidl XL",
    address: "Białystok, Piaski",
  },
  {
    id: 736,
    name: "Lidl XL Lyon-2e",
    lat: 45.7691,
    lng: 4.8207,
    score: 4.3,
    status: "success",
    type: "Lidl XL",
    address: "Lyon, 2e",
  },
  {
    id: 737,
    name: "Lidl Express Zaanstad-Assendelft",
    lat: 52.4843,
    lng: 4.8347,
    score: 4.1,
    status: "warning",
    type: "Lidl Express",
    address: "Zaanstad, Assendelft",
  },
  {
    id: 738,
    name: "Lidl Express Maribor-Centrum",
    lat: 46.5464,
    lng: 15.646,
    score: 4.7,
    status: "success",
    type: "Lidl Express",
    address: "Maribor, Centrum",
  },
  {
    id: 739,
    name: "Lidl Nîmes-Pissevin",
    lat: 43.8401,
    lng: 4.336,
    score: 3.9,
    status: "warning",
    type: "Lidl",
    address: "Nîmes, Pissevin",
  },
  {
    id: 740,
    name: "Lidl Winterthur-Altstadt",
    lat: 47.4976,
    lng: 8.7021,
    score: 4.6,
    status: "success",
    type: "Lidl",
    address: "Winterthur, Altstadt",
  },
  {
    id: 741,
    name: "Lidl Barcelona-Gràcia",
    lat: 41.3623,
    lng: 2.1608,
    score: 3.6,
    status: "warning",
    type: "Lidl",
    address: "Barcelona, Gràcia",
  },
  {
    id: 742,
    name: "Lidl Charleston-West Ashley",
    lat: 32.7969,
    lng: -79.9532,
    score: 3.1,
    status: "danger",
    type: "Lidl",
    address: "Charleston, West Ashley",
  },
  {
    id: 743,
    name: "Lidl Express Brussels-Jette",
    lat: 50.8528,
    lng: 4.3336,
    score: 4.4,
    status: "success",
    type: "Lidl Express",
    address: "Brussels, Jette",
  },
  {
    id: 744,
    name: "Lidl Tilburg-Oost",
    lat: 51.5663,
    lng: 5.1137,
    score: 3.5,
    status: "warning",
    type: "Lidl",
    address: "Tilburg, Oost",
  },
  {
    id: 745,
    name: "Lidl Express Valencia-L'Eixample",
    lat: 39.4779,
    lng: -0.3764,
    score: 4.6,
    status: "success",
    type: "Lidl Express",
    address: "Valencia, L'Eixample",
  },
  {
    id: 746,
    name: "Lidl Express New York-Bronx",
    lat: 40.7005,
    lng: -73.9833,
    score: 4.6,
    status: "success",
    type: "Lidl Express",
    address: "New York, Bronx",
  },
  {
    id: 747,
    name: "Lidl XL Breda-West",
    lat: 51.5826,
    lng: 4.7732,
    score: 4.3,
    status: "success",
    type: "Lidl XL",
    address: "Breda, West",
  },
  {
    id: 748,
    name: "Lidl XL Amsterdam-Sloterdijk",
    lat: 52.386,
    lng: 4.9055,
    score: 4.9,
    status: "success",
    type: "Lidl XL",
    address: "Amsterdam, Sloterdijk",
  },
  {
    id: 749,
    name: "Lidl Express Constanta-Palazu",
    lat: 44.1578,
    lng: 28.6261,
    score: 3.3,
    status: "danger",
    type: "Lidl Express",
    address: "Constanta, Palazu",
  },
  {
    id: 750,
    name: "Lidl Express Haarlem-Oost",
    lat: 52.407,
    lng: 4.6545,
    score: 3.7,
    status: "warning",
    type: "Lidl Express",
    address: "Haarlem, Oost",
  },
  {
    id: 751,
    name: "Lidl Brighton-Hove",
    lat: 50.8373,
    lng: -0.1521,
    score: 3.9,
    status: "warning",
    type: "Lidl",
    address: "Brighton, Hove",
  },
  {
    id: 752,
    name: "Lidl Newcastle-Heaton",
    lat: 54.99,
    lng: -1.6278,
    score: 4.2,
    status: "warning",
    type: "Lidl",
    address: "Newcastle, Heaton",
  },
  {
    id: 753,
    name: "Lidl Bilbao-Deusto",
    lat: 43.2603,
    lng: -2.9444,
    score: 3,
    status: "danger",
    type: "Lidl",
    address: "Bilbao, Deusto",
  },
  {
    id: 754,
    name: "Lidl Express Palma-Palma Nord",
    lat: 39.5847,
    lng: 2.6278,
    score: 3.3,
    status: "danger",
    type: "Lidl Express",
    address: "Palma, Palma Nord",
  },
  {
    id: 755,
    name: "Lidl Express Le Mans-Centre",
    lat: 48.0131,
    lng: 0.1954,
    score: 4.9,
    status: "success",
    type: "Lidl Express",
    address: "Le Mans, Centre",
  },
  {
    id: 756,
    name: "Lidl XL Florence-Novoli",
    lat: 43.7916,
    lng: 11.239,
    score: 4.7,
    status: "success",
    type: "Lidl XL",
    address: "Florence, Novoli",
  },
  {
    id: 757,
    name: "Lidl Charleston-North Charleston",
    lat: 32.7922,
    lng: -79.9247,
    score: 3.4,
    status: "warning",
    type: "Lidl",
    address: "Charleston, North Charleston",
  },
  {
    id: 758,
    name: "Lidl XL Angers-Belle-Beille",
    lat: 47.4924,
    lng: -0.5491,
    score: 4.3,
    status: "success",
    type: "Lidl XL",
    address: "Angers, Belle-Beille",
  },
  {
    id: 759,
    name: "Lidl Zurich-Kreis 4",
    lat: 47.3821,
    lng: 8.5597,
    score: 3.9,
    status: "warning",
    type: "Lidl",
    address: "Zurich, Kreis 4",
  },
  {
    id: 760,
    name: "Lidl XL Gijon-Sur",
    lat: 43.5495,
    lng: -5.6607,
    score: 3.9,
    status: "warning",
    type: "Lidl XL",
    address: "Gijon, Sur",
  },
  {
    id: 761,
    name: "Lidl Express Le Mans-Sablon",
    lat: 47.9846,
    lng: 0.1783,
    score: 4.7,
    status: "success",
    type: "Lidl Express",
    address: "Le Mans, Sablon",
  },
  {
    id: 762,
    name: "Lidl Express Klagenfurt-St. Ruprecht",
    lat: 46.6251,
    lng: 14.3166,
    score: 2.7,
    status: "danger",
    type: "Lidl Express",
    address: "Klagenfurt, St. Ruprecht",
  },
  {
    id: 763,
    name: "Lidl Express London-Lewisham",
    lat: 51.5299,
    lng: -0.1396,
    score: 4.2,
    status: "warning",
    type: "Lidl Express",
    address: "London, Lewisham",
  },
  {
    id: 764,
    name: "Lidl Wroclaw-Krzyki",
    lat: 51.0953,
    lng: 17.0324,
    score: 5,
    status: "success",
    type: "Lidl",
    address: "Wroclaw, Krzyki",
  },
  {
    id: 765,
    name: "Lidl Express Toulouse-Empalot",
    lat: 43.6037,
    lng: 1.4348,
    score: 4,
    status: "warning",
    type: "Lidl Express",
    address: "Toulouse, Empalot",
  },
  {
    id: 766,
    name: "Lidl Genoa-Bolzaneto",
    lat: 44.3899,
    lng: 8.9346,
    score: 3.1,
    status: "danger",
    type: "Lidl",
    address: "Genoa, Bolzaneto",
  },
  {
    id: 767,
    name: "Lidl Malaga-Palma-Palmilla",
    lat: 36.7243,
    lng: -4.398,
    score: 3.1,
    status: "danger",
    type: "Lidl",
    address: "Malaga, Palma-Palmilla",
  },
  {
    id: 768,
    name: "Lidl XL Vienna-Simmering",
    lat: 48.2016,
    lng: 16.35,
    score: 4.1,
    status: "warning",
    type: "Lidl XL",
    address: "Vienna, Simmering",
  },
  {
    id: 769,
    name: "Lidl Genoa-Boccadasse",
    lat: 44.3895,
    lng: 8.9503,
    score: 4.5,
    status: "success",
    type: "Lidl",
    address: "Genoa, Boccadasse",
  },
  {
    id: 770,
    name: "Lidl Express Milan-Niguarda",
    lat: 45.473,
    lng: 9.2014,
    score: 2.6,
    status: "danger",
    type: "Lidl Express",
    address: "Milan, Niguarda",
  },
  {
    id: 771,
    name: "Lidl Antwerp-Deurne",
    lat: 51.2284,
    lng: 4.3876,
    score: 3,
    status: "danger",
    type: "Lidl",
    address: "Antwerp, Deurne",
  },
  {
    id: 772,
    name: "Lidl XL Paris-5e",
    lat: 48.8615,
    lng: 2.3452,
    score: 4.8,
    status: "success",
    type: "Lidl XL",
    address: "Paris, 5e",
  },
  {
    id: 773,
    name: "Lidl Brescia-Sud",
    lat: 45.5602,
    lng: 10.2262,
    score: 3.5,
    status: "warning",
    type: "Lidl",
    address: "Brescia, Sud",
  },
  {
    id: 774,
    name: "Lidl Express Southampton-Portswood",
    lat: 50.887,
    lng: -1.3981,
    score: 4.1,
    status: "warning",
    type: "Lidl Express",
    address: "Southampton, Portswood",
  },
  {
    id: 775,
    name: "Lidl Express Padua-Nord",
    lat: 45.4074,
    lng: 11.8597,
    score: 4.6,
    status: "success",
    type: "Lidl Express",
    address: "Padua, Nord",
  },
  {
    id: 776,
    name: "Lidl Express Breda-Zuid",
    lat: 51.5709,
    lng: 4.7443,
    score: 4.6,
    status: "success",
    type: "Lidl Express",
    address: "Breda, Zuid",
  },
  {
    id: 777,
    name: "Lidl Express Gdansk-Orunia",
    lat: 54.368,
    lng: 18.6446,
    score: 3.2,
    status: "danger",
    type: "Lidl Express",
    address: "Gdansk, Orunia",
  },
  {
    id: 778,
    name: "Lidl Express Maribor-Tabor",
    lat: 46.552,
    lng: 15.6302,
    score: 3.3,
    status: "danger",
    type: "Lidl Express",
    address: "Maribor, Tabor",
  },
  {
    id: 779,
    name: "Lidl XL Bruges-Assebroek",
    lat: 51.2048,
    lng: 3.2343,
    score: 3.9,
    status: "warning",
    type: "Lidl XL",
    address: "Bruges, Assebroek",
  },
  {
    id: 780,
    name: "Lidl Express Athens-Glyfada",
    lat: 37.9617,
    lng: 23.7261,
    score: 4.5,
    status: "success",
    type: "Lidl Express",
    address: "Athens, Glyfada",
  },
  {
    id: 781,
    name: "Lidl XL Marseille-12e",
    lat: 43.2992,
    lng: 5.3945,
    score: 4.7,
    status: "success",
    type: "Lidl XL",
    address: "Marseille, 12e",
  },
  {
    id: 782,
    name: "Lidl Arnhem-Zuid",
    lat: 51.9951,
    lng: 5.8805,
    score: 2.9,
    status: "danger",
    type: "Lidl",
    address: "Arnhem, Zuid",
  },
  {
    id: 783,
    name: "Lidl XL Rome-Prenestino",
    lat: 41.9065,
    lng: 12.5023,
    score: 3.6,
    status: "warning",
    type: "Lidl XL",
    address: "Rome, Prenestino",
  },
  {
    id: 784,
    name: "Lidl Express Zadar-Centar",
    lat: 44.1115,
    lng: 15.2555,
    score: 3.5,
    status: "warning",
    type: "Lidl Express",
    address: "Zadar, Centar",
  },
  {
    id: 785,
    name: "Lidl Ostrava-Slezská Ostrava",
    lat: 49.8311,
    lng: 18.248,
    score: 4.2,
    status: "warning",
    type: "Lidl",
    address: "Ostrava, Slezská Ostrava",
  },
  {
    id: 786,
    name: "Lidl Express Angers-La Roseraie",
    lat: 47.4858,
    lng: -0.5649,
    score: 4.6,
    status: "success",
    type: "Lidl Express",
    address: "Angers, La Roseraie",
  },
  {
    id: 787,
    name: "Lidl Debrecen-Centrum",
    lat: 47.5141,
    lng: 21.6359,
    score: 4.3,
    status: "success",
    type: "Lidl",
    address: "Debrecen, Centrum",
  },
  {
    id: 788,
    name: "Lidl XL Klagenfurt-Villacher Vorstadt",
    lat: 46.6431,
    lng: 14.2832,
    score: 3.8,
    status: "warning",
    type: "Lidl XL",
    address: "Klagenfurt, Villacher Vorstadt",
  },
  {
    id: 789,
    name: "Lidl Express Warsaw-Ursus",
    lat: 52.2306,
    lng: 20.9898,
    score: 3.1,
    status: "danger",
    type: "Lidl Express",
    address: "Warsaw, Ursus",
  },
  {
    id: 790,
    name: "Lidl Express Brescia-Est",
    lat: 45.5244,
    lng: 10.2314,
    score: 3.3,
    status: "danger",
    type: "Lidl Express",
    address: "Brescia, Est",
  },
  {
    id: 791,
    name: "Lidl Express Ceske Budejovice-Čtyři Dvory",
    lat: 48.969,
    lng: 14.4984,
    score: 4.5,
    status: "success",
    type: "Lidl Express",
    address: "Ceske Budejovice, Čtyři Dvory",
  },
  {
    id: 792,
    name: "Lidl Express Limerick-Castletroy",
    lat: 52.654,
    lng: -8.6447,
    score: 3.7,
    status: "warning",
    type: "Lidl Express",
    address: "Limerick, Castletroy",
  },
  {
    id: 793,
    name: "Lidl Express Edinburgh-Corstorphine",
    lat: 55.9283,
    lng: -3.2108,
    score: 4.7,
    status: "success",
    type: "Lidl Express",
    address: "Edinburgh, Corstorphine",
  },
  {
    id: 794,
    name: "Lidl Express Rotterdam-Feijenoord",
    lat: 51.9043,
    lng: 4.4971,
    score: 2.8,
    status: "danger",
    type: "Lidl Express",
    address: "Rotterdam, Feijenoord",
  },
  {
    id: 795,
    name: "Lidl XL Lisbon-Benfica",
    lat: 38.7097,
    lng: -9.1239,
    score: 4.4,
    status: "success",
    type: "Lidl XL",
    address: "Lisbon, Benfica",
  },
  {
    id: 796,
    name: "Lidl Express Groningen-Noord",
    lat: 53.2208,
    lng: 6.588,
    score: 3,
    status: "danger",
    type: "Lidl Express",
    address: "Groningen, Noord",
  },
  {
    id: 797,
    name: "Lidl Salzburg-Maxglan",
    lat: 47.7916,
    lng: 13.0787,
    score: 4.2,
    status: "warning",
    type: "Lidl",
    address: "Salzburg, Maxglan",
  },
  {
    id: 798,
    name: "Lidl Budapest-Óbuda",
    lat: 47.5057,
    lng: 19.0283,
    score: 3.4,
    status: "warning",
    type: "Lidl",
    address: "Budapest, Óbuda",
  },
  {
    id: 799,
    name: "Lidl XL Zurich-Kreis 1",
    lat: 47.3543,
    lng: 8.5637,
    score: 4.7,
    status: "success",
    type: "Lidl XL",
    address: "Zurich, Kreis 1",
  },
  {
    id: 800,
    name: "Lidl XL Brussels-Uccle",
    lat: 50.831,
    lng: 4.3654,
    score: 4,
    status: "warning",
    type: "Lidl XL",
    address: "Brussels, Uccle",
  },
  {
    id: 801,
    name: "Lidl XL Budapest-District VII",
    lat: 47.5114,
    lng: 19.0269,
    score: 4.5,
    status: "success",
    type: "Lidl XL",
    address: "Budapest, District VII",
  },
  {
    id: 802,
    name: "Lidl Lyon-6e",
    lat: 45.7701,
    lng: 4.8432,
    score: 3.7,
    status: "warning",
    type: "Lidl",
    address: "Lyon, 6e",
  },
  {
    id: 803,
    name: "Lidl Angers-Centre",
    lat: 47.4717,
    lng: -0.5518,
    score: 4.3,
    status: "success",
    type: "Lidl",
    address: "Angers, Centre",
  },
  {
    id: 804,
    name: "Lidl Express Sofia-Krasno selo",
    lat: 42.6834,
    lng: 23.3432,
    score: 3.8,
    status: "warning",
    type: "Lidl Express",
    address: "Sofia, Krasno selo",
  },
  {
    id: 805,
    name: "Lidl Express Nantes-Doulon",
    lat: 47.2234,
    lng: -1.5726,
    score: 3.1,
    status: "danger",
    type: "Lidl Express",
    address: "Nantes, Doulon",
  },
  {
    id: 806,
    name: "Lidl Express Burgas-Meden Rudnik",
    lat: 42.4896,
    lng: 27.4471,
    score: 4.7,
    status: "success",
    type: "Lidl Express",
    address: "Burgas, Meden Rudnik",
  },
  {
    id: 807,
    name: "Lidl Express Philadelphia-Center City",
    lat: 39.9394,
    lng: -75.1553,
    score: 4.5,
    status: "success",
    type: "Lidl Express",
    address: "Philadelphia, Center City",
  },
  {
    id: 808,
    name: "Lidl Glasgow-Pollokshields",
    lat: 55.8661,
    lng: -4.2669,
    score: 3.5,
    status: "warning",
    type: "Lidl",
    address: "Glasgow, Pollokshields",
  },
  {
    id: 809,
    name: "Lidl Palermo-Montepellegrino",
    lat: 38.1181,
    lng: 13.3694,
    score: 4.1,
    status: "warning",
    type: "Lidl",
    address: "Palermo, Montepellegrino",
  },
  {
    id: 810,
    name: "Lidl Express Wroclaw-Fabryczna",
    lat: 51.1265,
    lng: 17.037,
    score: 4.4,
    status: "success",
    type: "Lidl Express",
    address: "Wroclaw, Fabryczna",
  },
  {
    id: 811,
    name: "Lidl Nottingham-Clifton",
    lat: 52.9302,
    lng: -1.1755,
    score: 3.8,
    status: "warning",
    type: "Lidl",
    address: "Nottingham, Clifton",
  },
  {
    id: 812,
    name: "Lidl XL Charleston-James Island",
    lat: 32.7683,
    lng: -79.9061,
    score: 3.2,
    status: "danger",
    type: "Lidl XL",
    address: "Charleston, James Island",
  },
  {
    id: 813,
    name: "Lidl XL Ljubljana-Trnovo",
    lat: 46.0422,
    lng: 14.5082,
    score: 3.1,
    status: "danger",
    type: "Lidl XL",
    address: "Ljubljana, Trnovo",
  },
  {
    id: 814,
    name: "Lidl Express Brussels-Etterbeek",
    lat: 50.841,
    lng: 4.3361,
    score: 4,
    status: "warning",
    type: "Lidl Express",
    address: "Brussels, Etterbeek",
  },
  {
    id: 815,
    name: "Lidl Express Graz-Gries",
    lat: 47.0812,
    lng: 15.4225,
    score: 2.7,
    status: "danger",
    type: "Lidl Express",
    address: "Graz, Gries",
  },
  {
    id: 816,
    name: "Lidl XL Madrid-San Blas",
    lat: 40.3962,
    lng: -3.688,
    score: 3.9,
    status: "warning",
    type: "Lidl XL",
    address: "Madrid, San Blas",
  },
  {
    id: 817,
    name: "Lidl Naples-Secondigliano",
    lat: 40.8745,
    lng: 14.2835,
    score: 3.5,
    status: "warning",
    type: "Lidl",
    address: "Naples, Secondigliano",
  },
  {
    id: 818,
    name: "Lidl XL Baltimore-Towson",
    lat: 39.2936,
    lng: -76.6144,
    score: 4.7,
    status: "success",
    type: "Lidl XL",
    address: "Baltimore, Towson",
  },
  {
    id: 819,
    name: "Lidl Express Setubal-Centro",
    lat: 38.5251,
    lng: -8.8782,
    score: 2.5,
    status: "danger",
    type: "Lidl Express",
    address: "Setubal, Centro",
  },
  {
    id: 820,
    name: "Lidl Nottingham-Beeston",
    lat: 52.9452,
    lng: -1.1657,
    score: 2.7,
    status: "danger",
    type: "Lidl",
    address: "Nottingham, Beeston",
  },
  {
    id: 821,
    name: "Lidl Express Brasov-Stupini",
    lat: 45.6627,
    lng: 25.6095,
    score: 2.7,
    status: "danger",
    type: "Lidl Express",
    address: "Brasov, Stupini",
  },
  {
    id: 822,
    name: "Lidl Marseille-10e",
    lat: 43.3191,
    lng: 5.3579,
    score: 2.9,
    status: "danger",
    type: "Lidl",
    address: "Marseille, 10e",
  },
  {
    id: 823,
    name: "Lidl Express Paris-9e",
    lat: 48.8425,
    lng: 2.3656,
    score: 2.6,
    status: "danger",
    type: "Lidl Express",
    address: "Paris, 9e",
  },
  {
    id: 824,
    name: "Lidl XL Glasgow-West End",
    lat: 55.872,
    lng: -4.2425,
    score: 3.9,
    status: "warning",
    type: "Lidl XL",
    address: "Glasgow, West End",
  },
  {
    id: 825,
    name: "Lidl Express Richmond-Downtown",
    lat: 37.521,
    lng: -77.4163,
    score: 3.3,
    status: "danger",
    type: "Lidl Express",
    address: "Richmond, Downtown",
  },
  {
    id: 826,
    name: "Lidl Express Brno-Královo Pole",
    lat: 49.1876,
    lng: 16.6101,
    score: 2.6,
    status: "danger",
    type: "Lidl Express",
    address: "Brno, Královo Pole",
  },
  {
    id: 827,
    name: "Lidl XL Naples-Mergellina",
    lat: 40.8706,
    lng: 14.2537,
    score: 2.7,
    status: "danger",
    type: "Lidl XL",
    address: "Naples, Mergellina",
  },
  {
    id: 828,
    name: "Lidl Brussels-Ixelles",
    lat: 50.862,
    lng: 4.3515,
    score: 3.7,
    status: "warning",
    type: "Lidl",
    address: "Brussels, Ixelles",
  },
  {
    id: 829,
    name: "Lidl Katowice-Śródmieście",
    lat: 50.2552,
    lng: 19.0186,
    score: 3.9,
    status: "warning",
    type: "Lidl",
    address: "Katowice, Śródmieście",
  },
  {
    id: 830,
    name: "Lidl Sosnowiec-Klimontów",
    lat: 50.2978,
    lng: 19.0896,
    score: 2.6,
    status: "danger",
    type: "Lidl",
    address: "Sosnowiec, Klimontów",
  },
  {
    id: 831,
    name: "Lidl Express Palermo-Centro",
    lat: 38.1043,
    lng: 13.3631,
    score: 2.9,
    status: "danger",
    type: "Lidl Express",
    address: "Palermo, Centro",
  },
  {
    id: 832,
    name: "Lidl XL Madrid-Usera",
    lat: 40.405,
    lng: -3.6977,
    score: 4.6,
    status: "success",
    type: "Lidl XL",
    address: "Madrid, Usera",
  },
  {
    id: 833,
    name: "Lidl Athens-Kifissia",
    lat: 37.9948,
    lng: 23.7314,
    score: 4.5,
    status: "success",
    type: "Lidl",
    address: "Athens, Kifissia",
  },
  {
    id: 834,
    name: "Lidl London-Camden",
    lat: 51.5321,
    lng: -0.1434,
    score: 3.8,
    status: "warning",
    type: "Lidl",
    address: "London, Camden",
  },
  {
    id: 835,
    name: "Lidl Express Ploiesti-Centru",
    lat: 44.9241,
    lng: 25.9979,
    score: 3.4,
    status: "warning",
    type: "Lidl Express",
    address: "Ploiesti, Centru",
  },
  {
    id: 836,
    name: "Lidl Express Sheffield-Hillsborough",
    lat: 53.3875,
    lng: -1.4579,
    score: 4.2,
    status: "warning",
    type: "Lidl Express",
    address: "Sheffield, Hillsborough",
  },
  {
    id: 837,
    name: "Lidl Express Bologna-San Vitale",
    lat: 44.5014,
    lng: 11.3457,
    score: 5,
    status: "success",
    type: "Lidl Express",
    address: "Bologna, San Vitale",
  },
  {
    id: 838,
    name: "Lidl Sofia-Lozenets",
    lat: 42.6887,
    lng: 23.299,
    score: 3.9,
    status: "warning",
    type: "Lidl",
    address: "Sofia, Lozenets",
  },
  {
    id: 839,
    name: "Lidl XL Bologna-Borgo Panigale",
    lat: 44.5086,
    lng: 11.3532,
    score: 3.2,
    status: "danger",
    type: "Lidl XL",
    address: "Bologna, Borgo Panigale",
  },
  {
    id: 840,
    name: "Lidl XL Lisbon-Belém",
    lat: 38.7126,
    lng: -9.1225,
    score: 3.6,
    status: "warning",
    type: "Lidl XL",
    address: "Lisbon, Belém",
  },
  {
    id: 841,
    name: "Lidl Express Athens-Centre",
    lat: 37.991,
    lng: 23.7183,
    score: 4.6,
    status: "success",
    type: "Lidl Express",
    address: "Athens, Centre",
  },
  {
    id: 842,
    name: "Lidl Bruges-Centrum",
    lat: 51.2336,
    lng: 3.2208,
    score: 2.8,
    status: "danger",
    type: "Lidl",
    address: "Bruges, Centrum",
  },
  {
    id: 843,
    name: "Lidl XL Poznan-Wilda",
    lat: 52.3939,
    lng: 16.9211,
    score: 3.8,
    status: "warning",
    type: "Lidl XL",
    address: "Poznan, Wilda",
  },
  {
    id: 844,
    name: "Lidl Osijek-Donji Grad",
    lat: 45.5547,
    lng: 18.6817,
    score: 4.7,
    status: "success",
    type: "Lidl",
    address: "Osijek, Donji Grad",
  },
  {
    id: 845,
    name: "Lidl XL Edinburgh-Marchmont",
    lat: 55.9489,
    lng: -3.2023,
    score: 3.7,
    status: "warning",
    type: "Lidl XL",
    address: "Edinburgh, Marchmont",
  },
  {
    id: 846,
    name: "Lidl Ljubljana-Vič",
    lat: 46.0401,
    lng: 14.5022,
    score: 2.8,
    status: "danger",
    type: "Lidl",
    address: "Ljubljana, Vič",
  },
  {
    id: 847,
    name: "Lidl Czestochowa-Północ",
    lat: 50.7988,
    lng: 19.1036,
    score: 3.3,
    status: "danger",
    type: "Lidl",
    address: "Czestochowa, Północ",
  },
  {
    id: 848,
    name: "Lidl XL Washington-Silver Spring",
    lat: 38.9036,
    lng: -77.0179,
    score: 4.1,
    status: "warning",
    type: "Lidl XL",
    address: "Washington, Silver Spring",
  },
  {
    id: 849,
    name: "Lidl Strasbourg-Koenigshoffen",
    lat: 48.5871,
    lng: 7.7532,
    score: 4.7,
    status: "success",
    type: "Lidl",
    address: "Strasbourg, Koenigshoffen",
  },
  {
    id: 850,
    name: "Lidl Verona-Borgo Trento",
    lat: 45.4413,
    lng: 10.982,
    score: 4.7,
    status: "success",
    type: "Lidl",
    address: "Verona, Borgo Trento",
  },
  {
    id: 851,
    name: "Lidl Milan-Porta Romana",
    lat: 45.4462,
    lng: 9.1938,
    score: 4.9,
    status: "success",
    type: "Lidl",
    address: "Milan, Porta Romana",
  },
  {
    id: 852,
    name: "Lidl XL Charlotte-South End",
    lat: 35.2387,
    lng: -80.852,
    score: 4.3,
    status: "success",
    type: "Lidl XL",
    address: "Charlotte, South End",
  },
  {
    id: 853,
    name: "Lidl XL Dijon-Nord",
    lat: 47.3353,
    lng: 5.0384,
    score: 4.9,
    status: "success",
    type: "Lidl XL",
    address: "Dijon, Nord",
  },
  {
    id: 854,
    name: "Lidl Utrecht-Binnenstad",
    lat: 52.0841,
    lng: 5.131,
    score: 3,
    status: "danger",
    type: "Lidl",
    address: "Utrecht, Binnenstad",
  },
  {
    id: 855,
    name: "Lidl XL Amadora-Falagueira",
    lat: 38.731,
    lng: -9.2473,
    score: 3.6,
    status: "warning",
    type: "Lidl XL",
    address: "Amadora, Falagueira",
  },
  {
    id: 856,
    name: "Lidl Budapest-District IV",
    lat: 47.5013,
    lng: 19.0426,
    score: 4.3,
    status: "success",
    type: "Lidl",
    address: "Budapest, District IV",
  },
  {
    id: 857,
    name: "Lidl Express Zurich-Oerlikon",
    lat: 47.3799,
    lng: 8.5267,
    score: 4.1,
    status: "warning",
    type: "Lidl Express",
    address: "Zurich, Oerlikon",
  },
  {
    id: 858,
    name: "Lidl Patras-Centre",
    lat: 38.2241,
    lng: 21.7362,
    score: 4.4,
    status: "success",
    type: "Lidl",
    address: "Patras, Centre",
  },
  {
    id: 859,
    name: "Lidl Express Szeged-Újszeged",
    lat: 46.2705,
    lng: 20.1393,
    score: 3.6,
    status: "warning",
    type: "Lidl Express",
    address: "Szeged, Újszeged",
  },
  {
    id: 860,
    name: "Lidl Express Leeds-Morley",
    lat: 53.7944,
    lng: -1.535,
    score: 4.4,
    status: "success",
    type: "Lidl Express",
    address: "Leeds, Morley",
  },
  {
    id: 861,
    name: "Lidl Express London-Kensington",
    lat: 51.5029,
    lng: -0.1447,
    score: 4.3,
    status: "success",
    type: "Lidl Express",
    address: "London, Kensington",
  },
  {
    id: 862,
    name: "Lidl XL Linz-Ebelsberg",
    lat: 48.3008,
    lng: 14.2818,
    score: 3.7,
    status: "warning",
    type: "Lidl XL",
    address: "Linz, Ebelsberg",
  },
  {
    id: 863,
    name: "Lidl Express Wroclaw-Śródmieście",
    lat: 51.1246,
    lng: 17.063,
    score: 4.1,
    status: "warning",
    type: "Lidl Express",
    address: "Wroclaw, Śródmieście",
  },
  {
    id: 864,
    name: "Lidl XL Valencia-Jarafuel",
    lat: 39.4692,
    lng: -0.378,
    score: 4.5,
    status: "success",
    type: "Lidl XL",
    address: "Valencia, Jarafuel",
  },
  {
    id: 865,
    name: "Lidl XL Madrid-Moncloa",
    lat: 40.396,
    lng: -3.7148,
    score: 4.2,
    status: "success",
    type: "Lidl XL",
    address: "Madrid, Moncloa",
  },
  {
    id: 866,
    name: "Lidl Express Porto-Centro",
    lat: 41.1537,
    lng: -8.6217,
    score: 4.8,
    status: "success",
    type: "Lidl Express",
    address: "Porto, Centro",
  },
  {
    id: 867,
    name: "Lidl Express Reims-Orgeval",
    lat: 49.2726,
    lng: 4.0566,
    score: 4.7,
    status: "success",
    type: "Lidl Express",
    address: "Reims, Orgeval",
  },
  {
    id: 868,
    name: "Lidl Express Milan-Fiera",
    lat: 45.4467,
    lng: 9.172,
    score: 4.1,
    status: "warning",
    type: "Lidl Express",
    address: "Milan, Fiera",
  },
  {
    id: 869,
    name: "Lidl XL Budapest-District IX",
    lat: 47.4732,
    lng: 19.0272,
    score: 4.3,
    status: "success",
    type: "Lidl XL",
    address: "Budapest, District IX",
  },
  {
    id: 870,
    name: "Lidl XL Richmond-Short Pump",
    lat: 37.5393,
    lng: -77.4431,
    score: 4,
    status: "warning",
    type: "Lidl XL",
    address: "Richmond, Short Pump",
  },
  {
    id: 871,
    name: "Lidl Galway-Terryland",
    lat: 53.2825,
    lng: -9.0629,
    score: 4.4,
    status: "success",
    type: "Lidl",
    address: "Galway, Terryland",
  },
  {
    id: 872,
    name: "Lidl Bari-Madonnella",
    lat: 41.1061,
    lng: 16.8912,
    score: 3.6,
    status: "warning",
    type: "Lidl",
    address: "Bari, Madonnella",
  },
  {
    id: 873,
    name: "Lidl Express Leeds-Horsforth",
    lat: 53.8184,
    lng: -1.5257,
    score: 4.5,
    status: "success",
    type: "Lidl Express",
    address: "Leeds, Horsforth",
  },
  {
    id: 874,
    name: "Lidl XL Liverpool-Wavertree",
    lat: 53.4308,
    lng: -2.9822,
    score: 4.2,
    status: "warning",
    type: "Lidl XL",
    address: "Liverpool, Wavertree",
  },
  {
    id: 875,
    name: "Lidl Miskolc-Hejőcsaba",
    lat: 48.0841,
    lng: 20.7862,
    score: 4.2,
    status: "warning",
    type: "Lidl",
    address: "Miskolc, Hejőcsaba",
  },
  {
    id: 876,
    name: "Lidl Southampton-City Centre",
    lat: 50.9269,
    lng: -1.4022,
    score: 4.4,
    status: "success",
    type: "Lidl",
    address: "Southampton, City Centre",
  },
  {
    id: 877,
    name: "Lidl Express Bologna-Centro",
    lat: 44.5121,
    lng: 11.3428,
    score: 4.3,
    status: "success",
    type: "Lidl Express",
    address: "Bologna, Centro",
  },
  {
    id: 878,
    name: "Lidl New York-Queens",
    lat: 40.6924,
    lng: -74.0295,
    score: 3,
    status: "danger",
    type: "Lidl",
    address: "New York, Queens",
  },
  {
    id: 879,
    name: "Lidl Express Brasov-Centru",
    lat: 45.6437,
    lng: 25.5818,
    score: 3.1,
    status: "danger",
    type: "Lidl Express",
    address: "Brasov, Centru",
  },
  {
    id: 880,
    name: "Lidl XL Warsaw-Wola",
    lat: 52.2065,
    lng: 20.9997,
    score: 4,
    status: "warning",
    type: "Lidl XL",
    address: "Warsaw, Wola",
  },
  {
    id: 881,
    name: "Lidl XL Villeurbanne-Gratte-Ciel",
    lat: 45.7447,
    lng: 4.9023,
    score: 4.2,
    status: "warning",
    type: "Lidl XL",
    address: "Villeurbanne, Gratte-Ciel",
  },
  {
    id: 882,
    name: "Lidl Express Geneva-Eaux-Vives",
    lat: 46.1804,
    lng: 6.1415,
    score: 3.3,
    status: "danger",
    type: "Lidl Express",
    address: "Geneva, Eaux-Vives",
  },
  {
    id: 883,
    name: "Lidl XL Zurich-Kreis 5",
    lat: 47.3755,
    lng: 8.5191,
    score: 3.2,
    status: "danger",
    type: "Lidl XL",
    address: "Zurich, Kreis 5",
  },
  {
    id: 884,
    name: "Lidl Express Bucharest-Drumul Taberei",
    lat: 44.4158,
    lng: 26.0938,
    score: 3.4,
    status: "warning",
    type: "Lidl Express",
    address: "Bucharest, Drumul Taberei",
  },
  {
    id: 885,
    name: "Lidl Gijon-Rural",
    lat: 43.5655,
    lng: -5.6754,
    score: 3.4,
    status: "warning",
    type: "Lidl",
    address: "Gijon, Rural",
  },
  {
    id: 886,
    name: "Lidl Express Liverpool-Kirkby",
    lat: 53.3967,
    lng: -2.968,
    score: 4.6,
    status: "success",
    type: "Lidl Express",
    address: "Liverpool, Kirkby",
  },
  {
    id: 887,
    name: "Lidl Palma-Palma Sud",
    lat: 39.5744,
    lng: 2.632,
    score: 3.7,
    status: "warning",
    type: "Lidl",
    address: "Palma, Palma Sud",
  },
  {
    id: 888,
    name: "Lidl Toulon-La Rode",
    lat: 43.1233,
    lng: 5.9325,
    score: 4.1,
    status: "warning",
    type: "Lidl",
    address: "Toulon, La Rode",
  },
  {
    id: 889,
    name: "Lidl XL Grenoble-Saint-Martin-d'Hères",
    lat: 45.1847,
    lng: 5.7115,
    score: 4.5,
    status: "success",
    type: "Lidl XL",
    address: "Grenoble, Saint-Martin-d'Hères",
  },
  {
    id: 890,
    name: "Lidl XL Nottingham-Arnold",
    lat: 52.9593,
    lng: -1.1686,
    score: 4.4,
    status: "success",
    type: "Lidl XL",
    address: "Nottingham, Arnold",
  },
  {
    id: 891,
    name: "Lidl XL Dijon-Centre",
    lat: 47.305,
    lng: 5.0574,
    score: 4.3,
    status: "success",
    type: "Lidl XL",
    address: "Dijon, Centre",
  },
  {
    id: 892,
    name: "Lidl Express Alicante-Campo de Mirra",
    lat: 38.3409,
    lng: -0.463,
    score: 2.8,
    status: "danger",
    type: "Lidl Express",
    address: "Alicante, Campo de Mirra",
  },
  {
    id: 893,
    name: "Lidl Paris-20e",
    lat: 48.8547,
    lng: 2.3547,
    score: 3.5,
    status: "warning",
    type: "Lidl",
    address: "Paris, 20e",
  },
  {
    id: 894,
    name: "Lidl XL Leicester-Oadby",
    lat: 52.6561,
    lng: -1.1442,
    score: 3.6,
    status: "warning",
    type: "Lidl XL",
    address: "Leicester, Oadby",
  },
  {
    id: 895,
    name: "Lidl XL Brno-Žabovřesky",
    lat: 49.2019,
    lng: 16.6179,
    score: 3.8,
    status: "warning",
    type: "Lidl XL",
    address: "Brno, Žabovřesky",
  },
  {
    id: 896,
    name: "Lidl Express Athens-Piraeus",
    lat: 37.9905,
    lng: 23.716,
    score: 4.1,
    status: "warning",
    type: "Lidl Express",
    address: "Athens, Piraeus",
  },
  {
    id: 897,
    name: "Lidl XL Amersfoort-Noord",
    lat: 52.1385,
    lng: 5.3957,
    score: 4.6,
    status: "success",
    type: "Lidl XL",
    address: "Amersfoort, Noord",
  },
  {
    id: 898,
    name: "Lidl XL Ruse-Zaharna Fabrika",
    lat: 43.8136,
    lng: 25.9488,
    score: 3.9,
    status: "warning",
    type: "Lidl XL",
    address: "Ruse, Zaharna Fabrika",
  },
  {
    id: 899,
    name: "Lidl Leeds-Roundhay",
    lat: 53.7898,
    lng: -1.5245,
    score: 3.8,
    status: "warning",
    type: "Lidl",
    address: "Leeds, Roundhay",
  },
  {
    id: 900,
    name: "Lidl Express Florence-Rifredi",
    lat: 43.7652,
    lng: 11.2357,
    score: 4.4,
    status: "success",
    type: "Lidl Express",
    address: "Florence, Rifredi",
  },
  {
    id: 901,
    name: "Lidl Setubal-Nossa Senhora da Anunciada",
    lat: 38.5409,
    lng: -8.9037,
    score: 3.4,
    status: "warning",
    type: "Lidl",
    address: "Setubal, Nossa Senhora da Anunciada",
  },
  {
    id: 902,
    name: "Lidl XL Antwerp-Merksem",
    lat: 51.1969,
    lng: 4.4044,
    score: 4.1,
    status: "warning",
    type: "Lidl XL",
    address: "Antwerp, Merksem",
  },
  {
    id: 903,
    name: "Lidl Krakow-Dębniki",
    lat: 50.0534,
    lng: 19.942,
    score: 2.8,
    status: "danger",
    type: "Lidl",
    address: "Krakow, Dębniki",
  },
  {
    id: 904,
    name: "Lidl The Hague-Centrum",
    lat: 52.0737,
    lng: 4.3245,
    score: 4.8,
    status: "success",
    type: "Lidl",
    address: "The Hague, Centrum",
  },
  {
    id: 905,
    name: "Lidl Express Prague-Praha 1",
    lat: 50.0938,
    lng: 14.4496,
    score: 5,
    status: "success",
    type: "Lidl Express",
    address: "Prague, Praha 1",
  },
  {
    id: 906,
    name: "Lidl Express Turin-Barriera di Milano",
    lat: 45.0527,
    lng: 7.6658,
    score: 4,
    status: "warning",
    type: "Lidl Express",
    address: "Turin, Barriera di Milano",
  },
  {
    id: 907,
    name: "Lidl Paris-14e",
    lat: 48.8739,
    lng: 2.3448,
    score: 4.5,
    status: "success",
    type: "Lidl",
    address: "Paris, 14e",
  },
  {
    id: 908,
    name: "Lidl Madrid-Salamanca",
    lat: 40.4339,
    lng: -3.7086,
    score: 3.2,
    status: "danger",
    type: "Lidl",
    address: "Madrid, Salamanca",
  },
  {
    id: 909,
    name: "Lidl Express Katowice-Ligota",
    lat: 50.2487,
    lng: 19.0284,
    score: 4.2,
    status: "warning",
    type: "Lidl Express",
    address: "Katowice, Ligota",
  },
  {
    id: 910,
    name: "Lidl XL Thessaloniki-Ladadika",
    lat: 40.6573,
    lng: 22.9652,
    score: 3.4,
    status: "danger",
    type: "Lidl XL",
    address: "Thessaloniki, Ladadika",
  },
  {
    id: 911,
    name: "Lidl Innsbruck-Hötting",
    lat: 47.2731,
    lng: 11.3965,
    score: 4.9,
    status: "success",
    type: "Lidl",
    address: "Innsbruck, Hötting",
  },
  {
    id: 912,
    name: "Lidl XL Salzburg-Liefering",
    lat: 47.8087,
    lng: 13.0548,
    score: 4.4,
    status: "success",
    type: "Lidl XL",
    address: "Salzburg, Liefering",
  },
  {
    id: 913,
    name: "Lidl Express Varna-Galata",
    lat: 43.1961,
    lng: 27.8963,
    score: 3.7,
    status: "warning",
    type: "Lidl Express",
    address: "Varna, Galata",
  },
  {
    id: 914,
    name: "Lidl Express Birmingham-Selly Oak",
    lat: 52.5074,
    lng: -1.9132,
    score: 3.7,
    status: "warning",
    type: "Lidl Express",
    address: "Birmingham, Selly Oak",
  },
  {
    id: 915,
    name: "Lidl XL Waterford-Tramore",
    lat: 52.2799,
    lng: -7.0983,
    score: 3.1,
    status: "danger",
    type: "Lidl XL",
    address: "Waterford, Tramore",
  },
  {
    id: 916,
    name: "Lidl Naples-Scampia",
    lat: 40.8591,
    lng: 14.2648,
    score: 3.8,
    status: "warning",
    type: "Lidl",
    address: "Naples, Scampia",
  },
  {
    id: 917,
    name: "Lidl XL Manchester-Didsbury",
    lat: 53.4941,
    lng: -2.2319,
    score: 3.6,
    status: "warning",
    type: "Lidl XL",
    address: "Manchester, Didsbury",
  },
  {
    id: 918,
    name: "Lidl Krakow-Prądnik",
    lat: 50.0708,
    lng: 19.9358,
    score: 3.8,
    status: "warning",
    type: "Lidl",
    address: "Krakow, Prądnik",
  },
  {
    id: 919,
    name: "Lidl Strasbourg-Neudorf",
    lat: 48.5727,
    lng: 7.7655,
    score: 3.5,
    status: "warning",
    type: "Lidl",
    address: "Strasbourg, Neudorf",
  },
  {
    id: 920,
    name: "Lidl Breda-Oost",
    lat: 51.5589,
    lng: 4.7572,
    score: 4,
    status: "warning",
    type: "Lidl",
    address: "Breda, Oost",
  },
  {
    id: 921,
    name: "Lidl XL Palma-Centre",
    lat: 39.5592,
    lng: 2.6676,
    score: 4.6,
    status: "success",
    type: "Lidl XL",
    address: "Palma, Centre",
  },
  {
    id: 922,
    name: "Lidl Express Philadelphia-South Philly",
    lat: 39.9485,
    lng: -75.1515,
    score: 4.6,
    status: "success",
    type: "Lidl Express",
    address: "Philadelphia, South Philly",
  },
  {
    id: 923,
    name: "Lidl Express Rennes-Sud",
    lat: 48.1154,
    lng: -1.6938,
    score: 3.5,
    status: "warning",
    type: "Lidl Express",
    address: "Rennes, Sud",
  },
  {
    id: 924,
    name: "Lidl XL Marseille-6e",
    lat: 43.2777,
    lng: 5.3836,
    score: 4,
    status: "warning",
    type: "Lidl XL",
    address: "Marseille, 6e",
  },
  {
    id: 925,
    name: "Lidl Brescia-Nord",
    lat: 45.5658,
    lng: 10.1963,
    score: 4.4,
    status: "success",
    type: "Lidl",
    address: "Brescia, Nord",
  },
  {
    id: 926,
    name: "Lidl Bern-Länggasse",
    lat: 46.9236,
    lng: 7.4341,
    score: 3.7,
    status: "warning",
    type: "Lidl",
    address: "Bern, Länggasse",
  },
  {
    id: 927,
    name: "Lidl Express Toulouse-Centre",
    lat: 43.5818,
    lng: 1.4226,
    score: 4.9,
    status: "success",
    type: "Lidl Express",
    address: "Toulouse, Centre",
  },
  {
    id: 928,
    name: "Lidl XL Montpellier-Croix d'Argent",
    lat: 43.624,
    lng: 3.8833,
    score: 3.5,
    status: "warning",
    type: "Lidl XL",
    address: "Montpellier, Croix d'Argent",
  },
  {
    id: 929,
    name: "Lidl Alicante-Albufereta",
    lat: 38.3605,
    lng: -0.4576,
    score: 4.7,
    status: "success",
    type: "Lidl",
    address: "Alicante, Albufereta",
  },
  {
    id: 930,
    name: "Lidl XL Zagreb-Peščenica",
    lat: 45.8315,
    lng: 15.9726,
    score: 3.7,
    status: "warning",
    type: "Lidl XL",
    address: "Zagreb, Peščenica",
  },
  {
    id: 931,
    name: "Lidl Express Vienna-Neubau",
    lat: 48.195,
    lng: 16.3965,
    score: 3.3,
    status: "danger",
    type: "Lidl Express",
    address: "Vienna, Neubau",
  },
  {
    id: 932,
    name: "Lidl XL London-Hammersmith",
    lat: 51.4985,
    lng: -0.1119,
    score: 2.7,
    status: "danger",
    type: "Lidl XL",
    address: "London, Hammersmith",
  },
  {
    id: 933,
    name: "Lidl Express Gdansk-Oliwa",
    lat: 54.3383,
    lng: 18.6382,
    score: 3.4,
    status: "warning",
    type: "Lidl Express",
    address: "Gdansk, Oliwa",
  },
  {
    id: 934,
    name: "Lidl XL Rennes-Le Blosne",
    lat: 48.1111,
    lng: -1.6856,
    score: 2.6,
    status: "danger",
    type: "Lidl XL",
    address: "Rennes, Le Blosne",
  },
  {
    id: 935,
    name: "Lidl Liverpool-Walton",
    lat: 53.4094,
    lng: -2.9861,
    score: 4.9,
    status: "success",
    type: "Lidl",
    address: "Liverpool, Walton",
  },
  {
    id: 936,
    name: "Lidl XL Nantes-Île de Nantes",
    lat: 47.1998,
    lng: -1.5516,
    score: 3.2,
    status: "danger",
    type: "Lidl XL",
    address: "Nantes, Île de Nantes",
  },
  {
    id: 937,
    name: "Lidl XL Radom-Gołębiów",
    lat: 51.4017,
    lng: 21.1453,
    score: 3.8,
    status: "warning",
    type: "Lidl XL",
    address: "Radom, Gołębiów",
  },
  {
    id: 938,
    name: "Lidl Express Grenoble-Villeneuve",
    lat: 45.2116,
    lng: 5.7395,
    score: 2.6,
    status: "danger",
    type: "Lidl Express",
    address: "Grenoble, Villeneuve",
  },
  {
    id: 939,
    name: "Lidl Express Genoa-Cornigliano",
    lat: 44.3842,
    lng: 8.94,
    score: 4.2,
    status: "warning",
    type: "Lidl Express",
    address: "Genoa, Cornigliano",
  },
  {
    id: 940,
    name: "Lidl XL Naples-Pozzuoli",
    lat: 40.8646,
    lng: 14.2764,
    score: 3.4,
    status: "warning",
    type: "Lidl XL",
    address: "Naples, Pozzuoli",
  },
  {
    id: 941,
    name: "Lidl XL Kranj-Centrum",
    lat: 46.2494,
    lng: 14.3376,
    score: 3.7,
    status: "warning",
    type: "Lidl XL",
    address: "Kranj, Centrum",
  },
  {
    id: 942,
    name: "Lidl Enschede-Zuid",
    lat: 52.2379,
    lng: 6.8895,
    score: 4.9,
    status: "success",
    type: "Lidl",
    address: "Enschede, Zuid",
  },
  {
    id: 943,
    name: "Lidl Murcia-Espinardo",
    lat: 38.0035,
    lng: -1.1138,
    score: 3.7,
    status: "warning",
    type: "Lidl",
    address: "Murcia, Espinardo",
  },
  {
    id: 944,
    name: "Lidl XL Alicante-Playa de San Juan",
    lat: 38.3411,
    lng: -0.4653,
    score: 2.5,
    status: "danger",
    type: "Lidl XL",
    address: "Alicante, Playa de San Juan",
  },
  {
    id: 945,
    name: "Lidl Charlotte-Ballantyne",
    lat: 35.2479,
    lng: -80.8535,
    score: 4.5,
    status: "success",
    type: "Lidl",
    address: "Charlotte, Ballantyne",
  },
  {
    id: 946,
    name: "Lidl Zadar-Borik",
    lat: 44.1007,
    lng: 15.2493,
    score: 4.7,
    status: "success",
    type: "Lidl",
    address: "Zadar, Borik",
  },
  {
    id: 947,
    name: "Lidl Express Lublin-Czuby",
    lat: 51.2512,
    lng: 22.5774,
    score: 4.1,
    status: "warning",
    type: "Lidl Express",
    address: "Lublin, Czuby",
  },
  {
    id: 948,
    name: "Lidl Seville-Los Remedios",
    lat: 37.3858,
    lng: -5.9681,
    score: 4.2,
    status: "warning",
    type: "Lidl",
    address: "Seville, Los Remedios",
  },
  {
    id: 949,
    name: "Lidl Bari-Murat",
    lat: 41.1384,
    lng: 16.8963,
    score: 3.1,
    status: "danger",
    type: "Lidl",
    address: "Bari, Murat",
  },
  {
    id: 950,
    name: "Lidl XL Bucharest-Sector 4",
    lat: 44.4047,
    lng: 26.1096,
    score: 4.3,
    status: "success",
    type: "Lidl XL",
    address: "Bucharest, Sector 4",
  },
  {
    id: 951,
    name: "Lidl Express Torun-Grębocin",
    lat: 53.026,
    lng: 18.5914,
    score: 2.9,
    status: "danger",
    type: "Lidl Express",
    address: "Torun, Grębocin",
  },
  {
    id: 952,
    name: "Lidl Express Vigo-Bouzas",
    lat: 42.24,
    lng: -8.7389,
    score: 2.8,
    status: "danger",
    type: "Lidl Express",
    address: "Vigo, Bouzas",
  },
  {
    id: 953,
    name: "Lidl XL Brussels-Schaerbeek",
    lat: 50.8578,
    lng: 4.3746,
    score: 3.8,
    status: "warning",
    type: "Lidl XL",
    address: "Brussels, Schaerbeek",
  },
  {
    id: 954,
    name: "Lidl Liverpool-Allerton",
    lat: 53.4265,
    lng: -2.9808,
    score: 3,
    status: "danger",
    type: "Lidl",
    address: "Liverpool, Allerton",
  },
  {
    id: 955,
    name: "Lidl Express Paris-17e",
    lat: 48.8482,
    lng: 2.3476,
    score: 3.4,
    status: "danger",
    type: "Lidl Express",
    address: "Paris, 17e",
  },
  {
    id: 956,
    name: "Lidl Express Greenville-Downtown",
    lat: 34.8576,
    lng: -82.407,
    score: 4.5,
    status: "success",
    type: "Lidl Express",
    address: "Greenville, Downtown",
  },
  {
    id: 957,
    name: "Lidl Express Catania-Ognina",
    lat: 37.4875,
    lng: 15.0918,
    score: 4.1,
    status: "warning",
    type: "Lidl Express",
    address: "Catania, Ognina",
  },
  {
    id: 958,
    name: "Lidl Bordeaux-Mériadeck",
    lat: 44.8361,
    lng: -0.572,
    score: 3.6,
    status: "warning",
    type: "Lidl",
    address: "Bordeaux, Mériadeck",
  },
  {
    id: 959,
    name: "Lidl XL Rotterdam-IJsselmonde",
    lat: 51.9335,
    lng: 4.4747,
    score: 3,
    status: "danger",
    type: "Lidl XL",
    address: "Rotterdam, IJsselmonde",
  },
  {
    id: 960,
    name: "Lidl Express Nijmegen-West",
    lat: 51.8385,
    lng: 5.8306,
    score: 3.5,
    status: "warning",
    type: "Lidl Express",
    address: "Nijmegen, West",
  },
  {
    id: 961,
    name: "Lidl XL Valencia-Poblats Marítims",
    lat: 39.4474,
    lng: -0.3676,
    score: 3.5,
    status: "warning",
    type: "Lidl XL",
    address: "Valencia, Poblats Marítims",
  },
  {
    id: 962,
    name: "Lidl Lisbon-Campo de Ourique",
    lat: 38.7074,
    lng: -9.1258,
    score: 3.1,
    status: "danger",
    type: "Lidl",
    address: "Lisbon, Campo de Ourique",
  },
  {
    id: 963,
    name: "Lidl Ceske Budejovice-Centrum",
    lat: 48.9927,
    lng: 14.4844,
    score: 2.8,
    status: "danger",
    type: "Lidl",
    address: "Ceske Budejovice, Centrum",
  },
  {
    id: 964,
    name: "Lidl Catania-Centro",
    lat: 37.4989,
    lng: 15.0594,
    score: 3.9,
    status: "warning",
    type: "Lidl",
    address: "Catania, Centro",
  },
  {
    id: 965,
    name: "Lidl XL Warsaw-Ursynów",
    lat: 52.2411,
    lng: 20.9889,
    score: 4.1,
    status: "warning",
    type: "Lidl XL",
    address: "Warsaw, Ursynów",
  },
  {
    id: 966,
    name: "Lidl Express Bristol-St Paul's",
    lat: 51.4591,
    lng: -2.5793,
    score: 4.9,
    status: "success",
    type: "Lidl Express",
    address: "Bristol, St Paul's",
  },
  {
    id: 967,
    name: "Lidl XL Braga-Centro",
    lat: 41.5345,
    lng: -8.4344,
    score: 2.6,
    status: "danger",
    type: "Lidl XL",
    address: "Braga, Centro",
  },
  {
    id: 968,
    name: "Lidl XL St. Pölten-Zentrum",
    lat: 48.1939,
    lng: 15.6214,
    score: 4.3,
    status: "success",
    type: "Lidl XL",
    address: "St. Pölten, Zentrum",
  },
  {
    id: 969,
    name: "Lidl Bristol-Southville",
    lat: 51.4471,
    lng: -2.605,
    score: 4.7,
    status: "success",
    type: "Lidl",
    address: "Bristol, Southville",
  },
  {
    id: 970,
    name: "Lidl XL Reims-Centre",
    lat: 49.2692,
    lng: 4.0547,
    score: 4.3,
    status: "success",
    type: "Lidl XL",
    address: "Reims, Centre",
  },
  {
    id: 971,
    name: "Lidl Express Basel-Gundeldingen",
    lat: 47.5664,
    lng: 7.5747,
    score: 3.8,
    status: "warning",
    type: "Lidl Express",
    address: "Basel, Gundeldingen",
  },
  {
    id: 972,
    name: "Lidl Murcia-El Carmen",
    lat: 38.0091,
    lng: -1.1065,
    score: 3.6,
    status: "warning",
    type: "Lidl",
    address: "Murcia, El Carmen",
  },
  {
    id: 973,
    name: "Lidl Express Amadora-Venda Nova",
    lat: 38.7388,
    lng: -9.2531,
    score: 2.7,
    status: "danger",
    type: "Lidl Express",
    address: "Amadora, Venda Nova",
  },
  {
    id: 974,
    name: "Lidl XL Heraklion-Poros",
    lat: 35.3627,
    lng: 25.1489,
    score: 2.8,
    status: "danger",
    type: "Lidl XL",
    address: "Heraklion, Poros",
  },
  {
    id: 975,
    name: "Lidl XL Newcastle-Gosforth",
    lat: 54.9578,
    lng: -1.6012,
    score: 3.8,
    status: "warning",
    type: "Lidl XL",
    address: "Newcastle, Gosforth",
  },
  {
    id: 976,
    name: "Lidl Prague-Vinohrady",
    lat: 50.0846,
    lng: 14.4229,
    score: 2.6,
    status: "danger",
    type: "Lidl",
    address: "Prague, Vinohrady",
  },
  {
    id: 977,
    name: "Lidl XL Amersfoort-Nieuwland",
    lat: 52.1629,
    lng: 5.4096,
    score: 4.4,
    status: "success",
    type: "Lidl XL",
    address: "Amersfoort, Nieuwland",
  },
  {
    id: 978,
    name: "Lidl Coimbra-Solum",
    lat: 40.2106,
    lng: -8.4365,
    score: 4.6,
    status: "success",
    type: "Lidl",
    address: "Coimbra, Solum",
  },
  {
    id: 979,
    name: "Lidl XL Norfolk-Ocean View",
    lat: 36.8596,
    lng: -76.3067,
    score: 4.4,
    status: "success",
    type: "Lidl XL",
    address: "Norfolk, Ocean View",
  },
  {
    id: 980,
    name: "Lidl XL Brighton-Moulsecoomb",
    lat: 50.8348,
    lng: -0.1294,
    score: 4,
    status: "warning",
    type: "Lidl XL",
    address: "Brighton, Moulsecoomb",
  },
  {
    id: 981,
    name: "Lidl XL Vienna-Innere Stadt",
    lat: 48.2163,
    lng: 16.3755,
    score: 4.8,
    status: "success",
    type: "Lidl XL",
    address: "Vienna, Innere Stadt",
  },
  {
    id: 982,
    name: "Lidl XL Paris-18e",
    lat: 48.8482,
    lng: 2.3303,
    score: 4.3,
    status: "success",
    type: "Lidl XL",
    address: "Paris, 18e",
  },
  {
    id: 983,
    name: "Lidl XL Florence-Gavinana",
    lat: 43.7813,
    lng: 11.2481,
    score: 4.1,
    status: "warning",
    type: "Lidl XL",
    address: "Florence, Gavinana",
  },
  {
    id: 984,
    name: "Lidl Bydgoszcz-Błonie",
    lat: 53.1083,
    lng: 18.0188,
    score: 3.7,
    status: "warning",
    type: "Lidl",
    address: "Bydgoszcz, Błonie",
  },
  {
    id: 985,
    name: "Lidl XL Le Mans-Ronces",
    lat: 47.9822,
    lng: 0.1977,
    score: 4.9,
    status: "success",
    type: "Lidl XL",
    address: "Le Mans, Ronces",
  },
  {
    id: 986,
    name: "Lidl XL Manchester-Trafford",
    lat: 53.4677,
    lng: -2.2491,
    score: 5,
    status: "success",
    type: "Lidl XL",
    address: "Manchester, Trafford",
  },
  {
    id: 987,
    name: "Lidl Basel-Kleinbasel",
    lat: 47.5663,
    lng: 7.586,
    score: 4.2,
    status: "success",
    type: "Lidl",
    address: "Basel, Kleinbasel",
  },
  {
    id: 988,
    name: "Lidl XL Thessaloniki-Sykes",
    lat: 40.6183,
    lng: 22.9516,
    score: 4.1,
    status: "warning",
    type: "Lidl XL",
    address: "Thessaloniki, Sykes",
  },
  {
    id: 989,
    name: "Lidl Express Tilburg-Zuid",
    lat: 51.5502,
    lng: 5.1113,
    score: 4.5,
    status: "success",
    type: "Lidl Express",
    address: "Tilburg, Zuid",
  },
  {
    id: 990,
    name: "Lidl Express Limerick-Dooradoyle",
    lat: 52.6769,
    lng: -8.6235,
    score: 3.9,
    status: "warning",
    type: "Lidl Express",
    address: "Limerick, Dooradoyle",
  },
  {
    id: 991,
    name: "Lidl Express Southampton-Millbrook",
    lat: 50.9032,
    lng: -1.3851,
    score: 4.6,
    status: "success",
    type: "Lidl Express",
    address: "Southampton, Millbrook",
  },
  {
    id: 992,
    name: "Lidl London-Tower Hamlets",
    lat: 51.524,
    lng: -0.1215,
    score: 3.4,
    status: "warning",
    type: "Lidl",
    address: "London, Tower Hamlets",
  },
  {
    id: 993,
    name: "Lidl XL Celje-Šmartno",
    lat: 46.2061,
    lng: 15.2844,
    score: 4.3,
    status: "success",
    type: "Lidl XL",
    address: "Celje, Šmartno",
  },
  {
    id: 994,
    name: "Lidl Express Marseille-9e",
    lat: 43.2802,
    lng: 5.3565,
    score: 3.9,
    status: "warning",
    type: "Lidl Express",
    address: "Marseille, 9e",
  },
  {
    id: 995,
    name: "Lidl Vienna-Rudolfsheim",
    lat: 48.1937,
    lng: 16.3907,
    score: 3.8,
    status: "warning",
    type: "Lidl",
    address: "Vienna, Rudolfsheim",
  },
  {
    id: 996,
    name: "Lidl Express London-Newham",
    lat: 51.4904,
    lng: -0.1472,
    score: 4.9,
    status: "success",
    type: "Lidl Express",
    address: "London, Newham",
  },
  {
    id: 997,
    name: "Lidl Express Thessaloniki-Toumba",
    lat: 40.6421,
    lng: 22.9667,
    score: 4.3,
    status: "success",
    type: "Lidl Express",
    address: "Thessaloniki, Toumba",
  },
  {
    id: 998,
    name: "Lidl XL Coimbra-Santo António",
    lat: 40.1955,
    lng: -8.4344,
    score: 4.6,
    status: "success",
    type: "Lidl XL",
    address: "Coimbra, Santo António",
  },
  {
    id: 999,
    name: "Lidl XL Varna-Vladislavovo",
    lat: 43.2026,
    lng: 27.8905,
    score: 3.9,
    status: "warning",
    type: "Lidl XL",
    address: "Varna, Vladislavovo",
  },
  {
    id: 1000,
    name: "Lidl XL Edinburgh-City Centre",
    lat: 55.9391,
    lng: -3.2065,
    score: 4.6,
    status: "success",
    type: "Lidl XL",
    address: "Edinburgh, City Centre",
  },
  {
    id: 1001,
    name: "Lidl XL Braga-Dume",
    lat: 41.5495,
    lng: -8.4111,
    score: 2.6,
    status: "danger",
    type: "Lidl XL",
    address: "Braga, Dume",
  },
  {
    id: 1002,
    name: "Lidl Catania-San Giovanni",
    lat: 37.5278,
    lng: 15.0952,
    score: 2.9,
    status: "danger",
    type: "Lidl",
    address: "Catania, San Giovanni",
  },
  {
    id: 1003,
    name: "Lidl Usti nad Labem-Předlice",
    lat: 50.639,
    lng: 14.0364,
    score: 3.6,
    status: "warning",
    type: "Lidl",
    address: "Usti nad Labem, Předlice",
  },
  {
    id: 1004,
    name: "Lidl XL Galati-Port",
    lat: 45.4476,
    lng: 27.9894,
    score: 4.2,
    status: "warning",
    type: "Lidl XL",
    address: "Galati, Port",
  },
  {
    id: 1005,
    name: "Lidl Express Linz-Innenstadt",
    lat: 48.3189,
    lng: 14.283,
    score: 4.6,
    status: "success",
    type: "Lidl Express",
    address: "Linz, Innenstadt",
  },
  {
    id: 1006,
    name: "Lidl XL Vienna-Margareten",
    lat: 48.187,
    lng: 16.3814,
    score: 3.6,
    status: "warning",
    type: "Lidl XL",
    address: "Vienna, Margareten",
  },
  {
    id: 1007,
    name: "Lidl XL London-Islington",
    lat: 51.5154,
    lng: -0.1318,
    score: 2.7,
    status: "danger",
    type: "Lidl XL",
    address: "London, Islington",
  },
  {
    id: 1008,
    name: "Lidl Cork-Blackrock",
    lat: 51.8964,
    lng: -8.5,
    score: 3.5,
    status: "warning",
    type: "Lidl",
    address: "Cork, Blackrock",
  },
  {
    id: 1009,
    name: "Lidl Express Miskolc-Centrum",
    lat: 48.1118,
    lng: 20.7959,
    score: 3.9,
    status: "warning",
    type: "Lidl Express",
    address: "Miskolc, Centrum",
  },
  {
    id: 1010,
    name: "Lidl Raleigh-North Hills",
    lat: 35.7824,
    lng: -78.6206,
    score: 2.8,
    status: "danger",
    type: "Lidl",
    address: "Raleigh, North Hills",
  },
  {
    id: 1011,
    name: "Lidl Express Bydgoszcz-Wyżyny",
    lat: 53.1263,
    lng: 18.0082,
    score: 4,
    status: "warning",
    type: "Lidl Express",
    address: "Bydgoszcz, Wyżyny",
  },
  {
    id: 1012,
    name: "Lidl Express Breda-Noord",
    lat: 51.5964,
    lng: 4.7718,
    score: 4.3,
    status: "success",
    type: "Lidl Express",
    address: "Breda, Noord",
  },
  {
    id: 1013,
    name: "Lidl New York-Manhattan",
    lat: 40.7138,
    lng: -74.0008,
    score: 3.5,
    status: "warning",
    type: "Lidl",
    address: "New York, Manhattan",
  },
  {
    id: 1014,
    name: "Lidl XL Paris-13e",
    lat: 48.8549,
    lng: 2.3398,
    score: 4.9,
    status: "success",
    type: "Lidl XL",
    address: "Paris, 13e",
  },
  {
    id: 1015,
    name: "Lidl Express Amadora-Centro",
    lat: 38.7726,
    lng: -9.2085,
    score: 3,
    status: "danger",
    type: "Lidl Express",
    address: "Amadora, Centro",
  },
  {
    id: 1016,
    name: "Lidl Athens-Kolonaki",
    lat: 37.9677,
    lng: 23.7097,
    score: 3.5,
    status: "warning",
    type: "Lidl",
    address: "Athens, Kolonaki",
  },
  {
    id: 1017,
    name: "Lidl Palma-Llevant",
    lat: 39.5586,
    lng: 2.6317,
    score: 3,
    status: "danger",
    type: "Lidl",
    address: "Palma, Llevant",
  },
  {
    id: 1018,
    name: "Lidl Express Rotterdam-Noord",
    lat: 51.9135,
    lng: 4.4645,
    score: 4.9,
    status: "success",
    type: "Lidl Express",
    address: "Rotterdam, Noord",
  },
  {
    id: 1019,
    name: "Lidl Ljubljana-Sostro",
    lat: 46.044,
    lng: 14.485,
    score: 3.8,
    status: "warning",
    type: "Lidl",
    address: "Ljubljana, Sostro",
  },
  {
    id: 1020,
    name: "Lidl Craiova-Filaret",
    lat: 44.3108,
    lng: 23.8186,
    score: 4.9,
    status: "success",
    type: "Lidl",
    address: "Craiova, Filaret",
  },
  {
    id: 1021,
    name: "Lidl Express Washington-Capitol Hill",
    lat: 38.9268,
    lng: -77.018,
    score: 3.7,
    status: "warning",
    type: "Lidl Express",
    address: "Washington, Capitol Hill",
  },
  {
    id: 1022,
    name: "Lidl XL Bologna-Savena",
    lat: 44.4837,
    lng: 11.352,
    score: 3.8,
    status: "warning",
    type: "Lidl XL",
    address: "Bologna, Savena",
  },
  {
    id: 1023,
    name: "Lidl Faro-Centro",
    lat: 37.0366,
    lng: -7.9173,
    score: 4.3,
    status: "success",
    type: "Lidl",
    address: "Faro, Centro",
  },
  {
    id: 1024,
    name: "Lidl XL Newcastle-Jesmond",
    lat: 54.9551,
    lng: -1.6098,
    score: 4.9,
    status: "success",
    type: "Lidl XL",
    address: "Newcastle, Jesmond",
  },
  {
    id: 1025,
    name: "Lidl Malaga-Bailén-Miraflores",
    lat: 36.7051,
    lng: -4.4009,
    score: 3.8,
    status: "warning",
    type: "Lidl",
    address: "Malaga, Bailén-Miraflores",
  },
  {
    id: 1026,
    name: "Lidl Express Hradec Kralove-Moravské Předměstí",
    lat: 50.2132,
    lng: 15.8079,
    score: 3.3,
    status: "danger",
    type: "Lidl Express",
    address: "Hradec Kralove, Moravské Předměstí",
  },
  {
    id: 1027,
    name: "Lidl Express Liberec-Harcov",
    lat: 50.7538,
    lng: 15.0505,
    score: 2.5,
    status: "danger",
    type: "Lidl Express",
    address: "Liberec, Harcov",
  },
  {
    id: 1028,
    name: "Lidl XL Białystok-Białostoczek",
    lat: 53.1254,
    lng: 23.1727,
    score: 4.3,
    status: "success",
    type: "Lidl XL",
    address: "Białystok, Białostoczek",
  },
  {
    id: 1029,
    name: "Lidl XL Leicester-Braunstone",
    lat: 52.6389,
    lng: -1.1238,
    score: 3.1,
    status: "danger",
    type: "Lidl XL",
    address: "Leicester, Braunstone",
  },
  {
    id: 1030,
    name: "Lidl Czestochowa-Stradom",
    lat: 50.804,
    lng: 19.1177,
    score: 4.7,
    status: "success",
    type: "Lidl",
    address: "Czestochowa, Stradom",
  },
  {
    id: 1031,
    name: "Lidl XL London-Greenwich",
    lat: 51.5109,
    lng: -0.1239,
    score: 4.9,
    status: "success",
    type: "Lidl XL",
    address: "London, Greenwich",
  },
  {
    id: 1032,
    name: "Lidl Express Glasgow-Maryhill",
    lat: 55.8586,
    lng: -4.2282,
    score: 4.9,
    status: "success",
    type: "Lidl Express",
    address: "Glasgow, Maryhill",
  },
  {
    id: 1033,
    name: "Lidl Express Manchester-Salford",
    lat: 53.4863,
    lng: -2.2538,
    score: 4.4,
    status: "success",
    type: "Lidl Express",
    address: "Manchester, Salford",
  },
  {
    id: 1034,
    name: "Lidl Bari-Japigia",
    lat: 41.1359,
    lng: 16.8521,
    score: 4.7,
    status: "success",
    type: "Lidl",
    address: "Bari, Japigia",
  },
  {
    id: 1035,
    name: "Lidl XL Cordoba-Sur",
    lat: 37.887,
    lng: -4.7892,
    score: 4.7,
    status: "success",
    type: "Lidl XL",
    address: "Cordoba, Sur",
  },
  {
    id: 1036,
    name: "Lidl Dornbirn-Hatlerdorf",
    lat: 47.4337,
    lng: 9.7298,
    score: 2.8,
    status: "danger",
    type: "Lidl",
    address: "Dornbirn, Hatlerdorf",
  },
  {
    id: 1037,
    name: "Lidl Express Pardubice-Polabiny",
    lat: 50.032,
    lng: 15.7847,
    score: 2.7,
    status: "danger",
    type: "Lidl Express",
    address: "Pardubice, Polabiny",
  },
  {
    id: 1038,
    name: "Lidl Express Liège-Outremeuse",
    lat: 50.6324,
    lng: 5.5713,
    score: 4.9,
    status: "success",
    type: "Lidl Express",
    address: "Liège, Outremeuse",
  },
  {
    id: 1039,
    name: "Lidl XL Philadelphia-Fishtown",
    lat: 39.9682,
    lng: -75.18,
    score: 4.3,
    status: "success",
    type: "Lidl XL",
    address: "Philadelphia, Fishtown",
  },
  {
    id: 1040,
    name: "Lidl XL Seville-Nervión",
    lat: 37.4049,
    lng: -5.9652,
    score: 3.4,
    status: "danger",
    type: "Lidl XL",
    address: "Seville, Nervión",
  },
  {
    id: 1041,
    name: "Lidl Express Poznan-Nowe Miasto",
    lat: 52.4229,
    lng: 16.9295,
    score: 3.7,
    status: "warning",
    type: "Lidl Express",
    address: "Poznan, Nowe Miasto",
  },
  {
    id: 1042,
    name: "Lidl Express Geneva-Carouge",
    lat: 46.2038,
    lng: 6.1383,
    score: 3.7,
    status: "warning",
    type: "Lidl Express",
    address: "Geneva, Carouge",
  },
  {
    id: 1043,
    name: "Lidl XL Lille-Wazemmes",
    lat: 50.6441,
    lng: 3.0406,
    score: 3.3,
    status: "danger",
    type: "Lidl XL",
    address: "Lille, Wazemmes",
  },
  {
    id: 1044,
    name: "Lidl Madrid-Fuencarral",
    lat: 40.439,
    lng: -3.7227,
    score: 4.6,
    status: "success",
    type: "Lidl",
    address: "Madrid, Fuencarral",
  },
  {
    id: 1045,
    name: "Lidl XL Brasov-Tractorul",
    lat: 45.6421,
    lng: 25.5986,
    score: 4.3,
    status: "success",
    type: "Lidl XL",
    address: "Brasov, Tractorul",
  },
  {
    id: 1046,
    name: "Lidl Express Enschede-Oost",
    lat: 52.2256,
    lng: 6.8792,
    score: 4.3,
    status: "success",
    type: "Lidl Express",
    address: "Enschede, Oost",
  },
  {
    id: 1047,
    name: "Lidl Express Dublin-Swords",
    lat: 53.3278,
    lng: -6.2672,
    score: 3.7,
    status: "warning",
    type: "Lidl Express",
    address: "Dublin, Swords",
  },
  {
    id: 1048,
    name: "Lidl XL Genoa-Sturla",
    lat: 44.4262,
    lng: 8.9679,
    score: 4.5,
    status: "success",
    type: "Lidl XL",
    address: "Genoa, Sturla",
  },
  {
    id: 1049,
    name: "Lidl Marseille-11e",
    lat: 43.314,
    lng: 5.3721,
    score: 3.6,
    status: "warning",
    type: "Lidl",
    address: "Marseille, 11e",
  },
  {
    id: 1050,
    name: "Lidl Murcia-Este",
    lat: 38.0071,
    lng: -1.1526,
    score: 4.5,
    status: "success",
    type: "Lidl",
    address: "Murcia, Este",
  },
  {
    id: 1051,
    name: "Lidl Express Brno-Líšeň",
    lat: 49.1931,
    lng: 16.6199,
    score: 4.1,
    status: "warning",
    type: "Lidl Express",
    address: "Brno, Líšeň",
  },
  {
    id: 1052,
    name: "Lidl Sosnowiec-Pogoń",
    lat: 50.2788,
    lng: 19.0906,
    score: 4,
    status: "warning",
    type: "Lidl",
    address: "Sosnowiec, Pogoń",
  },
  {
    id: 1053,
    name: "Lidl Express Bucharest-Sector 1",
    lat: 44.4507,
    lng: 26.1166,
    score: 3.5,
    status: "warning",
    type: "Lidl Express",
    address: "Bucharest, Sector 1",
  },
  {
    id: 1054,
    name: "Lidl Graz-Innere Stadt",
    lat: 47.0765,
    lng: 15.454,
    score: 4.4,
    status: "success",
    type: "Lidl",
    address: "Graz, Innere Stadt",
  },
  {
    id: 1055,
    name: "Lidl XL Valencia-Benicalap",
    lat: 39.4932,
    lng: -0.3707,
    score: 4.4,
    status: "success",
    type: "Lidl XL",
    address: "Valencia, Benicalap",
  },
  {
    id: 1056,
    name: "Lidl Amersfoort-Centrum",
    lat: 52.1527,
    lng: 5.4062,
    score: 3.3,
    status: "danger",
    type: "Lidl",
    address: "Amersfoort, Centrum",
  },
  {
    id: 1057,
    name: "Lidl Namur-Jambes",
    lat: 50.4919,
    lng: 4.8966,
    score: 4.2,
    status: "success",
    type: "Lidl",
    address: "Namur, Jambes",
  },
  {
    id: 1058,
    name: "Lidl XL Bydgoszcz-Śródmieście",
    lat: 53.1472,
    lng: 17.9917,
    score: 3.4,
    status: "warning",
    type: "Lidl XL",
    address: "Bydgoszcz, Śródmieście",
  },
  {
    id: 1059,
    name: "Lidl XL Drogheda-North",
    lat: 53.7064,
    lng: -6.3782,
    score: 4.2,
    status: "warning",
    type: "Lidl XL",
    address: "Drogheda, North",
  },
  {
    id: 1060,
    name: "Lidl Villach-Süd",
    lat: 46.6136,
    lng: 13.8453,
    score: 4.6,
    status: "success",
    type: "Lidl",
    address: "Villach, Süd",
  },
  {
    id: 1061,
    name: "Lidl XL Rotterdam-Kralingen",
    lat: 51.9302,
    lng: 4.4829,
    score: 2.8,
    status: "danger",
    type: "Lidl XL",
    address: "Rotterdam, Kralingen",
  },
  {
    id: 1062,
    name: "Lidl XL Zaragoza-Universidad",
    lat: 41.6349,
    lng: -0.8838,
    score: 3.6,
    status: "warning",
    type: "Lidl XL",
    address: "Zaragoza, Universidad",
  },
  {
    id: 1063,
    name: "Lidl Express Valencia-Jesús",
    lat: 39.4845,
    lng: -0.3889,
    score: 4.2,
    status: "warning",
    type: "Lidl Express",
    address: "Valencia, Jesús",
  },
  {
    id: 1064,
    name: "Lidl XL Ghent-Sint-Amandsberg",
    lat: 51.0456,
    lng: 3.7164,
    score: 2.8,
    status: "danger",
    type: "Lidl XL",
    address: "Ghent, Sint-Amandsberg",
  },
  {
    id: 1065,
    name: "Lidl XL Larissa-Centre",
    lat: 39.6253,
    lng: 22.4046,
    score: 2.7,
    status: "danger",
    type: "Lidl XL",
    address: "Larissa, Centre",
  },
  {
    id: 1066,
    name: "Lidl Express Warsaw-Bielany",
    lat: 52.2182,
    lng: 20.988,
    score: 4.1,
    status: "warning",
    type: "Lidl Express",
    address: "Warsaw, Bielany",
  },
  {
    id: 1067,
    name: "Lidl XL Venice-San Marco",
    lat: 45.4652,
    lng: 12.3297,
    score: 3.3,
    status: "danger",
    type: "Lidl XL",
    address: "Venice, San Marco",
  },
  {
    id: 1068,
    name: "Lidl Granada-Realejo",
    lat: 37.1583,
    lng: -3.6185,
    score: 2.5,
    status: "danger",
    type: "Lidl",
    address: "Granada, Realejo",
  },
  {
    id: 1069,
    name: "Lidl XL Heraklion-Temenos",
    lat: 35.3629,
    lng: 25.1359,
    score: 3.9,
    status: "warning",
    type: "Lidl XL",
    address: "Heraklion, Temenos",
  },
  {
    id: 1070,
    name: "Lidl XL Granada-Genil",
    lat: 37.167,
    lng: -3.592,
    score: 3.9,
    status: "warning",
    type: "Lidl XL",
    address: "Granada, Genil",
  },
  {
    id: 1071,
    name: "Lidl XL Porto-Lordelo",
    lat: 41.1596,
    lng: -8.6313,
    score: 2.8,
    status: "danger",
    type: "Lidl XL",
    address: "Porto, Lordelo",
  },
  {
    id: 1072,
    name: "Lidl Express Torun-Rubinkowo",
    lat: 52.9938,
    lng: 18.6091,
    score: 4.9,
    status: "success",
    type: "Lidl Express",
    address: "Torun, Rubinkowo",
  },
  {
    id: 1073,
    name: "Lidl Verona-San Michele",
    lat: 45.4579,
    lng: 11.0096,
    score: 4.6,
    status: "success",
    type: "Lidl",
    address: "Verona, San Michele",
  },
  {
    id: 1074,
    name: "Lidl XL Glasgow-Dennistoun",
    lat: 55.8636,
    lng: -4.2345,
    score: 3.1,
    status: "danger",
    type: "Lidl XL",
    address: "Glasgow, Dennistoun",
  },
  {
    id: 1075,
    name: "Lidl Express Richmond-Midlothian",
    lat: 37.5277,
    lng: -77.4409,
    score: 2.8,
    status: "danger",
    type: "Lidl Express",
    address: "Richmond, Midlothian",
  },
  {
    id: 1076,
    name: "Lidl XL Palermo-Kalsa",
    lat: 38.1066,
    lng: 13.3831,
    score: 4.4,
    status: "success",
    type: "Lidl XL",
    address: "Palermo, Kalsa",
  },
  {
    id: 1077,
    name: "Lidl Express Turin-Crocetta",
    lat: 45.0616,
    lng: 7.6823,
    score: 4.7,
    status: "success",
    type: "Lidl Express",
    address: "Turin, Crocetta",
  },
  {
    id: 1078,
    name: "Lidl XL Bologna-San Donato",
    lat: 44.5171,
    lng: 11.3416,
    score: 4.9,
    status: "success",
    type: "Lidl XL",
    address: "Bologna, San Donato",
  },
  {
    id: 1079,
    name: "Lidl Express Katowice-Zawodzie",
    lat: 50.2479,
    lng: 19.0319,
    score: 3.8,
    status: "warning",
    type: "Lidl Express",
    address: "Katowice, Zawodzie",
  },
  {
    id: 1080,
    name: "Lidl XL Coimbra-Celas",
    lat: 40.1954,
    lng: -8.4431,
    score: 4.9,
    status: "success",
    type: "Lidl XL",
    address: "Coimbra, Celas",
  },
  {
    id: 1081,
    name: "Lidl XL Galway-Knocknacarra",
    lat: 53.2747,
    lng: -9.037,
    score: 3.7,
    status: "warning",
    type: "Lidl XL",
    address: "Galway, Knocknacarra",
  },
  {
    id: 1082,
    name: "Lidl Express Brescia-Centro",
    lat: 45.5187,
    lng: 10.2211,
    score: 4.2,
    status: "warning",
    type: "Lidl Express",
    address: "Brescia, Centro",
  },
  {
    id: 1083,
    name: "Lidl Express Porto-Paranhos",
    lat: 41.1661,
    lng: -8.6366,
    score: 3.1,
    status: "danger",
    type: "Lidl Express",
    address: "Porto, Paranhos",
  },
  {
    id: 1084,
    name: "Lidl Express Madrid-Villaverde",
    lat: 40.4206,
    lng: -3.68,
    score: 3.4,
    status: "warning",
    type: "Lidl Express",
    address: "Madrid, Villaverde",
  },
  {
    id: 1085,
    name: "Lidl Verona-Valdonega",
    lat: 45.4534,
    lng: 10.9761,
    score: 4.5,
    status: "success",
    type: "Lidl",
    address: "Verona, Valdonega",
  },
  {
    id: 1086,
    name: "Lidl Almere-Poort",
    lat: 52.3641,
    lng: 5.2442,
    score: 4,
    status: "warning",
    type: "Lidl",
    address: "Almere, Poort",
  },
  {
    id: 1087,
    name: "Lidl Manchester-Moss Side",
    lat: 53.4799,
    lng: -2.2622,
    score: 4.4,
    status: "success",
    type: "Lidl",
    address: "Manchester, Moss Side",
  },
  {
    id: 1088,
    name: "Lidl Express Brussels-Saint-Gilles",
    lat: 50.8725,
    lng: 4.3349,
    score: 4.6,
    status: "success",
    type: "Lidl Express",
    address: "Brussels, Saint-Gilles",
  },
  {
    id: 1089,
    name: "Lidl Express Porto-Nevogilde",
    lat: 41.16,
    lng: -8.6181,
    score: 3.3,
    status: "danger",
    type: "Lidl Express",
    address: "Porto, Nevogilde",
  },
  {
    id: 1090,
    name: "Lidl Express Le Mans-Nord",
    lat: 48.0304,
    lng: 0.1765,
    score: 3.7,
    status: "warning",
    type: "Lidl Express",
    address: "Le Mans, Nord",
  },
  {
    id: 1091,
    name: "Lidl Rijeka-Kantrida",
    lat: 45.3205,
    lng: 14.4173,
    score: 4.6,
    status: "success",
    type: "Lidl",
    address: "Rijeka, Kantrida",
  },
  {
    id: 1092,
    name: "Lidl Heraklion-Centre",
    lat: 35.3618,
    lng: 25.1588,
    score: 4.2,
    status: "success",
    type: "Lidl",
    address: "Heraklion, Centre",
  },
  {
    id: 1093,
    name: "Lidl Express Maribor-Lent",
    lat: 46.5539,
    lng: 15.6541,
    score: 4.8,
    status: "success",
    type: "Lidl Express",
    address: "Maribor, Lent",
  },
  {
    id: 1094,
    name: "Lidl XL Rennes-Centre",
    lat: 48.1325,
    lng: -1.6768,
    score: 3.2,
    status: "danger",
    type: "Lidl XL",
    address: "Rennes, Centre",
  },
  {
    id: 1095,
    name: "Lidl Express Liverpool-Childwall",
    lat: 53.418,
    lng: -2.9689,
    score: 2.6,
    status: "danger",
    type: "Lidl Express",
    address: "Liverpool, Childwall",
  },
  {
    id: 1096,
    name: "Lidl XL Amsterdam-Zuid",
    lat: 52.3812,
    lng: 4.8799,
    score: 3.6,
    status: "warning",
    type: "Lidl XL",
    address: "Amsterdam, Zuid",
  },
  {
    id: 1097,
    name: "Lidl XL Faro-Sé",
    lat: 37.0088,
    lng: -7.9342,
    score: 3.5,
    status: "warning",
    type: "Lidl XL",
    address: "Faro, Sé",
  },
  {
    id: 1098,
    name: "Lidl Express Waterford-Ballybricken",
    lat: 52.2835,
    lng: -7.1331,
    score: 5,
    status: "success",
    type: "Lidl Express",
    address: "Waterford, Ballybricken",
  },
  {
    id: 1099,
    name: "Lidl XL Toulouse-Borderouge",
    lat: 43.5923,
    lng: 1.4303,
    score: 3.1,
    status: "danger",
    type: "Lidl XL",
    address: "Toulouse, Borderouge",
  },
  {
    id: 1100,
    name: "Lidl XL Marseille-3e",
    lat: 43.2857,
    lng: 5.3557,
    score: 3.1,
    status: "danger",
    type: "Lidl XL",
    address: "Marseille, 3e",
  },
  {
    id: 1101,
    name: "Lidl Express Philadelphia-North Philly",
    lat: 39.9499,
    lng: -75.1879,
    score: 3.9,
    status: "warning",
    type: "Lidl Express",
    address: "Philadelphia, North Philly",
  },
  {
    id: 1102,
    name: "Lidl Express Valencia-Quatre Carreres",
    lat: 39.458,
    lng: -0.3572,
    score: 4.3,
    status: "success",
    type: "Lidl Express",
    address: "Valencia, Quatre Carreres",
  },
  {
    id: 1103,
    name: "Lidl Trieste-Barcola",
    lat: 45.627,
    lng: 13.7623,
    score: 3.9,
    status: "warning",
    type: "Lidl",
    address: "Trieste, Barcola",
  },
  {
    id: 1104,
    name: "Lidl Express Radom-Ustronie",
    lat: 51.4251,
    lng: 21.1229,
    score: 3.5,
    status: "warning",
    type: "Lidl Express",
    address: "Radom, Ustronie",
  },
  {
    id: 1105,
    name: "Lidl Krakow-Grzegórzki",
    lat: 50.0513,
    lng: 19.9629,
    score: 4.2,
    status: "success",
    type: "Lidl",
    address: "Krakow, Grzegórzki",
  },
  {
    id: 1106,
    name: "Lidl Radom-Południe",
    lat: 51.4005,
    lng: 21.1641,
    score: 3.5,
    status: "warning",
    type: "Lidl",
    address: "Radom, Południe",
  },
  {
    id: 1107,
    name: "Lidl Bristol-Knowle",
    lat: 51.4749,
    lng: -2.5778,
    score: 4,
    status: "warning",
    type: "Lidl",
    address: "Bristol, Knowle",
  },
  {
    id: 1108,
    name: "Lidl XL Dublin-City Centre",
    lat: 53.3496,
    lng: -6.2471,
    score: 4,
    status: "warning",
    type: "Lidl XL",
    address: "Dublin, City Centre",
  },
  {
    id: 1109,
    name: "Lidl Express Celje-Trnovo",
    lat: 46.2257,
    lng: 15.2359,
    score: 4.1,
    status: "warning",
    type: "Lidl Express",
    address: "Celje, Trnovo",
  },
  {
    id: 1110,
    name: "Lidl Express Budapest-District XIII",
    lat: 47.4817,
    lng: 19.0392,
    score: 3.9,
    status: "warning",
    type: "Lidl Express",
    address: "Budapest, District XIII",
  },
  {
    id: 1111,
    name: "Lidl Ploiesti-Vest",
    lat: 44.95,
    lng: 26.0143,
    score: 4.2,
    status: "success",
    type: "Lidl",
    address: "Ploiesti, Vest",
  },
  {
    id: 1112,
    name: "Lidl Ljubljana-Moste",
    lat: 46.0651,
    lng: 14.5191,
    score: 4.7,
    status: "success",
    type: "Lidl",
    address: "Ljubljana, Moste",
  },
  {
    id: 1113,
    name: "Lidl Express Turin-Mirafiori",
    lat: 45.0601,
    lng: 7.6978,
    score: 4,
    status: "warning",
    type: "Lidl Express",
    address: "Turin, Mirafiori",
  },
  {
    id: 1114,
    name: "Lidl XL Linz-Urfahr",
    lat: 48.3276,
    lng: 14.2989,
    score: 4.7,
    status: "success",
    type: "Lidl XL",
    address: "Linz, Urfahr",
  },
  {
    id: 1115,
    name: "Lidl XL Warsaw-Mokotów",
    lat: 52.2167,
    lng: 21.0154,
    score: 4.4,
    status: "success",
    type: "Lidl XL",
    address: "Warsaw, Mokotów",
  },
  {
    id: 1116,
    name: "Lidl Zurich-Enge",
    lat: 47.374,
    lng: 8.5638,
    score: 3.7,
    status: "warning",
    type: "Lidl",
    address: "Zurich, Enge",
  },
  {
    id: 1117,
    name: "Lidl XL Strasbourg-Cronenbourg",
    lat: 48.5961,
    lng: 7.766,
    score: 3.8,
    status: "warning",
    type: "Lidl XL",
    address: "Strasbourg, Cronenbourg",
  },
  {
    id: 1118,
    name: "Lidl Raleigh-Glenwood",
    lat: 35.7847,
    lng: -78.6417,
    score: 2.8,
    status: "danger",
    type: "Lidl",
    address: "Raleigh, Glenwood",
  },
  {
    id: 1119,
    name: "Lidl Edinburgh-Gorgie",
    lat: 55.9533,
    lng: -3.2103,
    score: 3.9,
    status: "warning",
    type: "Lidl",
    address: "Edinburgh, Gorgie",
  },
  {
    id: 1120,
    name: "Lidl XL Baltimore-Inner Harbor",
    lat: 39.306,
    lng: -76.5991,
    score: 4,
    status: "warning",
    type: "Lidl XL",
    address: "Baltimore, Inner Harbor",
  },
  {
    id: 1121,
    name: "Lidl Ljubljana-Dravlje",
    lat: 46.0384,
    lng: 14.4953,
    score: 4.9,
    status: "success",
    type: "Lidl",
    address: "Ljubljana, Dravlje",
  },
  {
    id: 1122,
    name: "Lidl Express Murcia-Centro",
    lat: 37.979,
    lng: -1.1333,
    score: 4.4,
    status: "success",
    type: "Lidl Express",
    address: "Murcia, Centro",
  },
  {
    id: 1123,
    name: "Lidl Express Burgas-Lazur",
    lat: 42.5165,
    lng: 27.4657,
    score: 3.6,
    status: "warning",
    type: "Lidl Express",
    address: "Burgas, Lazur",
  },
  {
    id: 1124,
    name: "Lidl Brighton-City Centre",
    lat: 50.8264,
    lng: -0.1269,
    score: 3.7,
    status: "warning",
    type: "Lidl",
    address: "Brighton, City Centre",
  },
  {
    id: 1125,
    name: "Lidl Charleroi-Centre",
    lat: 50.4192,
    lng: 4.4665,
    score: 3.9,
    status: "warning",
    type: "Lidl",
    address: "Charleroi, Centre",
  },
  {
    id: 1126,
    name: "Lidl XL Szczecin-Niebułowo",
    lat: 53.4142,
    lng: 14.5761,
    score: 4,
    status: "warning",
    type: "Lidl XL",
    address: "Szczecin, Niebułowo",
  },
  {
    id: 1127,
    name: "Lidl Winterthur-Oberwinterthur",
    lat: 47.5179,
    lng: 8.7489,
    score: 3,
    status: "danger",
    type: "Lidl",
    address: "Winterthur, Oberwinterthur",
  },
  {
    id: 1128,
    name: "Lidl XL Mons-Havré",
    lat: 50.4579,
    lng: 3.934,
    score: 3.8,
    status: "warning",
    type: "Lidl XL",
    address: "Mons, Havré",
  },
  {
    id: 1129,
    name: "Lidl Express Tilburg-West",
    lat: 51.5674,
    lng: 5.0891,
    score: 2.6,
    status: "danger",
    type: "Lidl Express",
    address: "Tilburg, West",
  },
  {
    id: 1130,
    name: "Lidl Express Valencia-Extramurs",
    lat: 39.4699,
    lng: -0.3662,
    score: 4,
    status: "warning",
    type: "Lidl Express",
    address: "Valencia, Extramurs",
  },
  {
    id: 1131,
    name: "Lidl XL Bruges-Sint-Michiels",
    lat: 51.2015,
    lng: 3.2424,
    score: 3.6,
    status: "warning",
    type: "Lidl XL",
    address: "Bruges, Sint-Michiels",
  },
  {
    id: 1132,
    name: "Lidl Express Prague-Praha 8",
    lat: 50.0999,
    lng: 14.4598,
    score: 3.7,
    status: "warning",
    type: "Lidl Express",
    address: "Prague, Praha 8",
  },
  {
    id: 1133,
    name: "Lidl Pécs-Zsolnay",
    lat: 46.0499,
    lng: 18.2407,
    score: 4.6,
    status: "success",
    type: "Lidl",
    address: "Pécs, Zsolnay",
  },
  {
    id: 1134,
    name: "Lidl XL Manchester-Withington",
    lat: 53.4869,
    lng: -2.2272,
    score: 2.8,
    status: "danger",
    type: "Lidl XL",
    address: "Manchester, Withington",
  },
  {
    id: 1135,
    name: "Lidl Craiova-Centru",
    lat: 44.3491,
    lng: 23.7969,
    score: 4.7,
    status: "success",
    type: "Lidl",
    address: "Craiova, Centru",
  },
  {
    id: 1136,
    name: "Lidl XL Leuven-Kessel-Lo",
    lat: 50.8867,
    lng: 4.6815,
    score: 3.8,
    status: "warning",
    type: "Lidl XL",
    address: "Leuven, Kessel-Lo",
  },
  {
    id: 1137,
    name: "Lidl London-Waltham Forest",
    lat: 51.5275,
    lng: -0.1283,
    score: 2.8,
    status: "danger",
    type: "Lidl",
    address: "London, Waltham Forest",
  },
  {
    id: 1138,
    name: "Lidl Wels-Pernau",
    lat: 48.1328,
    lng: 14.0504,
    score: 3.6,
    status: "warning",
    type: "Lidl",
    address: "Wels, Pernau",
  },
  {
    id: 1139,
    name: "Lidl Thessaloniki-Stavroupoli",
    lat: 40.6209,
    lng: 22.9693,
    score: 4.5,
    status: "success",
    type: "Lidl",
    address: "Thessaloniki, Stavroupoli",
  },
  {
    id: 1140,
    name: "Lidl Liberec-Vratislavice",
    lat: 50.752,
    lng: 15.042,
    score: 4,
    status: "warning",
    type: "Lidl",
    address: "Liberec, Vratislavice",
  },
  {
    id: 1141,
    name: "Lidl Thessaloniki-Kalamaria",
    lat: 40.6622,
    lng: 22.9516,
    score: 3.7,
    status: "warning",
    type: "Lidl",
    address: "Thessaloniki, Kalamaria",
  },
  {
    id: 1142,
    name: "Lidl Express Utrecht-Lunetten",
    lat: 52.0674,
    lng: 5.1445,
    score: 2.6,
    status: "danger",
    type: "Lidl Express",
    address: "Utrecht, Lunetten",
  },
  {
    id: 1143,
    name: "Lidl Express Lille-Lomme",
    lat: 50.6185,
    lng: 3.0336,
    score: 3.4,
    status: "warning",
    type: "Lidl Express",
    address: "Lille, Lomme",
  },
  {
    id: 1144,
    name: "Lidl Ljubljana-Bežigrad",
    lat: 46.0776,
    lng: 14.5207,
    score: 3.7,
    status: "warning",
    type: "Lidl",
    address: "Ljubljana, Bežigrad",
  },
  {
    id: 1145,
    name: "Lidl XL Brussels-Molenbeek",
    lat: 50.8741,
    lng: 4.3389,
    score: 3.3,
    status: "danger",
    type: "Lidl XL",
    address: "Brussels, Molenbeek",
  },
  {
    id: 1146,
    name: "Lidl Express Lyon-Vaulx-en-Velin",
    lat: 45.7819,
    lng: 4.8311,
    score: 4.3,
    status: "success",
    type: "Lidl Express",
    address: "Lyon, Vaulx-en-Velin",
  },
  {
    id: 1147,
    name: "Lidl Express Bucharest-Titan",
    lat: 44.4077,
    lng: 26.1237,
    score: 4.6,
    status: "success",
    type: "Lidl Express",
    address: "Bucharest, Titan",
  },
  {
    id: 1148,
    name: "Lidl XL Bari-Poggiofranco",
    lat: 41.0967,
    lng: 16.8548,
    score: 3.7,
    status: "warning",
    type: "Lidl XL",
    address: "Bari, Poggiofranco",
  },
  {
    id: 1149,
    name: "Lidl Prague-Praha 6",
    lat: 50.078,
    lng: 14.434,
    score: 3,
    status: "danger",
    type: "Lidl",
    address: "Prague, Praha 6",
  },
  {
    id: 1150,
    name: "Lidl Express Seville-Triana",
    lat: 37.3739,
    lng: -5.9903,
    score: 4.2,
    status: "warning",
    type: "Lidl Express",
    address: "Seville, Triana",
  },
  {
    id: 1151,
    name: "Lidl New York-Williamsburg",
    lat: 40.7125,
    lng: -74.0228,
    score: 2.8,
    status: "danger",
    type: "Lidl",
    address: "New York, Williamsburg",
  },
  {
    id: 1152,
    name: "Lidl XL Namur-Saint-Servais",
    lat: 50.4836,
    lng: 4.8696,
    score: 4.6,
    status: "success",
    type: "Lidl XL",
    address: "Namur, Saint-Servais",
  },
  {
    id: 1153,
    name: "Lidl Express Zadar-Diklo",
    lat: 44.1314,
    lng: 15.2225,
    score: 4.2,
    status: "warning",
    type: "Lidl Express",
    address: "Zadar, Diklo",
  },
  {
    id: 1154,
    name: "Lidl Express Venice-Santa Croce",
    lat: 45.4492,
    lng: 12.2928,
    score: 3.9,
    status: "warning",
    type: "Lidl Express",
    address: "Venice, Santa Croce",
  },
  {
    id: 1155,
    name: "Lidl Express Vienna-Hietzing",
    lat: 48.2121,
    lng: 16.3732,
    score: 3.6,
    status: "warning",
    type: "Lidl Express",
    address: "Vienna, Hietzing",
  },
  {
    id: 1156,
    name: "Lidl XL Prague-Praha 10",
    lat: 50.0549,
    lng: 14.432,
    score: 4.4,
    status: "success",
    type: "Lidl XL",
    address: "Prague, Praha 10",
  },
  {
    id: 1157,
    name: "Lidl XL Timisoara-Iosefin",
    lat: 45.7644,
    lng: 21.1982,
    score: 3.8,
    status: "warning",
    type: "Lidl XL",
    address: "Timisoara, Iosefin",
  },
  {
    id: 1158,
    name: "Lidl XL Cork-Douglas",
    lat: 51.8798,
    lng: -8.4799,
    score: 3.6,
    status: "warning",
    type: "Lidl XL",
    address: "Cork, Douglas",
  },
  {
    id: 1159,
    name: "Lidl XL Varna-Centar",
    lat: 43.1913,
    lng: 27.9154,
    score: 4.4,
    status: "success",
    type: "Lidl XL",
    address: "Varna, Centar",
  },
  {
    id: 1160,
    name: "Lidl XL Amsterdam-Jordaan",
    lat: 52.3486,
    lng: 4.8866,
    score: 2.8,
    status: "danger",
    type: "Lidl XL",
    address: "Amsterdam, Jordaan",
  },
  {
    id: 1161,
    name: "Lidl XL Sofia-Ivan Vazov",
    lat: 42.7197,
    lng: 23.3352,
    score: 3.9,
    status: "warning",
    type: "Lidl XL",
    address: "Sofia, Ivan Vazov",
  },
  {
    id: 1162,
    name: "Lidl Brasov-Triaj",
    lat: 45.643,
    lng: 25.5956,
    score: 4.2,
    status: "warning",
    type: "Lidl",
    address: "Brasov, Triaj",
  },
  {
    id: 1163,
    name: "Lidl Express Strasbourg-Hautepierre",
    lat: 48.586,
    lng: 7.735,
    score: 3.7,
    status: "warning",
    type: "Lidl Express",
    address: "Strasbourg, Hautepierre",
  },
  {
    id: 1164,
    name: "Lidl Express Genoa-Sampierdarena",
    lat: 44.3883,
    lng: 8.9574,
    score: 4.2,
    status: "warning",
    type: "Lidl Express",
    address: "Genoa, Sampierdarena",
  },
  {
    id: 1165,
    name: "Lidl Leeds-Chapel Allerton",
    lat: 53.8218,
    lng: -1.5414,
    score: 3.1,
    status: "danger",
    type: "Lidl",
    address: "Leeds, Chapel Allerton",
  },
  {
    id: 1166,
    name: "Lidl XL Braga-Palmeira",
    lat: 41.5628,
    lng: -8.4309,
    score: 4,
    status: "warning",
    type: "Lidl XL",
    address: "Braga, Palmeira",
  },
  {
    id: 1167,
    name: "Lidl Express Valencia-Pobles del Sud",
    lat: 39.4588,
    lng: -0.366,
    score: 3.6,
    status: "warning",
    type: "Lidl Express",
    address: "Valencia, Pobles del Sud",
  },
  {
    id: 1168,
    name: "Lidl XL Mons-Nimy",
    lat: 50.462,
    lng: 3.9413,
    score: 3.3,
    status: "danger",
    type: "Lidl XL",
    address: "Mons, Nimy",
  },
  {
    id: 1169,
    name: "Lidl XL Barcelona-Sarrià-Sant Gervasi",
    lat: 41.3658,
    lng: 2.1774,
    score: 3.6,
    status: "warning",
    type: "Lidl XL",
    address: "Barcelona, Sarrià-Sant Gervasi",
  },
  {
    id: 1170,
    name: "Lidl Express Richmond-Scott's Addition",
    lat: 37.5361,
    lng: -77.4184,
    score: 3.4,
    status: "danger",
    type: "Lidl Express",
    address: "Richmond, Scott's Addition",
  },
  {
    id: 1171,
    name: "Lidl Express Wroclaw-Świdnica",
    lat: 51.1054,
    lng: 17.0412,
    score: 4.8,
    status: "success",
    type: "Lidl Express",
    address: "Wroclaw, Świdnica",
  },
  {
    id: 1172,
    name: "Lidl London-Enfield",
    lat: 51.4936,
    lng: -0.1095,
    score: 3.5,
    status: "warning",
    type: "Lidl",
    address: "London, Enfield",
  },
  {
    id: 1173,
    name: "Lidl XL Paris-7e",
    lat: 48.8389,
    lng: 2.3709,
    score: 2.7,
    status: "danger",
    type: "Lidl XL",
    address: "Paris, 7e",
  },
  {
    id: 1174,
    name: "Lidl St. Pölten-Spratzern",
    lat: 48.1832,
    lng: 15.6087,
    score: 4.9,
    status: "success",
    type: "Lidl",
    address: "St. Pölten, Spratzern",
  },
  {
    id: 1175,
    name: "Lidl XL Vienna-Penzing",
    lat: 48.1843,
    lng: 16.3962,
    score: 3.6,
    status: "warning",
    type: "Lidl XL",
    address: "Vienna, Penzing",
  },
  {
    id: 1176,
    name: "Lidl XL Győr-Gyárváros",
    lat: 47.6709,
    lng: 17.6623,
    score: 3.6,
    status: "warning",
    type: "Lidl XL",
    address: "Győr, Gyárváros",
  },
  {
    id: 1177,
    name: "Lidl Express Bucharest-Sector 5",
    lat: 44.424,
    lng: 26.1262,
    score: 4.6,
    status: "success",
    type: "Lidl Express",
    address: "Bucharest, Sector 5",
  },
  {
    id: 1178,
    name: "Lidl XL Wroclaw-Psie Pole",
    lat: 51.1006,
    lng: 17.0445,
    score: 4.7,
    status: "success",
    type: "Lidl XL",
    address: "Wroclaw, Psie Pole",
  },
  {
    id: 1179,
    name: "Lidl Express Breda-Centrum",
    lat: 51.593,
    lng: 4.7567,
    score: 4.4,
    status: "success",
    type: "Lidl Express",
    address: "Breda, Centrum",
  },
  {
    id: 1180,
    name: "Lidl XL Trieste-Roiano",
    lat: 45.6553,
    lng: 13.7851,
    score: 4,
    status: "warning",
    type: "Lidl XL",
    address: "Trieste, Roiano",
  },
  {
    id: 1181,
    name: "Lidl XL Lisbon-Marvila",
    lat: 38.7382,
    lng: -9.1235,
    score: 4.1,
    status: "warning",
    type: "Lidl XL",
    address: "Lisbon, Marvila",
  },
  {
    id: 1182,
    name: "Lidl Express Reims-Croix-Rouge",
    lat: 49.2665,
    lng: 4.0102,
    score: 4.6,
    status: "success",
    type: "Lidl Express",
    address: "Reims, Croix-Rouge",
  },
  {
    id: 1183,
    name: "Lidl Amsterdam-Oost",
    lat: 52.359,
    lng: 4.8825,
    score: 4.8,
    status: "success",
    type: "Lidl",
    address: "Amsterdam, Oost",
  },
  {
    id: 1184,
    name: "Lidl Naples-San Carlo",
    lat: 40.8568,
    lng: 14.2712,
    score: 3.2,
    status: "danger",
    type: "Lidl",
    address: "Naples, San Carlo",
  },
  {
    id: 1185,
    name: "Lidl Express Nice-Centre",
    lat: 43.714,
    lng: 7.2524,
    score: 4.2,
    status: "warning",
    type: "Lidl Express",
    address: "Nice, Centre",
  },
  {
    id: 1186,
    name: "Lidl Dublin-Blanchardstown",
    lat: 53.3535,
    lng: -6.2357,
    score: 4.1,
    status: "warning",
    type: "Lidl",
    address: "Dublin, Blanchardstown",
  },
  {
    id: 1187,
    name: "Lidl Cardiff-Llandaff",
    lat: 51.4945,
    lng: -3.176,
    score: 4,
    status: "warning",
    type: "Lidl",
    address: "Cardiff, Llandaff",
  },
  {
    id: 1188,
    name: "Lidl Express Nijmegen-Centrum",
    lat: 51.8197,
    lng: 5.8737,
    score: 2.7,
    status: "danger",
    type: "Lidl Express",
    address: "Nijmegen, Centrum",
  },
  {
    id: 1189,
    name: "Lidl Express Grenoble-La Tronche",
    lat: 45.2012,
    lng: 5.7137,
    score: 3.8,
    status: "warning",
    type: "Lidl Express",
    address: "Grenoble, La Tronche",
  },
  {
    id: 1190,
    name: "Lidl Express Zaragoza-Actur",
    lat: 41.6687,
    lng: -0.8984,
    score: 4.1,
    status: "warning",
    type: "Lidl Express",
    address: "Zaragoza, Actur",
  },
  {
    id: 1191,
    name: "Lidl XL Madrid-Hortaleza",
    lat: 40.4126,
    lng: -3.7137,
    score: 3.2,
    status: "danger",
    type: "Lidl XL",
    address: "Madrid, Hortaleza",
  },
  {
    id: 1192,
    name: "Lidl Bristol-Centre",
    lat: 51.4465,
    lng: -2.592,
    score: 4.1,
    status: "warning",
    type: "Lidl",
    address: "Bristol, Centre",
  },
  {
    id: 1193,
    name: "Lidl Express Cardiff-Whitchurch",
    lat: 51.4733,
    lng: -3.1742,
    score: 3.4,
    status: "warning",
    type: "Lidl Express",
    address: "Cardiff, Whitchurch",
  },
  {
    id: 1194,
    name: "Lidl Zagreb-Maksimir",
    lat: 45.806,
    lng: 15.9735,
    score: 4,
    status: "warning",
    type: "Lidl",
    address: "Zagreb, Maksimir",
  },
  {
    id: 1195,
    name: "Lidl XL Leicester-Evington",
    lat: 52.6338,
    lng: -1.1607,
    score: 3.6,
    status: "warning",
    type: "Lidl XL",
    address: "Leicester, Evington",
  },
  {
    id: 1196,
    name: "Lidl XL Cork-Mahon",
    lat: 51.8868,
    lng: -8.4789,
    score: 4.1,
    status: "warning",
    type: "Lidl XL",
    address: "Cork, Mahon",
  },
  {
    id: 1197,
    name: "Lidl Express Groningen-Oost",
    lat: 53.2143,
    lng: 6.5897,
    score: 2.9,
    status: "danger",
    type: "Lidl Express",
    address: "Groningen, Oost",
  },
  {
    id: 1198,
    name: "Lidl Express Krakow-Krowodrza",
    lat: 50.0795,
    lng: 19.9362,
    score: 4.9,
    status: "success",
    type: "Lidl Express",
    address: "Krakow, Krowodrza",
  },
  {
    id: 1199,
    name: "Lidl Genoa-Rivarolo",
    lat: 44.4047,
    lng: 8.9492,
    score: 3.8,
    status: "warning",
    type: "Lidl",
    address: "Genoa, Rivarolo",
  },
  {
    id: 1200,
    name: "Lidl Express Washington-Arlington",
    lat: 38.9112,
    lng: -77.0187,
    score: 4.6,
    status: "success",
    type: "Lidl Express",
    address: "Washington, Arlington",
  },
  {
    id: 1201,
    name: "Lidl XL Athens-Nea Smyrni",
    lat: 37.9944,
    lng: 23.7104,
    score: 3.2,
    status: "danger",
    type: "Lidl XL",
    address: "Athens, Nea Smyrni",
  },
  {
    id: 1202,
    name: "Lidl XL London-Wandsworth",
    lat: 51.513,
    lng: -0.145,
    score: 2.9,
    status: "danger",
    type: "Lidl XL",
    address: "London, Wandsworth",
  },
  {
    id: 1203,
    name: "Lidl Express Pilsen-Bory",
    lat: 49.7246,
    lng: 13.3611,
    score: 4.3,
    status: "success",
    type: "Lidl Express",
    address: "Pilsen, Bory",
  },
  {
    id: 1204,
    name: "Lidl Cluj-Napoca-Intre Lacuri",
    lat: 46.7547,
    lng: 23.6178,
    score: 4.8,
    status: "success",
    type: "Lidl",
    address: "Cluj-Napoca, Intre Lacuri",
  },
  {
    id: 1205,
    name: "Lidl Catania-San Giorgio",
    lat: 37.5122,
    lng: 15.0977,
    score: 4.4,
    status: "success",
    type: "Lidl",
    address: "Catania, San Giorgio",
  },
  {
    id: 1206,
    name: "Lidl XL Radom-Śródmieście",
    lat: 51.3958,
    lng: 21.1374,
    score: 3.9,
    status: "warning",
    type: "Lidl XL",
    address: "Radom, Śródmieście",
  },
  {
    id: 1207,
    name: "Lidl Express Amadora-Buraca",
    lat: 38.7745,
    lng: -9.2223,
    score: 4.9,
    status: "success",
    type: "Lidl Express",
    address: "Amadora, Buraca",
  },
  {
    id: 1208,
    name: "Lidl Express Cluj-Napoca-Manastur",
    lat: 46.7627,
    lng: 23.606,
    score: 4.4,
    status: "success",
    type: "Lidl Express",
    address: "Cluj-Napoca, Manastur",
  },
  {
    id: 1209,
    name: "Lidl Vienna-Alsergrund",
    lat: 48.2078,
    lng: 16.3613,
    score: 4.9,
    status: "success",
    type: "Lidl",
    address: "Vienna, Alsergrund",
  },
  {
    id: 1210,
    name: "Lidl Express Ruse-Vetren",
    lat: 43.8381,
    lng: 25.968,
    score: 4.7,
    status: "success",
    type: "Lidl Express",
    address: "Ruse, Vetren",
  },
  {
    id: 1211,
    name: "Lidl Express Pécs-Uránváros",
    lat: 46.0799,
    lng: 18.2478,
    score: 4.4,
    status: "success",
    type: "Lidl Express",
    address: "Pécs, Uránváros",
  },
  {
    id: 1212,
    name: "Lidl XL Villeurbanne-Centre",
    lat: 45.775,
    lng: 4.86,
    score: 2.8,
    status: "danger",
    type: "Lidl XL",
    address: "Villeurbanne, Centre",
  },
  {
    id: 1213,
    name: "Lidl Milan-Lambrate",
    lat: 45.4698,
    lng: 9.1658,
    score: 3.5,
    status: "warning",
    type: "Lidl",
    address: "Milan, Lambrate",
  },
  {
    id: 1214,
    name: "Lidl Norfolk-Downtown",
    lat: 36.8366,
    lng: -76.2709,
    score: 3.3,
    status: "danger",
    type: "Lidl",
    address: "Norfolk, Downtown",
  },
  {
    id: 1215,
    name: "Lidl XL Washington-Downtown",
    lat: 38.9207,
    lng: -77.0336,
    score: 4.5,
    status: "success",
    type: "Lidl XL",
    address: "Washington, Downtown",
  },
  {
    id: 1216,
    name: "Lidl Olomouc-Neředín",
    lat: 49.6074,
    lng: 17.2379,
    score: 4.9,
    status: "success",
    type: "Lidl",
    address: "Olomouc, Neředín",
  },
  {
    id: 1217,
    name: "Lidl XL Bucharest-Berceni",
    lat: 44.4022,
    lng: 26.1099,
    score: 3.1,
    status: "danger",
    type: "Lidl XL",
    address: "Bucharest, Berceni",
  },
  {
    id: 1218,
    name: "Lidl XL Brussels-Centre",
    lat: 50.8471,
    lng: 4.3318,
    score: 3.4,
    status: "danger",
    type: "Lidl XL",
    address: "Brussels, Centre",
  },
  {
    id: 1219,
    name: "Lidl Express Miskolc-Diósgyőr",
    lat: 48.1157,
    lng: 20.77,
    score: 3.8,
    status: "warning",
    type: "Lidl Express",
    address: "Miskolc, Diósgyőr",
  },
  {
    id: 1220,
    name: "Lidl Bilbao-Begoña",
    lat: 43.2725,
    lng: -2.93,
    score: 2.8,
    status: "danger",
    type: "Lidl",
    address: "Bilbao, Begoña",
  },
  {
    id: 1221,
    name: "Lidl London-Barnet",
    lat: 51.5173,
    lng: -0.1125,
    score: 3.7,
    status: "warning",
    type: "Lidl",
    address: "London, Barnet",
  },
  {
    id: 1222,
    name: "Lidl Express Galati-Siderurgistilor",
    lat: 45.4116,
    lng: 28.0213,
    score: 4.3,
    status: "success",
    type: "Lidl Express",
    address: "Galati, Siderurgistilor",
  },
  {
    id: 1223,
    name: "Lidl XL Gdynia-Obłuże",
    lat: 54.5047,
    lng: 18.5108,
    score: 4.6,
    status: "success",
    type: "Lidl XL",
    address: "Gdynia, Obłuże",
  },
  {
    id: 1224,
    name: "Lidl Express Brno-Bystrc",
    lat: 49.1743,
    lng: 16.5919,
    score: 4.5,
    status: "success",
    type: "Lidl Express",
    address: "Brno, Bystrc",
  },
  {
    id: 1225,
    name: "Lidl XL Birmingham-Sutton Coldfield",
    lat: 52.4624,
    lng: -1.9128,
    score: 4.4,
    status: "success",
    type: "Lidl XL",
    address: "Birmingham, Sutton Coldfield",
  },
  {
    id: 1226,
    name: "Lidl Valencia-Patraix",
    lat: 39.4756,
    lng: -0.3924,
    score: 2.6,
    status: "danger",
    type: "Lidl",
    address: "Valencia, Patraix",
  },
  {
    id: 1227,
    name: "Lidl Express Dublin-Tallaght",
    lat: 53.3598,
    lng: -6.2841,
    score: 3.8,
    status: "warning",
    type: "Lidl Express",
    address: "Dublin, Tallaght",
  },
  {
    id: 1228,
    name: "Lidl Nîmes-Écusson",
    lat: 43.8367,
    lng: 4.3678,
    score: 4.1,
    status: "warning",
    type: "Lidl",
    address: "Nîmes, Écusson",
  },
  {
    id: 1229,
    name: "Lidl Pécs-Centrum",
    lat: 46.0821,
    lng: 18.2494,
    score: 3.5,
    status: "warning",
    type: "Lidl",
    address: "Pécs, Centrum",
  },
  {
    id: 1230,
    name: "Lidl XL Ruse-Centar",
    lat: 43.829,
    lng: 25.9905,
    score: 3.5,
    status: "warning",
    type: "Lidl XL",
    address: "Ruse, Centar",
  },
  {
    id: 1231,
    name: "Lidl Rome-Testaccio",
    lat: 41.8855,
    lng: 12.4922,
    score: 4.6,
    status: "success",
    type: "Lidl",
    address: "Rome, Testaccio",
  },
  {
    id: 1232,
    name: "Lidl Express Graz-Jakomini",
    lat: 47.0727,
    lng: 15.4222,
    score: 2.9,
    status: "danger",
    type: "Lidl Express",
    address: "Graz, Jakomini",
  },
  {
    id: 1233,
    name: "Lidl XL Liverpool-Crosby",
    lat: 53.4139,
    lng: -2.9838,
    score: 3.5,
    status: "warning",
    type: "Lidl XL",
    address: "Liverpool, Crosby",
  },
  {
    id: 1234,
    name: "Lidl Amadora-Damaia",
    lat: 38.7473,
    lng: -9.241,
    score: 3.4,
    status: "danger",
    type: "Lidl",
    address: "Amadora, Damaia",
  },
  {
    id: 1235,
    name: "Lidl XL Saint-Étienne-Châteaucreux",
    lat: 45.4318,
    lng: 4.4074,
    score: 4.4,
    status: "success",
    type: "Lidl XL",
    address: "Saint-Étienne, Châteaucreux",
  },
  {
    id: 1236,
    name: "Lidl XL Bari-Libertà",
    lat: 41.0952,
    lng: 16.856,
    score: 4.1,
    status: "warning",
    type: "Lidl XL",
    address: "Bari, Libertà",
  },
  {
    id: 1237,
    name: "Lidl Express Amsterdam-Nieuw-West",
    lat: 52.3796,
    lng: 4.8912,
    score: 4.6,
    status: "success",
    type: "Lidl Express",
    address: "Amsterdam, Nieuw-West",
  },
  {
    id: 1238,
    name: "Lidl XL Glasgow-East End",
    lat: 55.8556,
    lng: -4.271,
    score: 3.1,
    status: "danger",
    type: "Lidl XL",
    address: "Glasgow, East End",
  },
  {
    id: 1239,
    name: "Lidl XL Gdynia-Śródmieście",
    lat: 54.4997,
    lng: 18.5383,
    score: 3.3,
    status: "danger",
    type: "Lidl XL",
    address: "Gdynia, Śródmieście",
  },
  {
    id: 1240,
    name: "Lidl Express Gdynia-Oksywie",
    lat: 54.5359,
    lng: 18.5101,
    score: 4.3,
    status: "success",
    type: "Lidl Express",
    address: "Gdynia, Oksywie",
  },
  {
    id: 1241,
    name: "Lidl Express Greenville-North Main",
    lat: 34.872,
    lng: -82.3916,
    score: 4.5,
    status: "success",
    type: "Lidl Express",
    address: "Greenville, North Main",
  },
  {
    id: 1242,
    name: "Lidl Express Cordoba-Levante",
    lat: 37.8915,
    lng: -4.7907,
    score: 4.7,
    status: "success",
    type: "Lidl Express",
    address: "Cordoba, Levante",
  },
  {
    id: 1243,
    name: "Lidl XL Zaragoza-Oliver-Valdefierro",
    lat: 41.663,
    lng: -0.8641,
    score: 3.7,
    status: "warning",
    type: "Lidl XL",
    address: "Zaragoza, Oliver-Valdefierro",
  },
  {
    id: 1244,
    name: "Lidl Express London-Lambeth",
    lat: 51.5146,
    lng: -0.1267,
    score: 3.4,
    status: "warning",
    type: "Lidl Express",
    address: "London, Lambeth",
  },
  {
    id: 1245,
    name: "Lidl Marseille-2e",
    lat: 43.2734,
    lng: 5.3706,
    score: 2.8,
    status: "danger",
    type: "Lidl",
    address: "Marseille, 2e",
  },
  {
    id: 1246,
    name: "Lidl Győr-Szabadhegy",
    lat: 47.6918,
    lng: 17.6678,
    score: 3.8,
    status: "warning",
    type: "Lidl",
    address: "Győr, Szabadhegy",
  },
  {
    id: 1247,
    name: "Lidl Lausanne-Flon",
    lat: 46.4967,
    lng: 6.6112,
    score: 4.1,
    status: "warning",
    type: "Lidl",
    address: "Lausanne, Flon",
  },
  {
    id: 1248,
    name: "Lidl Express Gijon-Este",
    lat: 43.555,
    lng: -5.6618,
    score: 3.9,
    status: "warning",
    type: "Lidl Express",
    address: "Gijon, Este",
  },
  {
    id: 1249,
    name: "Lidl XL Paris-16e",
    lat: 48.8654,
    lng: 2.3611,
    score: 3.7,
    status: "warning",
    type: "Lidl XL",
    address: "Paris, 16e",
  },
  {
    id: 1250,
    name: "Lidl The Hague-Leidschenveen",
    lat: 52.0647,
    lng: 4.292,
    score: 3.7,
    status: "warning",
    type: "Lidl",
    address: "The Hague, Leidschenveen",
  },
  {
    id: 1251,
    name: "Lidl Express Limerick-City Centre",
    lat: 52.6837,
    lng: -8.6369,
    score: 2.9,
    status: "danger",
    type: "Lidl Express",
    address: "Limerick, City Centre",
  },
  {
    id: 1252,
    name: "Lidl Express Szeged-Felsőváros",
    lat: 46.2634,
    lng: 20.1289,
    score: 3.2,
    status: "danger",
    type: "Lidl Express",
    address: "Szeged, Felsőváros",
  },
  {
    id: 1253,
    name: "Lidl Express Bilbao-Rekalde",
    lat: 43.2585,
    lng: -2.9219,
    score: 4.5,
    status: "success",
    type: "Lidl Express",
    address: "Bilbao, Rekalde",
  },
  {
    id: 1254,
    name: "Lidl XL Newcastle-City Centre",
    lat: 54.9613,
    lng: -1.6084,
    score: 4.6,
    status: "success",
    type: "Lidl XL",
    address: "Newcastle, City Centre",
  },
  {
    id: 1255,
    name: "Lidl Express Antwerp-Borgerhout",
    lat: 51.2115,
    lng: 4.4137,
    score: 4.2,
    status: "warning",
    type: "Lidl Express",
    address: "Antwerp, Borgerhout",
  },
  {
    id: 1256,
    name: "Lidl Valencia-Benimaclet",
    lat: 39.4847,
    lng: -0.3665,
    score: 4.1,
    status: "warning",
    type: "Lidl",
    address: "Valencia, Benimaclet",
  },
  {
    id: 1257,
    name: "Lidl Norfolk-Ghent",
    lat: 36.8687,
    lng: -76.2815,
    score: 4.9,
    status: "success",
    type: "Lidl",
    address: "Norfolk, Ghent",
  },
  {
    id: 1258,
    name: "Lidl Cluj-Napoca-Gheorgheni",
    lat: 46.7485,
    lng: 23.611,
    score: 3.6,
    status: "warning",
    type: "Lidl",
    address: "Cluj-Napoca, Gheorgheni",
  },
  {
    id: 1259,
    name: "Lidl Glasgow-City Centre",
    lat: 55.8599,
    lng: -4.2317,
    score: 4.4,
    status: "success",
    type: "Lidl",
    address: "Glasgow, City Centre",
  },
  {
    id: 1260,
    name: "Lidl XL Liège-Centre",
    lat: 50.6273,
    lng: 5.5642,
    score: 4.6,
    status: "success",
    type: "Lidl XL",
    address: "Liège, Centre",
  },
  {
    id: 1261,
    name: "Lidl Express Marseille-8e",
    lat: 43.2945,
    lng: 5.3835,
    score: 4,
    status: "warning",
    type: "Lidl Express",
    address: "Marseille, 8e",
  },
  {
    id: 1262,
    name: "Lidl Paris-8e",
    lat: 48.8701,
    lng: 2.3369,
    score: 4.1,
    status: "warning",
    type: "Lidl",
    address: "Paris, 8e",
  },
  {
    id: 1263,
    name: "Lidl XL Valencia-Pobles del Nord",
    lat: 39.47,
    lng: -0.3793,
    score: 4.2,
    status: "success",
    type: "Lidl XL",
    address: "Valencia, Pobles del Nord",
  },
  {
    id: 1264,
    name: "Lidl Express Edinburgh-Morningside",
    lat: 55.9334,
    lng: -3.1789,
    score: 3.7,
    status: "warning",
    type: "Lidl Express",
    address: "Edinburgh, Morningside",
  },
  {
    id: 1265,
    name: "Lidl Ostrava-Hrabůvka",
    lat: 49.8404,
    lng: 18.2553,
    score: 2.9,
    status: "danger",
    type: "Lidl",
    address: "Ostrava, Hrabůvka",
  },
  {
    id: 1266,
    name: "Lidl Rome-Ostiense",
    lat: 41.8981,
    lng: 12.4901,
    score: 2.6,
    status: "danger",
    type: "Lidl",
    address: "Rome, Ostiense",
  },
  {
    id: 1267,
    name: "Lidl Cork-Bishopstown",
    lat: 51.9214,
    lng: -8.4992,
    score: 3.2,
    status: "danger",
    type: "Lidl",
    address: "Cork, Bishopstown",
  },
  {
    id: 1268,
    name: "Lidl XL Barcelona-Nou Barris",
    lat: 41.4021,
    lng: 2.1855,
    score: 2.6,
    status: "danger",
    type: "Lidl XL",
    address: "Barcelona, Nou Barris",
  },
  {
    id: 1269,
    name: "Lidl Lyon-3e",
    lat: 45.7717,
    lng: 4.8427,
    score: 4.3,
    status: "success",
    type: "Lidl",
    address: "Lyon, 3e",
  },
  {
    id: 1270,
    name: "Lidl Express Antwerp-Berchem",
    lat: 51.2379,
    lng: 4.4015,
    score: 3.6,
    status: "warning",
    type: "Lidl Express",
    address: "Antwerp, Berchem",
  },
  {
    id: 1271,
    name: "Lidl Barcelona-Sant Andreu",
    lat: 41.381,
    lng: 2.1617,
    score: 2.7,
    status: "danger",
    type: "Lidl",
    address: "Barcelona, Sant Andreu",
  },
  {
    id: 1272,
    name: "Lidl Express Bilbao-Ibaiondo",
    lat: 43.2574,
    lng: -2.9545,
    score: 4.3,
    status: "success",
    type: "Lidl Express",
    address: "Bilbao, Ibaiondo",
  },
  {
    id: 1273,
    name: "Lidl Express Plovdiv-Smirnenski",
    lat: 42.144,
    lng: 24.7353,
    score: 4.1,
    status: "warning",
    type: "Lidl Express",
    address: "Plovdiv, Smirnenski",
  },
  {
    id: 1274,
    name: "Lidl Express Zagreb-Donji Grad",
    lat: 45.8216,
    lng: 15.9962,
    score: 5,
    status: "success",
    type: "Lidl Express",
    address: "Zagreb, Donji Grad",
  },
  {
    id: 1275,
    name: "Lidl XL Haarlem-Noord",
    lat: 52.3889,
    lng: 4.6227,
    score: 2.8,
    status: "danger",
    type: "Lidl XL",
    address: "Haarlem, Noord",
  },
  {
    id: 1276,
    name: "Lidl Express Brussels-Anderlecht",
    lat: 50.8552,
    lng: 4.3732,
    score: 4.3,
    status: "success",
    type: "Lidl Express",
    address: "Brussels, Anderlecht",
  },
  {
    id: 1277,
    name: "Lidl Oradea-Iosia",
    lat: 47.041,
    lng: 21.9117,
    score: 3.9,
    status: "warning",
    type: "Lidl",
    address: "Oradea, Iosia",
  },
  {
    id: 1278,
    name: "Lidl XL Constanta-Tomis",
    lat: 44.1371,
    lng: 28.6239,
    score: 4.5,
    status: "success",
    type: "Lidl XL",
    address: "Constanta, Tomis",
  },
  {
    id: 1279,
    name: "Lidl Cluj-Napoca-Centru",
    lat: 46.7737,
    lng: 23.6385,
    score: 4.3,
    status: "success",
    type: "Lidl",
    address: "Cluj-Napoca, Centru",
  },
  {
    id: 1280,
    name: "Lidl Express Lisbon-Penha de França",
    lat: 38.7151,
    lng: -9.1414,
    score: 4.6,
    status: "success",
    type: "Lidl Express",
    address: "Lisbon, Penha de França",
  },
  {
    id: 1281,
    name: "Lidl Express Cardiff-Roath",
    lat: 51.4919,
    lng: -3.2034,
    score: 4.9,
    status: "success",
    type: "Lidl Express",
    address: "Cardiff, Roath",
  },
  {
    id: 1282,
    name: "Lidl Vigo-Centro",
    lat: 42.2438,
    lng: -8.7385,
    score: 3.9,
    status: "warning",
    type: "Lidl",
    address: "Vigo, Centro",
  },
  {
    id: 1283,
    name: "Lidl XL Zurich-Altstetten",
    lat: 47.3719,
    lng: 8.5447,
    score: 4.9,
    status: "success",
    type: "Lidl XL",
    address: "Zurich, Altstetten",
  },
  {
    id: 1284,
    name: "Lidl XL Milan-Bovisa",
    lat: 45.4779,
    lng: 9.1929,
    score: 4,
    status: "warning",
    type: "Lidl XL",
    address: "Milan, Bovisa",
  },
  {
    id: 1285,
    name: "Lidl Express Brighton-Seven Dials",
    lat: 50.8164,
    lng: -0.1611,
    score: 4.8,
    status: "success",
    type: "Lidl Express",
    address: "Brighton, Seven Dials",
  },
  {
    id: 1286,
    name: "Lidl Express Birmingham-Yardley",
    lat: 52.4695,
    lng: -1.9112,
    score: 3.5,
    status: "warning",
    type: "Lidl Express",
    address: "Birmingham, Yardley",
  },
  {
    id: 1287,
    name: "Lidl Charlotte-NoDa",
    lat: 35.2169,
    lng: -80.8213,
    score: 4.9,
    status: "success",
    type: "Lidl",
    address: "Charlotte, NoDa",
  },
  {
    id: 1288,
    name: "Lidl XL Warsaw-Żoliborz",
    lat: 52.2412,
    lng: 21.0173,
    score: 3.8,
    status: "warning",
    type: "Lidl XL",
    address: "Warsaw, Żoliborz",
  },
  {
    id: 1289,
    name: "Lidl Express Győr-Révfalu",
    lat: 47.6766,
    lng: 17.6746,
    score: 2.8,
    status: "danger",
    type: "Lidl Express",
    address: "Győr, Révfalu",
  },
  {
    id: 1290,
    name: "Lidl Padua-Arcella",
    lat: 45.3871,
    lng: 11.8965,
    score: 4.7,
    status: "success",
    type: "Lidl",
    address: "Padua, Arcella",
  },
  {
    id: 1291,
    name: "Lidl Bucharest-Unirii",
    lat: 44.4132,
    lng: 26.1061,
    score: 2.6,
    status: "danger",
    type: "Lidl",
    address: "Bucharest, Unirii",
  },
  {
    id: 1292,
    name: "Lidl Zaragoza-Delicias",
    lat: 41.6618,
    lng: -0.8866,
    score: 4.4,
    status: "success",
    type: "Lidl",
    address: "Zaragoza, Delicias",
  },
  {
    id: 1293,
    name: "Lidl XL Venice-San Polo",
    lat: 45.432,
    lng: 12.3086,
    score: 3.5,
    status: "warning",
    type: "Lidl XL",
    address: "Venice, San Polo",
  },
  {
    id: 1294,
    name: "Lidl Edinburgh-Stockbridge",
    lat: 55.9401,
    lng: -3.1929,
    score: 3,
    status: "danger",
    type: "Lidl",
    address: "Edinburgh, Stockbridge",
  },
  {
    id: 1295,
    name: "Lidl XL Zaragoza-Centro",
    lat: 41.6438,
    lng: -0.9118,
    score: 5,
    status: "success",
    type: "Lidl XL",
    address: "Zaragoza, Centro",
  },
  {
    id: 1296,
    name: "Lidl XL Naples-Chiaia",
    lat: 40.8447,
    lng: 14.2836,
    score: 5,
    status: "success",
    type: "Lidl XL",
    address: "Naples, Chiaia",
  },
  {
    id: 1297,
    name: "Lidl Express Liverpool-City Centre",
    lat: 53.3849,
    lng: -2.9805,
    score: 4.3,
    status: "success",
    type: "Lidl Express",
    address: "Liverpool, City Centre",
  },
  {
    id: 1298,
    name: "Lidl XL Krakow-Zwierzyniec",
    lat: 50.0444,
    lng: 19.9277,
    score: 3,
    status: "danger",
    type: "Lidl XL",
    address: "Krakow, Zwierzyniec",
  },
  {
    id: 1299,
    name: "Lidl Express Venice-Dorsoduro",
    lat: 45.4556,
    lng: 12.2956,
    score: 3.7,
    status: "warning",
    type: "Lidl Express",
    address: "Venice, Dorsoduro",
  },
  {
    id: 1300,
    name: "Lidl XL Arnhem-Presikhaaf",
    lat: 51.9842,
    lng: 5.9004,
    score: 2.8,
    status: "danger",
    type: "Lidl XL",
    address: "Arnhem, Presikhaaf",
  },
  {
    id: 1301,
    name: "Lidl XL Palermo-Albergheria",
    lat: 38.1,
    lng: 13.3425,
    score: 4.7,
    status: "success",
    type: "Lidl XL",
    address: "Palermo, Albergheria",
  },
  {
    id: 1302,
    name: "Lidl Amersfoort-Zuid",
    lat: 52.1322,
    lng: 5.3665,
    score: 3.5,
    status: "warning",
    type: "Lidl",
    address: "Amersfoort, Zuid",
  },
  {
    id: 1303,
    name: "Lidl Katowice-Brynow",
    lat: 50.2824,
    lng: 19.0034,
    score: 3.8,
    status: "warning",
    type: "Lidl",
    address: "Katowice, Brynow",
  },
  {
    id: 1304,
    name: "Lidl Usti nad Labem-Střekov",
    lat: 50.677,
    lng: 14.0141,
    score: 2.6,
    status: "danger",
    type: "Lidl",
    address: "Usti nad Labem, Střekov",
  },
  {
    id: 1305,
    name: "Lidl Express Braga-Real",
    lat: 41.5732,
    lng: -8.4062,
    score: 5,
    status: "success",
    type: "Lidl Express",
    address: "Braga, Real",
  },
  {
    id: 1306,
    name: "Lidl XL Funchal-São Gonçalo",
    lat: 32.674,
    lng: -16.9157,
    score: 3.6,
    status: "warning",
    type: "Lidl XL",
    address: "Funchal, São Gonçalo",
  },
  {
    id: 1307,
    name: "Lidl XL Liège-Grivegnée",
    lat: 50.6542,
    lng: 5.5979,
    score: 5,
    status: "success",
    type: "Lidl XL",
    address: "Liège, Grivegnée",
  },
  {
    id: 1308,
    name: "Lidl XL Lyon-7e",
    lat: 45.7647,
    lng: 4.843,
    score: 4.3,
    status: "success",
    type: "Lidl XL",
    address: "Lyon, 7e",
  },
  {
    id: 1309,
    name: "Lidl Express Split-Stobreč",
    lat: 43.5153,
    lng: 16.4368,
    score: 3.8,
    status: "warning",
    type: "Lidl Express",
    address: "Split, Stobreč",
  },
  {
    id: 1310,
    name: "Lidl Express Rijeka-Sušak",
    lat: 45.3066,
    lng: 14.4572,
    score: 3.7,
    status: "warning",
    type: "Lidl Express",
    address: "Rijeka, Sušak",
  },
  {
    id: 1311,
    name: "Lidl Express Bari-San Paolo",
    lat: 41.1268,
    lng: 16.8897,
    score: 3.9,
    status: "warning",
    type: "Lidl Express",
    address: "Bari, San Paolo",
  },
  {
    id: 1312,
    name: "Lidl Express Cork-Turners Cross",
    lat: 51.889,
    lng: -8.484,
    score: 3,
    status: "danger",
    type: "Lidl Express",
    address: "Cork, Turners Cross",
  },
  {
    id: 1313,
    name: "Lidl Express Catania-Barriera",
    lat: 37.506,
    lng: 15.0842,
    score: 5,
    status: "success",
    type: "Lidl Express",
    address: "Catania, Barriera",
  },
  {
    id: 1314,
    name: "Lidl Express Cardiff-Radyr",
    lat: 51.4965,
    lng: -3.1961,
    score: 4.2,
    status: "success",
    type: "Lidl Express",
    address: "Cardiff, Radyr",
  },
  {
    id: 1315,
    name: "Lidl Express Cluj-Napoca-Marasti",
    lat: 46.7689,
    lng: 23.6107,
    score: 4.9,
    status: "success",
    type: "Lidl Express",
    address: "Cluj-Napoca, Marasti",
  },
  {
    id: 1316,
    name: "Lidl Murcia-Santiago el Mayor",
    lat: 37.9836,
    lng: -1.129,
    score: 3.9,
    status: "warning",
    type: "Lidl",
    address: "Murcia, Santiago el Mayor",
  },
  {
    id: 1317,
    name: "Lidl XL Krakow-Stare Miasto",
    lat: 50.0731,
    lng: 19.9643,
    score: 4.6,
    status: "success",
    type: "Lidl XL",
    address: "Krakow, Stare Miasto",
  },
  {
    id: 1318,
    name: "Lidl XL Prague-Dejvice",
    lat: 50.0653,
    lng: 14.4463,
    score: 2.9,
    status: "danger",
    type: "Lidl XL",
    address: "Prague, Dejvice",
  },
  {
    id: 1319,
    name: "Lidl Zagreb-Centar",
    lat: 45.8044,
    lng: 15.9625,
    score: 4.9,
    status: "success",
    type: "Lidl",
    address: "Zagreb, Centar",
  },
  {
    id: 1320,
    name: "Lidl Turin-Aurora",
    lat: 45.0819,
    lng: 7.6763,
    score: 3.9,
    status: "warning",
    type: "Lidl",
    address: "Turin, Aurora",
  },
  {
    id: 1321,
    name: "Lidl Zaanstad-Krommenie",
    lat: 52.4935,
    lng: 4.8067,
    score: 5,
    status: "success",
    type: "Lidl",
    address: "Zaanstad, Krommenie",
  },
  {
    id: 1322,
    name: "Lidl XL Maribor-Pobrežje",
    lat: 46.5522,
    lng: 15.6493,
    score: 2.8,
    status: "danger",
    type: "Lidl XL",
    address: "Maribor, Pobrežje",
  },
  {
    id: 1323,
    name: "Lidl XL Nottingham-Lenton",
    lat: 52.9319,
    lng: -1.1699,
    score: 3.7,
    status: "warning",
    type: "Lidl XL",
    address: "Nottingham, Lenton",
  },
  {
    id: 1324,
    name: "Lidl Express Zaragoza-Las Fuentes",
    lat: 41.6443,
    lng: -0.908,
    score: 4.7,
    status: "success",
    type: "Lidl Express",
    address: "Zaragoza, Las Fuentes",
  },
  {
    id: 1325,
    name: "Lidl XL Florence-Campo di Marte",
    lat: 43.786,
    lng: 11.2321,
    score: 3,
    status: "danger",
    type: "Lidl XL",
    address: "Florence, Campo di Marte",
  },
  {
    id: 1326,
    name: "Lidl XL Toulouse-Saint-Cyprien",
    lat: 43.5924,
    lng: 1.4281,
    score: 4.6,
    status: "success",
    type: "Lidl XL",
    address: "Toulouse, Saint-Cyprien",
  },
  {
    id: 1327,
    name: "Lidl Galati-Dunarea",
    lat: 45.4199,
    lng: 27.9993,
    score: 4.7,
    status: "success",
    type: "Lidl",
    address: "Galati, Dunarea",
  },
  {
    id: 1328,
    name: "Lidl XL Innsbruck-Amras",
    lat: 47.2544,
    lng: 11.4166,
    score: 4.5,
    status: "success",
    type: "Lidl XL",
    address: "Innsbruck, Amras",
  },
  {
    id: 1329,
    name: "Lidl XL Manchester-Hulme",
    lat: 53.4616,
    lng: -2.2243,
    score: 4.7,
    status: "success",
    type: "Lidl XL",
    address: "Manchester, Hulme",
  },
  {
    id: 1330,
    name: "Lidl XL Warsaw-Praga",
    lat: 52.2062,
    lng: 21.0297,
    score: 3.5,
    status: "warning",
    type: "Lidl XL",
    address: "Warsaw, Praga",
  },
  {
    id: 1331,
    name: "Lidl XL Plovdiv-Maritsa",
    lat: 42.1173,
    lng: 24.7646,
    score: 3.8,
    status: "warning",
    type: "Lidl XL",
    address: "Plovdiv, Maritsa",
  },
  {
    id: 1332,
    name: "Lidl Express Florence-Isolotto",
    lat: 43.7889,
    lng: 11.2426,
    score: 4.1,
    status: "warning",
    type: "Lidl Express",
    address: "Florence, Isolotto",
  },
  {
    id: 1333,
    name: "Lidl Porto-Bonfim",
    lat: 41.1484,
    lng: -8.6188,
    score: 4.6,
    status: "success",
    type: "Lidl",
    address: "Porto, Bonfim",
  },
  {
    id: 1334,
    name: "Lidl Patras-Rio",
    lat: 38.2581,
    lng: 21.7113,
    score: 3.8,
    status: "warning",
    type: "Lidl",
    address: "Patras, Rio",
  },
  {
    id: 1335,
    name: "Lidl XL Trieste-Servola",
    lat: 45.6569,
    lng: 13.7652,
    score: 3.6,
    status: "warning",
    type: "Lidl XL",
    address: "Trieste, Servola",
  },
  {
    id: 1336,
    name: "Lidl XL Győr-Centrum",
    lat: 47.6725,
    lng: 17.65,
    score: 3.6,
    status: "warning",
    type: "Lidl XL",
    address: "Győr, Centrum",
  },
  {
    id: 1337,
    name: "Lidl XL Ghent-Gentbrugge",
    lat: 51.0436,
    lng: 3.7133,
    score: 4.8,
    status: "success",
    type: "Lidl XL",
    address: "Ghent, Gentbrugge",
  },
  {
    id: 1338,
    name: "Lidl Nice-Arenas",
    lat: 43.7268,
    lng: 7.2564,
    score: 3.4,
    status: "danger",
    type: "Lidl",
    address: "Nice, Arenas",
  },
  {
    id: 1339,
    name: "Lidl Express Larissa-Koulouri",
    lat: 39.6492,
    lng: 22.4019,
    score: 3.9,
    status: "warning",
    type: "Lidl Express",
    address: "Larissa, Koulouri",
  },
  {
    id: 1340,
    name: "Lidl Express Catania-Picanello",
    lat: 37.5225,
    lng: 15.0719,
    score: 3.8,
    status: "warning",
    type: "Lidl Express",
    address: "Catania, Picanello",
  },
  {
    id: 1341,
    name: "Lidl XL Palermo-La Loggia",
    lat: 38.1238,
    lng: 13.3653,
    score: 3.1,
    status: "danger",
    type: "Lidl XL",
    address: "Palermo, La Loggia",
  },
  {
    id: 1342,
    name: "Lidl XL Constanta-Mamaia",
    lat: 44.1574,
    lng: 28.6341,
    score: 2.7,
    status: "danger",
    type: "Lidl XL",
    address: "Constanta, Mamaia",
  },
  {
    id: 1343,
    name: "Lidl Charlotte-University",
    lat: 35.246,
    lng: -80.8676,
    score: 4.7,
    status: "success",
    type: "Lidl",
    address: "Charlotte, University",
  },
  {
    id: 1344,
    name: "Lidl Express Zurich-Schwamendingen",
    lat: 47.3864,
    lng: 8.5665,
    score: 4.7,
    status: "success",
    type: "Lidl Express",
    address: "Zurich, Schwamendingen",
  },
  {
    id: 1345,
    name: "Lidl Express Seville-La Cartuja",
    lat: 37.3734,
    lng: -5.9994,
    score: 3.6,
    status: "warning",
    type: "Lidl Express",
    address: "Seville, La Cartuja",
  },
  {
    id: 1346,
    name: "Lidl Salzburg-Taxham",
    lat: 47.8291,
    lng: 13.0791,
    score: 4.2,
    status: "success",
    type: "Lidl",
    address: "Salzburg, Taxham",
  },
  {
    id: 1347,
    name: "Lidl XL Geneva-Champel",
    lat: 46.2147,
    lng: 6.1187,
    score: 3.7,
    status: "warning",
    type: "Lidl XL",
    address: "Geneva, Champel",
  },
  {
    id: 1348,
    name: "Lidl XL Dijon-Sud",
    lat: 47.3377,
    lng: 5.0469,
    score: 2.7,
    status: "danger",
    type: "Lidl XL",
    address: "Dijon, Sud",
  },
  {
    id: 1349,
    name: "Lidl Paris-4e",
    lat: 48.8526,
    lng: 2.3706,
    score: 3.9,
    status: "warning",
    type: "Lidl",
    address: "Paris, 4e",
  },
  {
    id: 1350,
    name: "Lidl Murcia-Oeste",
    lat: 37.9806,
    lng: -1.1536,
    score: 4.7,
    status: "success",
    type: "Lidl",
    address: "Murcia, Oeste",
  },
  {
    id: 1351,
    name: "Lidl XL Czestochowa-Śródmieście",
    lat: 50.8168,
    lng: 19.1103,
    score: 4.7,
    status: "success",
    type: "Lidl XL",
    address: "Czestochowa, Śródmieście",
  },
  {
    id: 1352,
    name: "Lidl XL Craiova-Valea Rosie",
    lat: 44.3392,
    lng: 23.77,
    score: 4.8,
    status: "success",
    type: "Lidl XL",
    address: "Craiova, Valea Rosie",
  },
  {
    id: 1353,
    name: "Lidl XL Birmingham-Hall Green",
    lat: 52.4861,
    lng: -1.9027,
    score: 3.9,
    status: "warning",
    type: "Lidl XL",
    address: "Birmingham, Hall Green",
  },
  {
    id: 1354,
    name: "Lidl Madrid-Carabanchel",
    lat: 40.4416,
    lng: -3.7034,
    score: 4.1,
    status: "warning",
    type: "Lidl",
    address: "Madrid, Carabanchel",
  },
  {
    id: 1355,
    name: "Lidl Warsaw-Wesoła",
    lat: 52.216,
    lng: 21.0022,
    score: 3.8,
    status: "warning",
    type: "Lidl",
    address: "Warsaw, Wesoła",
  },
  {
    id: 1356,
    name: "Lidl XL Galati-Centru",
    lat: 45.4349,
    lng: 28.014,
    score: 3.7,
    status: "warning",
    type: "Lidl XL",
    address: "Galati, Centru",
  },
  {
    id: 1357,
    name: "Lidl XL Utrecht-Zuid",
    lat: 52.073,
    lng: 5.1417,
    score: 4.1,
    status: "warning",
    type: "Lidl XL",
    address: "Utrecht, Zuid",
  },
  {
    id: 1358,
    name: "Lidl XL Kranj-Stara Fužina",
    lat: 46.2437,
    lng: 14.3575,
    score: 3.7,
    status: "warning",
    type: "Lidl XL",
    address: "Kranj, Stara Fužina",
  },
  {
    id: 1359,
    name: "Lidl Express Gdansk-Śródmieście",
    lat: 54.36,
    lng: 18.6363,
    score: 2.6,
    status: "danger",
    type: "Lidl Express",
    address: "Gdansk, Śródmieście",
  },
  {
    id: 1360,
    name: "Lidl XL Lisbon-Centro",
    lat: 38.7432,
    lng: -9.1293,
    score: 4.8,
    status: "success",
    type: "Lidl XL",
    address: "Lisbon, Centro",
  },
  {
    id: 1361,
    name: "Lidl Express Mons-Centre",
    lat: 50.47,
    lng: 3.9634,
    score: 4.9,
    status: "success",
    type: "Lidl Express",
    address: "Mons, Centre",
  },
  {
    id: 1362,
    name: "Lidl XL Ostrava-Mariánské Hory",
    lat: 49.8142,
    lng: 18.2533,
    score: 3,
    status: "danger",
    type: "Lidl XL",
    address: "Ostrava, Mariánské Hory",
  },
  {
    id: 1363,
    name: "Lidl XL Gijon-Oeste",
    lat: 43.57,
    lng: -5.6859,
    score: 4.1,
    status: "warning",
    type: "Lidl XL",
    address: "Gijon, Oeste",
  },
  {
    id: 1364,
    name: "Lidl Raleigh-Five Points",
    lat: 35.802,
    lng: -78.63,
    score: 4.9,
    status: "success",
    type: "Lidl",
    address: "Raleigh, Five Points",
  },
  {
    id: 1365,
    name: "Lidl Express Prague-Praha 4",
    lat: 50.0946,
    lng: 14.4332,
    score: 3.1,
    status: "danger",
    type: "Lidl Express",
    address: "Prague, Praha 4",
  },
  {
    id: 1366,
    name: "Lidl XL Padua-Torre",
    lat: 45.3934,
    lng: 11.8763,
    score: 3.7,
    status: "warning",
    type: "Lidl XL",
    address: "Padua, Torre",
  },
  {
    id: 1367,
    name: "Lidl Setubal-Gâmbia",
    lat: 38.5471,
    lng: -8.9005,
    score: 2.8,
    status: "danger",
    type: "Lidl",
    address: "Setubal, Gâmbia",
  },
  {
    id: 1368,
    name: "Lidl XL Bydgoszcz-Szwederowo",
    lat: 53.1211,
    lng: 18.0111,
    score: 3.7,
    status: "warning",
    type: "Lidl XL",
    address: "Bydgoszcz, Szwederowo",
  },
  {
    id: 1369,
    name: "Lidl Toulon-Port",
    lat: 43.145,
    lng: 5.9203,
    score: 5,
    status: "success",
    type: "Lidl",
    address: "Toulon, Port",
  },
  {
    id: 1370,
    name: "Lidl Express Zagreb-Trnje",
    lat: 45.8371,
    lng: 15.9772,
    score: 4.4,
    status: "success",
    type: "Lidl Express",
    address: "Zagreb, Trnje",
  },
  {
    id: 1371,
    name: "Lidl Vigo-Teis",
    lat: 42.2507,
    lng: -8.7276,
    score: 4.8,
    status: "success",
    type: "Lidl",
    address: "Vigo, Teis",
  },
  {
    id: 1372,
    name: "Lidl New York-Upper West",
    lat: 40.7128,
    lng: -74.0299,
    score: 3.5,
    status: "warning",
    type: "Lidl",
    address: "New York, Upper West",
  },
  {
    id: 1373,
    name: "Lidl XL Budapest-District II",
    lat: 47.4732,
    lng: 19.0417,
    score: 3.1,
    status: "danger",
    type: "Lidl XL",
    address: "Budapest, District II",
  },
  {
    id: 1374,
    name: "Lidl Express Haarlem-Centrum",
    lat: 52.3945,
    lng: 4.6362,
    score: 4.7,
    status: "success",
    type: "Lidl Express",
    address: "Haarlem, Centrum",
  },
  {
    id: 1375,
    name: "Lidl Express London-Westminster",
    lat: 51.5149,
    lng: -0.1321,
    score: 4.4,
    status: "success",
    type: "Lidl Express",
    address: "London, Westminster",
  },
  {
    id: 1376,
    name: "Lidl Timisoara-Centru",
    lat: 45.7577,
    lng: 21.2107,
    score: 4.2,
    status: "warning",
    type: "Lidl",
    address: "Timisoara, Centru",
  },
  {
    id: 1377,
    name: "Lidl Malaga-Centro",
    lat: 36.7171,
    lng: -4.4078,
    score: 4.1,
    status: "warning",
    type: "Lidl",
    address: "Malaga, Centro",
  },
  {
    id: 1378,
    name: "Lidl Nantes-Hauts-Pavés",
    lat: 47.2109,
    lng: -1.5655,
    score: 4.5,
    status: "success",
    type: "Lidl",
    address: "Nantes, Hauts-Pavés",
  },
  {
    id: 1379,
    name: "Lidl Express Marseille-15e",
    lat: 43.2797,
    lng: 5.3813,
    score: 3.7,
    status: "warning",
    type: "Lidl Express",
    address: "Marseille, 15e",
  },
  {
    id: 1380,
    name: "Lidl XL Verona-Borgo Venezia",
    lat: 45.4196,
    lng: 11.0001,
    score: 2.7,
    status: "danger",
    type: "Lidl XL",
    address: "Verona, Borgo Venezia",
  },
  {
    id: 1381,
    name: "Lidl Charlotte-Uptown",
    lat: 35.2335,
    lng: -80.8675,
    score: 2.7,
    status: "danger",
    type: "Lidl",
    address: "Charlotte, Uptown",
  },
  {
    id: 1382,
    name: "Lidl XL Zurich-Wiedikon",
    lat: 47.4016,
    lng: 8.5205,
    score: 4.1,
    status: "warning",
    type: "Lidl XL",
    address: "Zurich, Wiedikon",
  },
  {
    id: 1383,
    name: "Lidl XL Maribor-Tezno",
    lat: 46.5499,
    lng: 15.6453,
    score: 4.7,
    status: "success",
    type: "Lidl XL",
    address: "Maribor, Tezno",
  },
  {
    id: 1384,
    name: "Lidl Express Paris-10e",
    lat: 48.8763,
    lng: 2.3685,
    score: 4.1,
    status: "warning",
    type: "Lidl Express",
    address: "Paris, 10e",
  },
  {
    id: 1385,
    name: "Lidl XL Madrid-Chamartín",
    lat: 40.397,
    lng: -3.7286,
    score: 3.9,
    status: "warning",
    type: "Lidl XL",
    address: "Madrid, Chamartín",
  },
  {
    id: 1386,
    name: "Lidl Madrid-Arganzuela",
    lat: 40.4261,
    lng: -3.7014,
    score: 3.6,
    status: "warning",
    type: "Lidl",
    address: "Madrid, Arganzuela",
  },
  {
    id: 1387,
    name: "Lidl XL Ostrava-Poruba",
    lat: 49.8063,
    lng: 18.283,
    score: 3.8,
    status: "warning",
    type: "Lidl XL",
    address: "Ostrava, Poruba",
  },
  {
    id: 1388,
    name: "Lidl XL Ostrava-Moravská Ostrava",
    lat: 49.8121,
    lng: 18.2837,
    score: 4,
    status: "warning",
    type: "Lidl XL",
    address: "Ostrava, Moravská Ostrava",
  },
  {
    id: 1389,
    name: "Lidl Bristol-Easton",
    lat: 51.4497,
    lng: -2.6026,
    score: 3.5,
    status: "warning",
    type: "Lidl",
    address: "Bristol, Easton",
  },
  {
    id: 1390,
    name: "Lidl XL Timisoara-Lipovei",
    lat: 45.7731,
    lng: 21.2001,
    score: 2.9,
    status: "danger",
    type: "Lidl XL",
    address: "Timisoara, Lipovei",
  },
  {
    id: 1391,
    name: "Lidl Express Ploiesti-Sud",
    lat: 44.9276,
    lng: 26.0106,
    score: 3.8,
    status: "warning",
    type: "Lidl Express",
    address: "Ploiesti, Sud",
  },
  {
    id: 1392,
    name: "Lidl XL Utrecht-Noord",
    lat: 52.0675,
    lng: 5.1158,
    score: 3.1,
    status: "danger",
    type: "Lidl XL",
    address: "Utrecht, Noord",
  },
  {
    id: 1393,
    name: "Lidl Vienna-Mariahilf",
    lat: 48.1995,
    lng: 16.3556,
    score: 3.5,
    status: "warning",
    type: "Lidl",
    address: "Vienna, Mariahilf",
  },
  {
    id: 1394,
    name: "Lidl Leicester-City Centre",
    lat: 52.6176,
    lng: -1.1409,
    score: 2.6,
    status: "danger",
    type: "Lidl",
    address: "Leicester, City Centre",
  },
  {
    id: 1395,
    name: "Lidl Express Bucharest-Centru",
    lat: 44.4089,
    lng: 26.1075,
    score: 4.6,
    status: "success",
    type: "Lidl Express",
    address: "Bucharest, Centru",
  },
  {
    id: 1396,
    name: "Lidl Tilburg-Noord",
    lat: 51.5527,
    lng: 5.0672,
    score: 4.9,
    status: "success",
    type: "Lidl",
    address: "Tilburg, Noord",
  },
  {
    id: 1397,
    name: "Lidl Paris-3e",
    lat: 48.8422,
    lng: 2.3369,
    score: 4,
    status: "warning",
    type: "Lidl",
    address: "Paris, 3e",
  },
  {
    id: 1398,
    name: "Lidl XL Galway-Ballybrit",
    lat: 53.2494,
    lng: -9.0633,
    score: 3.8,
    status: "warning",
    type: "Lidl XL",
    address: "Galway, Ballybrit",
  },
  {
    id: 1399,
    name: "Lidl Rome-Monte Sacro",
    lat: 41.88,
    lng: 12.4983,
    score: 4.6,
    status: "success",
    type: "Lidl",
    address: "Rome, Monte Sacro",
  },
  {
    id: 1400,
    name: "Lidl Express Montpellier-Antigone",
    lat: 43.6046,
    lng: 3.8925,
    score: 4.7,
    status: "success",
    type: "Lidl Express",
    address: "Montpellier, Antigone",
  },
  {
    id: 1401,
    name: "Lidl XL Greenville-Travelers Rest",
    lat: 34.8553,
    lng: -82.4175,
    score: 3.5,
    status: "warning",
    type: "Lidl XL",
    address: "Greenville, Travelers Rest",
  },
  {
    id: 1402,
    name: "Lidl XL Manchester-Chorlton",
    lat: 53.4878,
    lng: -2.2496,
    score: 3.6,
    status: "warning",
    type: "Lidl XL",
    address: "Manchester, Chorlton",
  },
  {
    id: 1403,
    name: "Lidl XL Heraklion-Kastelli",
    lat: 35.3198,
    lng: 25.1204,
    score: 4.2,
    status: "success",
    type: "Lidl XL",
    address: "Heraklion, Kastelli",
  },
  {
    id: 1404,
    name: "Lidl Express Padua-Centro",
    lat: 45.4166,
    lng: 11.8854,
    score: 2.7,
    status: "danger",
    type: "Lidl Express",
    address: "Padua, Centro",
  },
  {
    id: 1405,
    name: "Lidl Express Patras-Proastiakos",
    lat: 38.2497,
    lng: 21.7153,
    score: 3.5,
    status: "warning",
    type: "Lidl Express",
    address: "Patras, Proastiakos",
  },
  {
    id: 1406,
    name: "Lidl Express Arnhem-Oost",
    lat: 51.9875,
    lng: 5.8995,
    score: 2.8,
    status: "danger",
    type: "Lidl Express",
    address: "Arnhem, Oost",
  },
  {
    id: 1407,
    name: "Lidl Olomouc-Chválkovice",
    lat: 49.6081,
    lng: 17.2528,
    score: 4.2,
    status: "warning",
    type: "Lidl",
    address: "Olomouc, Chválkovice",
  },
  {
    id: 1408,
    name: "Lidl Express Leicester-Clarendon Park",
    lat: 52.6578,
    lng: -1.1439,
    score: 3.6,
    status: "warning",
    type: "Lidl Express",
    address: "Leicester, Clarendon Park",
  },
  {
    id: 1409,
    name: "Lidl XL Split-Solin",
    lat: 43.5126,
    lng: 16.4156,
    score: 4.5,
    status: "success",
    type: "Lidl XL",
    address: "Split, Solin",
  },
  {
    id: 1410,
    name: "Lidl XL Valencia-Ciutat Vella",
    lat: 39.4682,
    lng: -0.3826,
    score: 2.7,
    status: "danger",
    type: "Lidl XL",
    address: "Valencia, Ciutat Vella",
  },
  {
    id: 1411,
    name: "Lidl Express Paris-1er",
    lat: 48.8797,
    lng: 2.3471,
    score: 3.7,
    status: "warning",
    type: "Lidl Express",
    address: "Paris, 1er",
  },
  {
    id: 1412,
    name: "Lidl XL Timisoara-Giroc",
    lat: 45.7358,
    lng: 21.185,
    score: 4.4,
    status: "success",
    type: "Lidl XL",
    address: "Timisoara, Giroc",
  },
  {
    id: 1413,
    name: "Lidl XL Zagreb-Dubrava",
    lat: 45.7966,
    lng: 15.9749,
    score: 3.4,
    status: "warning",
    type: "Lidl XL",
    address: "Zagreb, Dubrava",
  },
  {
    id: 1414,
    name: "Lidl Lisbon-Avenidas Novas",
    lat: 38.7344,
    lng: -9.158,
    score: 3.5,
    status: "warning",
    type: "Lidl",
    address: "Lisbon, Avenidas Novas",
  },
  {
    id: 1415,
    name: "Lidl XL Lucerne-Littau",
    lat: 47.0497,
    lng: 8.2858,
    score: 4.1,
    status: "warning",
    type: "Lidl XL",
    address: "Lucerne, Littau",
  },
  {
    id: 1416,
    name: "Lidl Valladolid-Oeste",
    lat: 41.6299,
    lng: -4.7203,
    score: 4.8,
    status: "success",
    type: "Lidl",
    address: "Valladolid, Oeste",
  },
  {
    id: 1417,
    name: "Lidl XL Bilbao-Otxarkoaga",
    lat: 43.2474,
    lng: -2.9184,
    score: 4.9,
    status: "success",
    type: "Lidl XL",
    address: "Bilbao, Otxarkoaga",
  },
  {
    id: 1418,
    name: "Lidl XL Waterford-Ferrybank",
    lat: 52.2805,
    lng: -7.0882,
    score: 4.2,
    status: "warning",
    type: "Lidl XL",
    address: "Waterford, Ferrybank",
  },
  {
    id: 1419,
    name: "Lidl Valladolid-Sur",
    lat: 41.6416,
    lng: -4.7171,
    score: 3.6,
    status: "warning",
    type: "Lidl",
    address: "Valladolid, Sur",
  },
  {
    id: 1420,
    name: "Lidl Express Lyon-4e",
    lat: 45.7641,
    lng: 4.8599,
    score: 3.7,
    status: "warning",
    type: "Lidl Express",
    address: "Lyon, 4e",
  },
  {
    id: 1421,
    name: "Lidl XL Bordeaux-Centre",
    lat: 44.83,
    lng: -0.5662,
    score: 4.9,
    status: "success",
    type: "Lidl XL",
    address: "Bordeaux, Centre",
  },
  {
    id: 1422,
    name: "Lidl Express Cork-Ballintemple",
    lat: 51.9028,
    lng: -8.4566,
    score: 3.9,
    status: "warning",
    type: "Lidl Express",
    address: "Cork, Ballintemple",
  },
  {
    id: 1423,
    name: "Lidl XL Ruse-Druzhba",
    lat: 43.8263,
    lng: 25.9853,
    score: 4.1,
    status: "warning",
    type: "Lidl XL",
    address: "Ruse, Druzhba",
  },
  {
    id: 1424,
    name: "Lidl XL Rotterdam-Hillegersberg",
    lat: 51.9249,
    lng: 4.4638,
    score: 3.9,
    status: "warning",
    type: "Lidl XL",
    address: "Rotterdam, Hillegersberg",
  },
  {
    id: 1425,
    name: "Lidl Nice-Liberation",
    lat: 43.7314,
    lng: 7.2831,
    score: 4.3,
    status: "success",
    type: "Lidl",
    address: "Nice, Liberation",
  },
  {
    id: 1426,
    name: "Lidl Express Oradea-Nufarul",
    lat: 47.0314,
    lng: 21.9034,
    score: 4.5,
    status: "success",
    type: "Lidl Express",
    address: "Oradea, Nufarul",
  },
  {
    id: 1427,
    name: "Lidl Venice-Cannaregio",
    lat: 45.4639,
    lng: 12.3202,
    score: 4.9,
    status: "success",
    type: "Lidl",
    address: "Venice, Cannaregio",
  },
  {
    id: 1428,
    name: "Lidl Express Larissa-Terpsithea",
    lat: 39.6539,
    lng: 22.415,
    score: 3.8,
    status: "warning",
    type: "Lidl Express",
    address: "Larissa, Terpsithea",
  },
  {
    id: 1429,
    name: "Lidl Express Madrid-Retiro",
    lat: 40.3951,
    lng: -3.7098,
    score: 4.9,
    status: "success",
    type: "Lidl Express",
    address: "Madrid, Retiro",
  },
  {
    id: 1430,
    name: "Lidl XL Montpellier-Mosson",
    lat: 43.5984,
    lng: 3.8546,
    score: 4.2,
    status: "success",
    type: "Lidl XL",
    address: "Montpellier, Mosson",
  },
  {
    id: 1431,
    name: "Lidl XL Grenoble-Centre",
    lat: 45.2028,
    lng: 5.7118,
    score: 4.7,
    status: "success",
    type: "Lidl XL",
    address: "Grenoble, Centre",
  },
  {
    id: 1432,
    name: "Lidl Express Iasi-Tatarasi",
    lat: 47.1626,
    lng: 27.5983,
    score: 4.2,
    status: "success",
    type: "Lidl Express",
    address: "Iasi, Tatarasi",
  },
  {
    id: 1433,
    name: "Lidl XL Iasi-Nicolina",
    lat: 47.1462,
    lng: 27.6001,
    score: 2.6,
    status: "danger",
    type: "Lidl XL",
    address: "Iasi, Nicolina",
  },
  {
    id: 1434,
    name: "Lidl Villeurbanne-Cusset",
    lat: 45.7814,
    lng: 4.8634,
    score: 2.6,
    status: "danger",
    type: "Lidl",
    address: "Villeurbanne, Cusset",
  },
  {
    id: 1435,
    name: "Lidl Budapest-District I",
    lat: 47.5009,
    lng: 19.0552,
    score: 4.6,
    status: "success",
    type: "Lidl",
    address: "Budapest, District I",
  },
  {
    id: 1436,
    name: "Lidl Barcelona-Eixample",
    lat: 41.4068,
    lng: 2.1857,
    score: 3.7,
    status: "warning",
    type: "Lidl",
    address: "Barcelona, Eixample",
  },
  {
    id: 1437,
    name: "Lidl Bern-Wankdorf",
    lat: 46.9248,
    lng: 7.4394,
    score: 4.1,
    status: "warning",
    type: "Lidl",
    address: "Bern, Wankdorf",
  },
  {
    id: 1438,
    name: "Lidl Plovdiv-Centar",
    lat: 42.1128,
    lng: 24.7398,
    score: 2.8,
    status: "danger",
    type: "Lidl",
    address: "Plovdiv, Centar",
  },
  {
    id: 1439,
    name: "Lidl Malaga-Cruz de Humilladero",
    lat: 36.6975,
    lng: -4.4086,
    score: 3.9,
    status: "warning",
    type: "Lidl",
    address: "Malaga, Cruz de Humilladero",
  },
  {
    id: 1440,
    name: "Lidl Express Madrid-Tetuan",
    lat: 40.4063,
    lng: -3.7023,
    score: 4.9,
    status: "success",
    type: "Lidl Express",
    address: "Madrid, Tetuan",
  },
  {
    id: 1441,
    name: "Lidl XL Radom-Kozia Górka",
    lat: 51.4178,
    lng: 21.1523,
    score: 3.9,
    status: "warning",
    type: "Lidl XL",
    address: "Radom, Kozia Górka",
  },
  {
    id: 1442,
    name: "Lidl XL Rome-Centro",
    lat: 41.881,
    lng: 12.4947,
    score: 4.7,
    status: "success",
    type: "Lidl XL",
    address: "Rome, Centro",
  },
  {
    id: 1443,
    name: "Lidl Express Bristol-Bedminster",
    lat: 51.4359,
    lng: -2.6023,
    score: 3.3,
    status: "danger",
    type: "Lidl Express",
    address: "Bristol, Bedminster",
  },
  {
    id: 1444,
    name: "Lidl Express Aveiro-Centro",
    lat: 40.6657,
    lng: -8.6475,
    score: 3.8,
    status: "warning",
    type: "Lidl Express",
    address: "Aveiro, Centro",
  },
  {
    id: 1445,
    name: "Lidl Coimbra-Santa Cruz",
    lat: 40.2227,
    lng: -8.4193,
    score: 4.6,
    status: "success",
    type: "Lidl",
    address: "Coimbra, Santa Cruz",
  },
  {
    id: 1446,
    name: "Lidl Gdynia-Witomino",
    lat: 54.4999,
    lng: 18.5526,
    score: 4.4,
    status: "success",
    type: "Lidl",
    address: "Gdynia, Witomino",
  },
  {
    id: 1447,
    name: "Lidl XL Białystok-Dojlidy",
    lat: 53.1217,
    lng: 23.1644,
    score: 3.4,
    status: "warning",
    type: "Lidl XL",
    address: "Białystok, Dojlidy",
  },
  {
    id: 1448,
    name: "Lidl Naples-Fuorigrotta",
    lat: 40.8742,
    lng: 14.258,
    score: 4.5,
    status: "success",
    type: "Lidl",
    address: "Naples, Fuorigrotta",
  },
  {
    id: 1449,
    name: "Lidl XL Budapest-District III",
    lat: 47.499,
    lng: 19.0189,
    score: 4.4,
    status: "success",
    type: "Lidl XL",
    address: "Budapest, District III",
  },
  {
    id: 1450,
    name: "Lidl Express Southampton-Shirley",
    lat: 50.9009,
    lng: -1.4034,
    score: 3.5,
    status: "warning",
    type: "Lidl Express",
    address: "Southampton, Shirley",
  },
  {
    id: 1451,
    name: "Lidl Barcelona-Horta-Guinardó",
    lat: 41.3656,
    lng: 2.1498,
    score: 4.7,
    status: "success",
    type: "Lidl",
    address: "Barcelona, Horta-Guinardó",
  },
  {
    id: 1452,
    name: "Lidl Vigo-Cabral",
    lat: 42.2337,
    lng: -8.7212,
    score: 2.9,
    status: "danger",
    type: "Lidl",
    address: "Vigo, Cabral",
  },
  {
    id: 1453,
    name: "Lidl Express Kranj-Kokrica",
    lat: 46.2398,
    lng: 14.3454,
    score: 4.9,
    status: "success",
    type: "Lidl Express",
    address: "Kranj, Kokrica",
  },
  {
    id: 1454,
    name: "Lidl XL Rijeka-Trsat",
    lat: 45.321,
    lng: 14.4433,
    score: 2.9,
    status: "danger",
    type: "Lidl XL",
    address: "Rijeka, Trsat",
  },
  {
    id: 1455,
    name: "Lidl XL Birmingham-Digbeth",
    lat: 52.4854,
    lng: -1.9075,
    score: 4.1,
    status: "warning",
    type: "Lidl XL",
    address: "Birmingham, Digbeth",
  },
  {
    id: 1456,
    name: "Lidl Express Innsbruck-Wilten",
    lat: 47.251,
    lng: 11.4241,
    score: 4.6,
    status: "success",
    type: "Lidl Express",
    address: "Innsbruck, Wilten",
  },
  {
    id: 1457,
    name: "Lidl XL Toulouse-Rangueil",
    lat: 43.6133,
    lng: 1.4283,
    score: 5,
    status: "success",
    type: "Lidl XL",
    address: "Toulouse, Rangueil",
  },
  {
    id: 1458,
    name: "Lidl Zadar-Puntamika",
    lat: 44.1004,
    lng: 15.255,
    score: 2.7,
    status: "danger",
    type: "Lidl",
    address: "Zadar, Puntamika",
  },
  {
    id: 1459,
    name: "Lidl Malaga-Carretera de Cádiz",
    lat: 36.7065,
    lng: -4.4243,
    score: 4.6,
    status: "success",
    type: "Lidl",
    address: "Malaga, Carretera de Cádiz",
  },
  {
    id: 1460,
    name: "Lidl Lausanne-Centre",
    lat: 46.5178,
    lng: 6.6424,
    score: 3.9,
    status: "warning",
    type: "Lidl",
    address: "Lausanne, Centre",
  },
  {
    id: 1461,
    name: "Lidl Usti nad Labem-Neštěmice",
    lat: 50.6685,
    lng: 14.0553,
    score: 4.2,
    status: "success",
    type: "Lidl",
    address: "Usti nad Labem, Neštěmice",
  },
  {
    id: 1462,
    name: "Lidl Express Iasi-Centru",
    lat: 47.1765,
    lng: 27.5886,
    score: 4.1,
    status: "warning",
    type: "Lidl Express",
    address: "Iasi, Centru",
  },
  {
    id: 1463,
    name: "Lidl Arnhem-Centrum",
    lat: 52.0074,
    lng: 5.9013,
    score: 2.7,
    status: "danger",
    type: "Lidl",
    address: "Arnhem, Centrum",
  },
  {
    id: 1464,
    name: "Lidl Lisbon-Arroios",
    lat: 38.7462,
    lng: -9.1433,
    score: 4.4,
    status: "success",
    type: "Lidl",
    address: "Lisbon, Arroios",
  },
  {
    id: 1465,
    name: "Lidl Milan-Romolo",
    lat: 45.4508,
    lng: 9.2001,
    score: 4.5,
    status: "success",
    type: "Lidl",
    address: "Milan, Romolo",
  },
  {
    id: 1466,
    name: "Lidl Rennes-Nord",
    lat: 48.1308,
    lng: -1.6897,
    score: 4,
    status: "warning",
    type: "Lidl",
    address: "Rennes, Nord",
  },
  {
    id: 1467,
    name: "Lidl Express Groningen-West",
    lat: 53.2217,
    lng: 6.5614,
    score: 3.6,
    status: "warning",
    type: "Lidl Express",
    address: "Groningen, West",
  },
  {
    id: 1468,
    name: "Lidl Cordoba-Poniente",
    lat: 37.884,
    lng: -4.7748,
    score: 3.8,
    status: "warning",
    type: "Lidl",
    address: "Cordoba, Poniente",
  },
  {
    id: 1469,
    name: "Lidl Express Pardubice-Centrum",
    lat: 50.0158,
    lng: 15.7994,
    score: 4.9,
    status: "success",
    type: "Lidl Express",
    address: "Pardubice, Centrum",
  },
  {
    id: 1470,
    name: "Lidl Malaga-Ciudad Jardín",
    lat: 36.7277,
    lng: -4.4298,
    score: 3.1,
    status: "danger",
    type: "Lidl",
    address: "Malaga, Ciudad Jardín",
  },
  {
    id: 1471,
    name: "Lidl XL Bern-Innere Stadt",
    lat: 46.9643,
    lng: 7.4479,
    score: 3,
    status: "danger",
    type: "Lidl XL",
    address: "Bern, Innere Stadt",
  },
  {
    id: 1472,
    name: "Lidl XL Charleroi-Gilly",
    lat: 50.4318,
    lng: 4.4596,
    score: 2.8,
    status: "danger",
    type: "Lidl XL",
    address: "Charleroi, Gilly",
  },
  {
    id: 1473,
    name: "Lidl XL Aveiro-Glória",
    lat: 40.6189,
    lng: -8.6395,
    score: 4.3,
    status: "success",
    type: "Lidl XL",
    address: "Aveiro, Glória",
  },
  {
    id: 1474,
    name: "Lidl Dundalk-Centre",
    lat: 53.9895,
    lng: -6.4006,
    score: 4.9,
    status: "success",
    type: "Lidl",
    address: "Dundalk, Centre",
  },
  {
    id: 1475,
    name: "Lidl XL Florence-Centro",
    lat: 43.7466,
    lng: 11.2579,
    score: 4.7,
    status: "success",
    type: "Lidl XL",
    address: "Florence, Centro",
  },
  {
    id: 1476,
    name: "Lidl Express Granada-Ronda",
    lat: 37.1722,
    lng: -3.6171,
    score: 3.7,
    status: "warning",
    type: "Lidl Express",
    address: "Granada, Ronda",
  },
  {
    id: 1477,
    name: "Lidl XL Murcia-Norte",
    lat: 37.996,
    lng: -1.1249,
    score: 4,
    status: "warning",
    type: "Lidl XL",
    address: "Murcia, Norte",
  },
  {
    id: 1478,
    name: "Lidl Alicante-Centro",
    lat: 38.3416,
    lng: -0.4606,
    score: 3.1,
    status: "danger",
    type: "Lidl",
    address: "Alicante, Centro",
  },
  {
    id: 1479,
    name: "Lidl XL Rotterdam-Centrum",
    lat: 51.8996,
    lng: 4.4937,
    score: 4.9,
    status: "success",
    type: "Lidl XL",
    address: "Rotterdam, Centrum",
  },
  {
    id: 1480,
    name: "Lidl Express Bern-Breitenrain",
    lat: 46.9639,
    lng: 7.4268,
    score: 3.6,
    status: "warning",
    type: "Lidl Express",
    address: "Bern, Breitenrain",
  },
  {
    id: 1481,
    name: "Lidl Almere-Noord",
    lat: 52.3478,
    lng: 5.2846,
    score: 4.6,
    status: "success",
    type: "Lidl",
    address: "Almere, Noord",
  },
  {
    id: 1482,
    name: "Lidl Trieste-San Giacomo",
    lat: 45.639,
    lng: 13.7554,
    score: 4.1,
    status: "warning",
    type: "Lidl",
    address: "Trieste, San Giacomo",
  },
  {
    id: 1483,
    name: "Lidl XL New York-Upper East",
    lat: 40.7271,
    lng: -74.0225,
    score: 4.7,
    status: "success",
    type: "Lidl XL",
    address: "New York, Upper East",
  },
  {
    id: 1484,
    name: "Lidl Express Malaga-Este",
    lat: 36.6984,
    lng: -4.4024,
    score: 4,
    status: "warning",
    type: "Lidl Express",
    address: "Malaga, Este",
  },
  {
    id: 1485,
    name: "Lidl Express Aalst-Erembodegem",
    lat: 50.9161,
    lng: 4.0531,
    score: 3.5,
    status: "warning",
    type: "Lidl Express",
    address: "Aalst, Erembodegem",
  },
  {
    id: 1486,
    name: "Lidl Rennes-Villejean",
    lat: 48.0949,
    lng: -1.662,
    score: 4.9,
    status: "success",
    type: "Lidl",
    address: "Rennes, Villejean",
  },
  {
    id: 1487,
    name: "Lidl Eindhoven-Gestel",
    lat: 51.4579,
    lng: 5.4481,
    score: 4.7,
    status: "success",
    type: "Lidl",
    address: "Eindhoven, Gestel",
  },
  {
    id: 1488,
    name: "Lidl Express London-Southwark",
    lat: 51.485,
    lng: -0.1042,
    score: 4.3,
    status: "success",
    type: "Lidl Express",
    address: "London, Southwark",
  },
  {
    id: 1489,
    name: "Lidl Birmingham-Edgbaston",
    lat: 52.503,
    lng: -1.8963,
    score: 4.7,
    status: "success",
    type: "Lidl",
    address: "Birmingham, Edgbaston",
  },
  {
    id: 1490,
    name: "Lidl Express Sosnowiec-Jaworzno",
    lat: 50.2934,
    lng: 19.101,
    score: 3.9,
    status: "warning",
    type: "Lidl Express",
    address: "Sosnowiec, Jaworzno",
  },
  {
    id: 1491,
    name: "Lidl Klagenfurt-Völkermarkter Vorstadt",
    lat: 46.6476,
    lng: 14.2932,
    score: 4.1,
    status: "warning",
    type: "Lidl",
    address: "Klagenfurt, Völkermarkter Vorstadt",
  },
  {
    id: 1492,
    name: "Lidl XL Iasi-Pacurari",
    lat: 47.1624,
    lng: 27.5997,
    score: 3.6,
    status: "warning",
    type: "Lidl XL",
    address: "Iasi, Pacurari",
  },
  {
    id: 1493,
    name: "Lidl XL Leeds-Garforth",
    lat: 53.7963,
    lng: -1.5563,
    score: 3.7,
    status: "warning",
    type: "Lidl XL",
    address: "Leeds, Garforth",
  },
  {
    id: 1494,
    name: "Lidl XL Liège-Sclessin",
    lat: 50.643,
    lng: 5.6045,
    score: 3.5,
    status: "warning",
    type: "Lidl XL",
    address: "Liège, Sclessin",
  },
  {
    id: 1495,
    name: "Lidl Express Strasbourg-Neuhof",
    lat: 48.564,
    lng: 7.7288,
    score: 3,
    status: "danger",
    type: "Lidl Express",
    address: "Strasbourg, Neuhof",
  },
  {
    id: 1496,
    name: "Lidl Express Toulon-Pont du Las",
    lat: 43.1047,
    lng: 5.9352,
    score: 4.7,
    status: "success",
    type: "Lidl Express",
    address: "Toulon, Pont du Las",
  },
  {
    id: 1497,
    name: "Lidl Express Athens-Aigaleo",
    lat: 37.9646,
    lng: 23.7335,
    score: 4,
    status: "warning",
    type: "Lidl Express",
    address: "Athens, Aigaleo",
  },
  {
    id: 1498,
    name: "Lidl Express Gdansk-Chełm",
    lat: 54.3546,
    lng: 18.6594,
    score: 4.2,
    status: "warning",
    type: "Lidl Express",
    address: "Gdansk, Chełm",
  },
  {
    id: 1499,
    name: "Lidl Prague-Praha 9",
    lat: 50.0745,
    lng: 14.4392,
    score: 2.9,
    status: "danger",
    type: "Lidl",
    address: "Prague, Praha 9",
  },
  {
    id: 1500,
    name: "Lidl Lille-Centre",
    lat: 50.6216,
    lng: 3.0381,
    score: 3.7,
    status: "warning",
    type: "Lidl",
    address: "Lille, Centre",
  },
  {
    id: 1501,
    name: "Lidl Express Thessaloniki-Evosmos",
    lat: 40.6535,
    lng: 22.9354,
    score: 3.2,
    status: "danger",
    type: "Lidl Express",
    address: "Thessaloniki, Evosmos",
  },
  {
    id: 1502,
    name: "Lidl XL Le Mans-Sud",
    lat: 48.0193,
    lng: 0.2021,
    score: 3.8,
    status: "warning",
    type: "Lidl XL",
    address: "Le Mans, Sud",
  },
  {
    id: 1503,
    name: "Lidl Aalst-Centrum",
    lat: 50.961,
    lng: 4.0463,
    score: 4.7,
    status: "success",
    type: "Lidl",
    address: "Aalst, Centrum",
  },
  {
    id: 1504,
    name: "Lidl Almada-Laranjeiro",
    lat: 38.6922,
    lng: -9.1374,
    score: 4.5,
    status: "success",
    type: "Lidl",
    address: "Almada, Laranjeiro",
  },
  {
    id: 1505,
    name: "Lidl Craiova-Sfânta Maria",
    lat: 44.3454,
    lng: 23.7974,
    score: 4.8,
    status: "success",
    type: "Lidl",
    address: "Craiova, Sfânta Maria",
  },
  {
    id: 1506,
    name: "Lidl XL Valladolid-Centro",
    lat: 41.6512,
    lng: -4.7226,
    score: 3.7,
    status: "warning",
    type: "Lidl XL",
    address: "Valladolid, Centro",
  },
  {
    id: 1507,
    name: "Lidl Krakow-Nowa Huta",
    lat: 50.0783,
    lng: 19.9412,
    score: 5,
    status: "success",
    type: "Lidl",
    address: "Krakow, Nowa Huta",
  },
  {
    id: 1508,
    name: "Lidl Almada-Feijó",
    lat: 38.6704,
    lng: -9.1445,
    score: 3,
    status: "danger",
    type: "Lidl",
    address: "Almada, Feijó",
  },
  {
    id: 1509,
    name: "Lidl Express Verona-Veronetta",
    lat: 45.4341,
    lng: 10.9812,
    score: 3.2,
    status: "danger",
    type: "Lidl Express",
    address: "Verona, Veronetta",
  },
  {
    id: 1510,
    name: "Lidl Express London-Hackney",
    lat: 51.5024,
    lng: -0.1478,
    score: 3.9,
    status: "warning",
    type: "Lidl Express",
    address: "London, Hackney",
  },
  {
    id: 1511,
    name: "Lidl Nîmes-Chemin-Bas",
    lat: 43.8359,
    lng: 4.3577,
    score: 3.7,
    status: "warning",
    type: "Lidl",
    address: "Nîmes, Chemin-Bas",
  },
  {
    id: 1512,
    name: "Lidl XL Budapest-District V",
    lat: 47.4831,
    lng: 19.0218,
    score: 4.4,
    status: "success",
    type: "Lidl XL",
    address: "Budapest, District V",
  },
];


export default stores
